
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("MNfxH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c969d4155b4e137a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e9YVH = parcelRequire("e9YVH");

var $lw2HC = parcelRequire("lw2HC");

var $ghVG7 = parcelRequire("ghVG7");

var $g26cY = parcelRequire("g26cY");

var $esWw1 = parcelRequire("esWw1");

var $kGNe4 = parcelRequire("kGNe4");

var $2Lj35 = parcelRequire("2Lj35");

var $2riGj = parcelRequire("2riGj");

var $4dRjY = parcelRequire("4dRjY");

var $90yGq = parcelRequire("90yGq");

var $imS60 = parcelRequire("imS60");
const $c969d4155b4e137a$var$renderKnowledgeHubPageWithCorrectBreadcrumbs = (match, accountId, spaceKey)=>{
    if (match && match.params && match.params.categoryId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "knowledge-hub-category-view-article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kGNe4.default), {
        id: (0, $2Lj35.toCategoryGuid)(match.params.categoryId || '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $esWw1.default), {
        id: match.params.articleId,
        accountId: accountId,
        spaceKey: spaceKey
    })));
    if (match && match.url && match.url.includes('search')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "knowledge-hub-search-view-article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g26cY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $esWw1.default), {
        id: match && match.params && match.params.articleId,
        accountId: accountId,
        spaceKey: spaceKey
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "knowledge-hub-browse-view-article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $esWw1.default), {
        id: match && match.params && match.params.articleId,
        accountId: accountId,
        spaceKey: spaceKey
    }));
};
const $c969d4155b4e137a$var$View = ()=>{
    const [, { resetDraftArticleData: resetDraftArticleData }] = (0, $lw2HC.useArticleId)();
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(// We don't want to reset deleted because this flag should show up in browse-all-articles component
    ()=>()=>{
            resetDraftArticleData(false);
        }, [
        resetDraftArticleData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2riGj.KnowledgeHubAppBase), {
        appName: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE
    }, ({ match: match, query: query })=>{
        const spaceKey = query ? query.spaceKey || query.spacekey : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghVG7.default), null, $c969d4155b4e137a$var$renderKnowledgeHubPageWithCorrectBreadcrumbs(match, accountId, spaceKey));
    }));
};
var $c969d4155b4e137a$export$2e2bcd8739ae039 = $c969d4155b4e137a$var$View;

});
parcelRegister("lw2HC", function(module, exports) {

$parcel$export(module.exports, "initialCreateCategoryData", () => $ba746da67c53f4b3$export$4947e9942a5d137c);
$parcel$export(module.exports, "KnowledgeCommonSubscriber", () => $ba746da67c53f4b3$export$d226f0c95b79366b);
$parcel$export(module.exports, "UserCapabilitiesSubscriber", () => $ba746da67c53f4b3$export$42b7b5df8c1dee52);
$parcel$export(module.exports, "useFlagData", () => $ba746da67c53f4b3$export$a9ac4a6dcb7104bf);
$parcel$export(module.exports, "useGetCategory", () => $ba746da67c53f4b3$export$3fa52226f8fff61e);
$parcel$export(module.exports, "useDraftShareId", () => $ba746da67c53f4b3$export$2602997fd4d9b312);
$parcel$export(module.exports, "useArticleId", () => $ba746da67c53f4b3$export$a5eb46485735066a);
$parcel$export(module.exports, "useIsFetchingDraftDetails", () => $ba746da67c53f4b3$export$428db75bed41f9d);
$parcel$export(module.exports, "useRedirectionData", () => $ba746da67c53f4b3$export$e30071c464cba7f9);
$parcel$export(module.exports, "useUserCapabilities", () => $ba746da67c53f4b3$export$7ae10e817e068c57);
$parcel$export(module.exports, "useIsPermittedSpaces", () => $ba746da67c53f4b3$export$60270d772f1f3c76);
$parcel$export(module.exports, "useCategoriesData", () => $ba746da67c53f4b3$export$56b47c5ebac10997);
$parcel$export(module.exports, "useCreateCategoryData", () => $ba746da67c53f4b3$export$1e7300097c003415);

var $7JoAD = parcelRequire("7JoAD");

var $kz5Uo = parcelRequire("kz5Uo");

var $cSB1I = parcelRequire("cSB1I");
const $ba746da67c53f4b3$export$61e797cf03b496e1 = {
    hasConfluenceLicense: false,
    articleUserCapabilities: {
        canCreateArticle: false
    },
    spaceUserCapabilities: {
        editableSpaces: [],
        readableSpaces: []
    }
};
const $ba746da67c53f4b3$export$4947e9942a5d137c = {
    isSubmitting: false,
    formValues: {
        name: '',
        description: ''
    },
    error: {
        formError: undefined,
        fieldErrors: undefined
    },
    createdCategory: null
};
const $ba746da67c53f4b3$export$d4c72bab9d6cc13a = {
    draftShareId: '',
    articleId: '',
    published: false,
    closed: false,
    deleted: false,
    redirectionData: {
        onPublishRedirectUrl: '',
        onCloseRedirectUrl: ''
    },
    isFetchingDraftDetails: false,
    spacesPermitted: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    permittedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    userCapabilities: {
        isLoading: false,
        error: null,
        data: {
            ...$ba746da67c53f4b3$export$61e797cf03b496e1
        }
    },
    linkedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    showConfluenceCreatePageError: false,
    categoriesData: {
        isLoading: true,
        categories: [],
        isCategoriesSupported: false,
        error: null
    },
    createCategoryData: {
        ...$ba746da67c53f4b3$export$4947e9942a5d137c
    },
    spaceKey: '',
    flags: []
};
const $ba746da67c53f4b3$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    initialState: $ba746da67c53f4b3$export$d4c72bab9d6cc13a,
    actions: $kz5Uo.actions,
    name: 'KnowledgeCommonStore'
});
const $ba746da67c53f4b3$export$d226f0c95b79366b = (0, $7JoAD.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9);
const $ba746da67c53f4b3$export$42b7b5df8c1dee52 = (0, $7JoAD.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    displayName: 'UserCapabilitiesSubscriber',
    selector: (0, $cSB1I.getUserCapabilities)
});
const $ba746da67c53f4b3$export$a3c47cea95d8bbd1 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCommonFlags)
});
const $ba746da67c53f4b3$export$a9ac4a6dcb7104bf = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getKnowledgeCommonFlags)
});
const $ba746da67c53f4b3$export$3fa52226f8fff61e = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCategory)
});
const $ba746da67c53f4b3$export$2602997fd4d9b312 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getDraftShareId)
});
const $ba746da67c53f4b3$export$a5eb46485735066a = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getArticleId)
});
const $ba746da67c53f4b3$export$428db75bed41f9d = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getIsFetchingDraftDetails)
});
const $ba746da67c53f4b3$export$e30071c464cba7f9 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getRedirectionData)
});
const $ba746da67c53f4b3$export$7ae10e817e068c57 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getUserCapabilities)
});
const $ba746da67c53f4b3$export$60270d772f1f3c76 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getPermittedSpaces)
});
const $ba746da67c53f4b3$export$40685b8df387d08 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getLinkedSpaces)
});
const $ba746da67c53f4b3$export$56b47c5ebac10997 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCategoriesData)
});
const $ba746da67c53f4b3$export$1e7300097c003415 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCreateCategoryData)
});

});
parcelRegister("kz5Uo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $78ea76781fae4c5f$export$e324594224ef24da);

var $lx7EO = parcelRequire("lx7EO");

var $heXZI = parcelRequire("heXZI");

var $dsFMC = parcelRequire("dsFMC");

var $aInVL = parcelRequire("aInVL");

var $3twc2 = parcelRequire("3twc2");

var $klUDT = parcelRequire("klUDT");

var $2tTYZ = parcelRequire("2tTYZ");

var $ik7FP = parcelRequire("ik7FP");

var $dAXEk = parcelRequire("dAXEk");

var $dIiIO = parcelRequire("dIiIO");

var $gpe3Z = parcelRequire("gpe3Z");

var $1TU0Q = parcelRequire("1TU0Q");

var $jIuZj = parcelRequire("jIuZj");

var $eP4xZ = parcelRequire("eP4xZ");

var $8QyFO = parcelRequire("8QyFO");

var $1VmcQ = parcelRequire("1VmcQ");
const $78ea76781fae4c5f$export$e324594224ef24da = {
    setRedirectionData: $1TU0Q.setRedirectionData,
    resetRedirectionData: $1TU0Q.resetRedirectionData,
    publishSuccess: $aInVL.publishSuccess,
    savedSuccess: $3twc2.savedSuccess,
    fetchDraftAndNavigateToEditor: $ik7FP.fetchDraftAndNavigateToEditor,
    navigateCreateDraftRoute: $gpe3Z.navigateCreateDraftRoute,
    fetchCreateArticlePermission: $2tTYZ.fetchCreateArticlePermission,
    fetchLinkedSpaces: $dAXEk.fetchLinkedSpaces,
    resetDraftArticleData: $8QyFO.resetDraftArticleData,
    articleDeleteSuccess: $lx7EO.articleDeleteSuccess,
    fetchUserCapabilities: $dIiIO.fetchUserCapabilities,
    fetchCategories: $klUDT.fetchCategories,
    reorderCategories: $eP4xZ.reorderCategories,
    createCategory: $heXZI.createCategory,
    handleFormInputChange: $heXZI.handleFormInputChange,
    resetCreatedCategory: $heXZI.resetCreatedCategory,
    updateCategorySuccess: $1VmcQ.updateCategorySuccess,
    deleteCategorySuccess: $dsFMC.deleteCategorySuccess,
    removeCommonFlag: $jIuZj.removeCommonFlag
};

});
parcelRegister("lx7EO", function(module, exports) {

$parcel$export(module.exports, "articleDeleteSuccess", () => $cfa855108534d4c5$export$7e6f4a244457270c);
const $cfa855108534d4c5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            deleted: true,
            articleId: articleId
        });
    };

});

parcelRegister("heXZI", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $015500bcb6a585cb$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "handleFormInputChange", () => $015500bcb6a585cb$export$8e52c4bd9075cb96);
$parcel$export(module.exports, "resetCreatedCategory", () => $015500bcb6a585cb$export$98485bfbe8c8269a);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $fPjip = parcelRequire("fPjip");


var $j8qrr = parcelRequire("j8qrr");

var $lw2HC = parcelRequire("lw2HC");
const $015500bcb6a585cb$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const { formValues: formValues } = {
            ...getState().createCategoryData
        };
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                isSubmitting: true
            }
        });
        try {
            const category = await (0, $j8qrr.createCategory)(projectId, formValues, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories,
                        category
                    ]
                },
                createCategoryData: {
                    ...(0, $lw2HC.initialCreateCategoryData),
                    createdCategory: category
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const { fieldErrors: fieldErrors, formError: formError } = (0, $fPjip.toErrors)(error);
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: false,
                    error: {
                        formError: formError,
                        fieldErrors: fieldErrors
                    }
                }
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'categoryCreate',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };
const $015500bcb6a585cb$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                formValues: {
                    ...getState().createCategoryData.formValues,
                    [field]: value
                }
            }
        });
    };
const $015500bcb6a585cb$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                createdCategory: null
            }
        });
    };

});
parcelRegister("fPjip", function(module, exports) {

$parcel$export(module.exports, "toErrors", () => $fdef67eb1eab7980$export$b0ccdd1765e7cb42);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $i2U8h = parcelRequire("i2U8h");

var $guSo6 = parcelRequire("guSo6");
// Ideally JSD Apollo would have i18n in their error messages, however in the absence of that
// we do a conversion here.
const $fdef67eb1eab7980$var$errorKeyToMessage = {
    'jsd.apollo.error.limit.exceeded': (0, $i2U8h.default).categoriesLimitExceeded,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $i2U8h.default).categoriesNoPermission,
    'jsd.apollo.field.error.category.name.cannot.be.blank': (0, $i2U8h.default).categoriesNameFieldBlank,
    'jsd.apollo.field.error.category.exceeded.name.length': (0, $i2U8h.default).categoriesNameFieldTooLong,
    'jsd.apollo.field.error.category.description.cannot.be.blank': (0, $i2U8h.default).categoriesDescriptionFieldBlank,
    'jsd.apollo.field.error.category.exceeded.description.length': (0, $i2U8h.default).categoriesDescriptionFieldTooLong
};
const $fdef67eb1eab7980$export$b0ccdd1765e7cb42 = (errorResponse)=>{
    const fieldErrorsResponse = errorResponse.fieldErrors || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [field]: {
                message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
                $fdef67eb1eab7980$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, $i2U8h.default).categoriesGenericMessage
            }
        }), {});
    const formError = errorResponse.errorKey ? {
        message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
        $fdef67eb1eab7980$var$errorKeyToMessage[errorResponse.errorKey] || (0, $i2U8h.default).categoriesGenericMessage
    } : undefined;
    return {
        formError: formError,
        fieldErrors: fieldErrors
    };
};
const $fdef67eb1eab7980$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, $guSo6.createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw({
            nativeError: errorResponse,
            formattedError: $fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)
        }));
const $fdef67eb1eab7980$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, $guSo6.updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw($fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)));

});
parcelRegister("i2U8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed327d012ea36dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6ed327d012ea36dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    categoriesGenericMessage: {
        "id": "servicedesk-knowledge-services.categories-generic-message",
        "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
    },
    categoriesNoPermission: {
        "id": "servicedesk-knowledge-services.categories-no-permission",
        "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
    },
    categoriesLimitExceeded: {
        "id": "servicedesk-knowledge-services.categories-limit-exceeded",
        "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
    },
    categoriesNameFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-name-field-blank",
        "defaultMessage": "Name cannot be blank"
    },
    categoriesDescriptionFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-description-field-blank",
        "defaultMessage": "Description cannot be blank"
    },
    categoriesNameFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-name-field-too-long",
        "defaultMessage": "Name cannot be longer than 100 characters"
    },
    categoriesDescriptionFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-description-field-too-long",
        "defaultMessage": "Description cannot be longer than 150 characters"
    }
});

});

parcelRegister("guSo6", function(module, exports) {

$parcel$export(module.exports, "listCategories", () => $61a0664d6d43d351$export$db54be5b1772ef4b);
$parcel$export(module.exports, "createCategory", () => $61a0664d6d43d351$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "updateCategory", () => $61a0664d6d43d351$export$daaacb0271870c9);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $5OrSA = parcelRequire("5OrSA");

var $2Lj35 = parcelRequire("2Lj35");

const $61a0664d6d43d351$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
};
const $61a0664d6d43d351$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category/`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, $2Lj35.categoryGuidToString)(categoryId)}`, {
        method: 'DELETE'
    });
};
const $61a0664d6d43d351$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
        method: 'POST',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $61a0664d6d43d351$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    let body = {
        articleId: articleId,
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; articleId: string; featured: boolean | undefined; }' is not assignable to type '{ articleId: string; featured: boolean | undefined; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article`, {
        method: 'POST',
        body: JSON.stringify(body)
    });
};
const $61a0664d6d43d351$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
        method: 'DELETE'
    });
const $61a0664d6d43d351$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
const $61a0664d6d43d351$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    let body = {
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; featured: boolean; }' is not assignable to type '{ featured: boolean; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article/${articleId}`, {
        method: 'PUT',
        body: JSON.stringify(body)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $61a0664d6d43d351$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
        method: 'PUT',
        body: JSON.stringify(categories)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));

});
parcelRegister("5OrSA", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $f90c86f7d1f72b9b$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $f90c86f7d1f72b9b$export$64ab95a52860b608);
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $561FV = parcelRequire("561FV");

var $kVLXA = parcelRequire("kVLXA");

var $487fd = parcelRequire("487fd");

var $7f4tk = parcelRequire("7f4tk");

var $7zmUm = parcelRequire("7zmUm");
const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode,
        traceId: traceId
    });
const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
    const traceId = error.traceId;
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
        return {
            response: response,
            statusCode: error.statusCode,
            traceId: traceId
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
    }
};
const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, $7f4tk.default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, $487fd.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, $7zmUm.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $aDvGo = parcelRequire("aDvGo");

var $x9xyg = parcelRequire("x9xyg");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $aDvGo.default), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $aDvGo = parcelRequire("aDvGo");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $aDvGo.default), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});


parcelRegister("2Lj35", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $6a4fff955a10b2dc$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $6a4fff955a10b2dc$export$be5c80c4ad1faf99);
const $6a4fff955a10b2dc$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
const $6a4fff955a10b2dc$export$43162cfd3260b2fe = (guid)=>guid;
const $6a4fff955a10b2dc$export$be5c80c4ad1faf99 = (guid)=>guid;

});

const $45c806b56a43da0e$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $45c806b56a43da0e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';



const $d7e8e0de2b5415e5$export$d42203c46ecda0b5 = 'ncs';
const $d7e8e0de2b5415e5$export$22ba648868203514 = 'synchrony';
const $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c = 'JSM';
const $d7e8e0de2b5415e5$export$a40257481ddef37e = 'atlassianAccount';
const $d7e8e0de2b5415e5$export$d57b6b390e78d90f = 'jsm-nebula';
const $d7e8e0de2b5415e5$export$85314a8fbb8155e1 = 'MONTHLY';
const $d7e8e0de2b5415e5$export$d1eb58f682ad65ad = 'ANNUAL';
const $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4 = 'INACTIVE';

parcelRegister("j8qrr", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $50b96e14ac428fad$export$7ce9dbcc6d544b1);

var $7f4tk = parcelRequire("7f4tk");

const $50b96e14ac428fad$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $50b96e14ac428fad$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
    const url = $50b96e14ac428fad$export$f0b37505cff627e3(projectId, activationId);
    return (0, $7f4tk.default)(url, {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("dsFMC", function(module, exports) {

$parcel$export(module.exports, "deleteCategorySuccess", () => $3c95377777bb5342$export$aa2eaa46022bd60b);
const $3c95377777bb5342$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: [
                    ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                ]
            }
        });
    };

});

parcelRegister("aInVL", function(module, exports) {

$parcel$export(module.exports, "publishSuccess", () => $7490ef4194dfdc47$export$a435a3808fe5155f);
const $7490ef4194dfdc47$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            published: true,
            articleId: articleId,
            draftShareId: draftShareId,
            spaceKey: spaceKey
        });
    };

});

parcelRegister("3twc2", function(module, exports) {

$parcel$export(module.exports, "savedSuccess", () => $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f);
const $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            closed: true,
            articleId: articleId,
            draftShareId: draftShareId
        });
    };

});

parcelRegister("klUDT", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $1022d05f23af34ff$export$416ec9f5729de215);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $1d66W = parcelRequire("1d66W");
const $1022d05f23af34ff$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            categoriesData: {
                ...initialState.categoriesData,
                isLoading: true
            }
        });
        try {
            const { categories: categories, categoriesSupported: categoriesSupported } = await (0, $1d66W.fetchCategories)(projectId, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    categories: categories,
                    isCategoriesSupported: categoriesSupported,
                    isLoading: false,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: false,
                    error: error
                }
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'onFetchCategoriesFailure',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("1d66W", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $b7d9de4ee333d2ce$export$416ec9f5729de215);

var $7f4tk = parcelRequire("7f4tk");

const $b7d9de4ee333d2ce$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $b7d9de4ee333d2ce$export$416ec9f5729de215 = (projectId, activationId)=>{
    const url = $b7d9de4ee333d2ce$export$5cf4b2ebebe43941(projectId, activationId);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("2tTYZ", function(module, exports) {

$parcel$export(module.exports, "fetchCreateArticlePermission", () => $ac71c34762d51de0$export$c5bf032e1fb1ad18);

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $5ukFp = parcelRequire("5ukFp");
const $ac71c34762d51de0$var$EVENT_NAME = 'createPermissionsForSpace';
const $ac71c34762d51de0$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            spacesPermitted: {
                ...initialState.spacesPermitted,
                isLoading: true
            }
        });
        try {
            const { promotedSpaces: promotedSpaces } = await (0, $5ukFp.getCreatePermissionsForSpace)(cloudId, spaceKeys);
            const permittedSpaces = promotedSpaces.spaces.map(// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'text' implicitly has an 'any' type.
            ({ id: id, text: text })=>({
                    spaceKey: id,
                    spaceName: text
                }));
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    data: permittedSpaces,
                    totalSize: promotedSpaces.spaces.length
                }
            });
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${$ac71c34762d51de0$var$EVENT_NAME} succedded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    error: error
                }
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
        }
    };

});
parcelRegister("cVUDi", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsEvents", () => $9d8927ca77b8220f$export$b84e314c48e09c44);
$parcel$export(module.exports, "getPageOnDelete", () => $9d8927ca77b8220f$export$99689dbe56145ad5);
$parcel$export(module.exports, "fireCustomErrorAnalytics", () => $9d8927ca77b8220f$export$3d13cbe76aeaf5e8);
$parcel$export(module.exports, "getViewArticleUrl", () => $9d8927ca77b8220f$export$4b1de73aa951498c);
$parcel$export(module.exports, "getAllDraftsUrl", () => $9d8927ca77b8220f$export$939c0821a1193768);
$parcel$export(module.exports, "getAllArticlesUrl", () => $9d8927ca77b8220f$export$240e98bbb8304c52);
$parcel$export(module.exports, "getFlag", () => $9d8927ca77b8220f$export$a19b74191e00c5e);
$parcel$export(module.exports, "getCommonFlagData", () => $9d8927ca77b8220f$export$f44d45dc3db56277);
$parcel$export(module.exports, "filterSupportedBillingPeriod", () => $9d8927ca77b8220f$export$9f13ed259dc4b1bf);
$parcel$export(module.exports, "formatTrialEndDate", () => $9d8927ca77b8220f$export$da56c66ce2766e02);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");


var $fyKAM = parcelRequire("fyKAM");

const $9d8927ca77b8220f$var$TEAM_NAME = 'jsm-nebula';
const $9d8927ca77b8220f$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $9d8927ca77b8220f$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $9d8927ca77b8220f$export$53ee51427129200c = (statusCode)=>$9d8927ca77b8220f$export$1a5a4674dd906e7e(statusCode) || $9d8927ca77b8220f$export$d31fd506ce75fa65(statusCode);
const $9d8927ca77b8220f$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    if (error && typeof error.statusCode === 'number') {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
        const { statusCode: statusCode } = error;
        const lowPriorityError = statusCode >= 400 && statusCode < 500;
        const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
        const transformedError = error instanceof (0, $jJZqs.default) ? error : new (0, $jJZqs.default)(statusCode);
        const errorObj = {
            error: transformedError,
            meta: {
                id: errorMetaId,
                packageName: packageName,
                teamName: $9d8927ca77b8220f$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        };
        (0, $jcw0u.default)(errorObj);
    } else (0, $jcw0u.default)({
        // Note there should not be a case of circular object for error , if there is it will be handled by fireErrorAnalytics
        error: error instanceof Error ? error : new Error(JSON.stringify(error)),
        meta: {
            id: `${id}__JS_ERROR`,
            packageName: packageName,
            teamName: $9d8927ca77b8220f$var$TEAM_NAME
        },
        ...attributes && {
            attributes: attributes
        }
    });
};
const $9d8927ca77b8220f$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
    const lastPage = Math.ceil(updateDataSize / perPage);
    return currentPage > lastPage ? lastPage : currentPage;
};
const $9d8927ca77b8220f$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
    if (error && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    typeof error.statusCode === 'number' && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    !$9d8927ca77b8220f$export$53ee51427129200c(error.statusCode)) event && (0, $8zOmE.fireOperationalAnalytics)(event, id);
    $9d8927ca77b8220f$export$b84e314c48e09c44(error, id, packageName, attributes);
};
const $9d8927ca77b8220f$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
const $9d8927ca77b8220f$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
const $9d8927ca77b8220f$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
const $9d8927ca77b8220f$export$a19b74191e00c5e = (title, description, flagType)=>({
        title: title,
        description: description,
        id: (0, $fyKAM.generateNanoId)(),
        flagType: flagType
    });
const $9d8927ca77b8220f$export$a6125e21263de883 = (state)=>{
    const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
    const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
    const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
    const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
    const isArticleDeleted = Boolean(articleId && deleted);
    return {
        isDraftPublished: isDraftPublished,
        isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
        isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
        isArticleDeleted: isArticleDeleted
    };
};
const $9d8927ca77b8220f$export$f44d45dc3db56277 = (state, messages)=>{
    let flag = {
        id: '',
        title: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        description: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
    };
    const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
    // if confluence get content api fails
    if (showConfluenceCreatePageError) {
        flag = {
            id: 'draftErrorFlag',
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            title: messages.confluenceCreatePageFailureTitle,
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            description: messages.confluenceCreatePageFailureDescription,
            type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
        };
        return flag;
    }
    const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $9d8927ca77b8220f$export$a6125e21263de883(state);
    // case when new article is published --> Article View
    if (isDraftPublished) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when draft is saved with unpublished changes --> Browse All Articles Page
    if (isDraftSavedWithUnpublishedChanges) flag = {
        id: 'draftSavedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'string | MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessSavedFlagDescription || '',
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when older article is saved with unpublished changes --> Article View
    if (isArticleSavedWithUnpublishedChanges) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleSuccessSavedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when article is deleted --> Browse All Articles Page
    if (isArticleDeleted) flag = {
        id: 'articleDeletedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleDeletedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleDeletedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    return flag;
};
const $9d8927ca77b8220f$export$9f13ed259dc4b1bf = (billingPeriod)=>{
    if (billingPeriod === (0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1)) return 0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1;
    if (billingPeriod === (0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad)) return 0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad;
    return 0, $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4;
};
const $9d8927ca77b8220f$export$da56c66ce2766e02 = (trialEndDate)=>{
    if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
    return null;
};

});
const $3026c2757a468eb7$export$516433e8a6db7503 = 'SUCCESS';
const $3026c2757a468eb7$export$a0a5e05447abb018 = 'WARNING';
const $3026c2757a468eb7$export$f215947b3d76a6b7 = 'ERROR';
const $3026c2757a468eb7$export$21bdd502a5302e06 = 'INFO';

parcelRegister("fyKAM", function(module, exports) {

$parcel$export(module.exports, "generateNanoId", () => $ef446b866ecb6566$export$a4f5444a5996c185);

var $9J4h7 = parcelRequire("9J4h7");
const $ef446b866ecb6566$export$a4f5444a5996c185 = ()=>(0, $9J4h7.nanoid)(12);
const $ef446b866ecb6566$export$e73c8bd0f20705a = ()=>(0, $9J4h7.nanoid)();

});
parcelRegister("9J4h7", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $714ba1f43c1bc4b0$export$ac4959f4f1338dfc);

let $714ba1f43c1bc4b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $714ba1f43c1bc4b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $714ba1f43c1bc4b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$714ba1f43c1bc4b0$export$a5cee9e955a615e5(alphabet, size, $714ba1f43c1bc4b0$export$4385e60b38654f68);
let $714ba1f43c1bc4b0$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--)id += (0, $11cc6b8f5f8db98c$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};

});
const $11cc6b8f5f8db98c$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';




parcelRegister("5ukFp", function(module, exports) {

$parcel$export(module.exports, "getCreatePermissionsForSpace", () => $4d7a1d82dc21430a$export$a4d40fb662e5fd46);
$parcel$export(module.exports, "getLinkedSpaces", () => $4d7a1d82dc21430a$export$b764c9ef97480a8e);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $4d7a1d82dc21430a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
    const queryString = (0, $ebyGx.stringify)({
        promotedSpaceKey: spaceKeys,
        promotedSpacesLimit: spaceKeys.length,
        otherSpacesLimit: 0
    });
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
};
const $4d7a1d82dc21430a$export$b764c9ef97480a8e = (projectKey)=>(0, $7f4tk.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);

});


parcelRegister("ik7FP", function(module, exports) {

$parcel$export(module.exports, "fetchDraftAndNavigateToEditor", () => $76ec8efa1f92f234$export$e8292dc9536b9de8);

var $5DTFO = parcelRequire("5DTFO");

var $8zOmE = parcelRequire("8zOmE");


var $cVUDi = parcelRequire("cVUDi");

var $gpe3Z = parcelRequire("gpe3Z");

var $1TU0Q = parcelRequire("1TU0Q");
const $76ec8efa1f92f234$var$EVENT_NAME = 'createNewConfluencePage';
const $76ec8efa1f92f234$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        try {
            setState({
                ...getState(),
                isFetchingDraftDetails: true
            });
            const createContentParams = {
                spaceKey: spaceKey,
                parentProductContentContainerId: String(projectId),
                parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
                title: topicName
            };
            const { contentId: contentId, draftShareId: draftShareId } = await (0, $5DTFO.createContent)(createContentParams);
            setState({
                ...getState(),
                articleId: contentId,
                draftShareId: draftShareId,
                isFetchingDraftDetails: false
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${$76ec8efa1f92f234$var$EVENT_NAME} succedded`, {
                topicId: topicId
            });
            dispatch((0, $1TU0Q.setRedirectionData)({
                onCloseRedirectUrl: onCloseRedirectUrl,
                onPublishRedirectUrl: onPublishRedirectUrl
            }));
            dispatch((0, $gpe3Z.navigateCreateDraftRoute)({
                routerActions: routerActions,
                projectKey: projectKey,
                selectedSpaceKey: spaceKey
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isFetchingDraftDetails: false,
                showConfluenceCreatePageError: true
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, $76ec8efa1f92f234$var$EVENT_NAME, 'knowledgeCommon');
        }
    };

});
parcelRegister("5DTFO", function(module, exports) {

$parcel$export(module.exports, "createContent", () => $01e25937c7343ac4$export$41c7a4cacf5bab80);
/**
 * This function would be used by Embedding product to create Confluence Content. Content created by this function will be tagged with "embedded" flag.
 * At the moment we only support creating a blank page and does not support cross domain request (Parent Product must be in same domain as Confluence)
 * To enable unlicensed user to create a page, parentProduct & parentProductContentContainerId are required.
 */ 
var $eJjla = parcelRequire("eJjla");
const $01e25937c7343ac4$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
    'parentProduct',
    'parentProductContentContainerId',
    'spaceKey'
];
const $01e25937c7343ac4$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
const $01e25937c7343ac4$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
    const payload = {
        type: 'page',
        status: 'draft',
        metadata: {
            properties: {
                editor: {
                    value: 'v2'
                }
            },
            frontend: {
                embedded: true
            }
        },
        space: {
            key: spaceKey
        },
        title: title,
        body: body
    };
    if (parentPageId) payload.ancestors = [
        {
            id: parentPageId
        }
    ];
    const baseurl = domain ? `https://${domain}` : domain;
    const unlicensedAccessHeader = $01e25937c7343ac4$var$getUnlicensedAccessHeader({
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    });
    let response;
    try {
        response = await fetch(`${baseurl}/wiki/rest/api/content`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                credentials: 'include',
                ...unlicensedAccessHeader
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // Promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side else resolve
        throw new Error(`Network failure ${e}`);
    }
    const responseJson = await response.json();
    if (!response.ok) throw new (0, $eJjla.CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
    return {
        draftShareId: $01e25937c7343ac4$var$getDraftShareId(responseJson),
        spaceKey: responseJson?.space?.key,
        contentId: responseJson?.id,
        status: responseJson?.status,
        subType: responseJson?.subType
    };
};
const $01e25937c7343ac4$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
const $01e25937c7343ac4$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
    const headerValue = {
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    };
    const isValidHeader = $01e25937c7343ac4$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$01e25937c7343ac4$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
};

});
parcelRegister("eJjla", function(module, exports) {

$parcel$export(module.exports, "CreateError", () => $6ed794ea4d63fcbb$export$91ee1703d5a5ab8b);
class $6ed794ea4d63fcbb$export$91ee1703d5a5ab8b extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("gpe3Z", function(module, exports) {

$parcel$export(module.exports, "navigateCreateDraftRoute", () => $4f804a011e2794bb$export$4e7c7ad076f5f5fc);

var $6udl5 = parcelRequire("6udl5");
const $4f804a011e2794bb$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey })=>async ({ getState: getState })=>{
        const { articleId: articleId, draftShareId: draftShareId } = {
            ...getState()
        };
        const EDIT_DRAFT_ROUTE = (0, $6udl5.getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId);
        routerActions.push(EDIT_DRAFT_ROUTE);
    };

});
parcelRegister("6udl5", function(module, exports) {

$parcel$export(module.exports, "getDraftEditUrl", () => $ed1cffe35d42c3de$export$5e8433ae3ce7c696);
$parcel$export(module.exports, "isDraftCreatedWithNCS", () => $ed1cffe35d42c3de$export$fc0fa1dc4749f854);
$parcel$export(module.exports, "findCategory", () => $ed1cffe35d42c3de$export$93e9d221203aed67);

const $ed1cffe35d42c3de$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId)=>`/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
const $ed1cffe35d42c3de$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $d7e8e0de2b5415e5$export$d42203c46ecda0b5);
const $ed1cffe35d42c3de$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
    if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
    return undefined;
};

});


parcelRegister("1TU0Q", function(module, exports) {

$parcel$export(module.exports, "setRedirectionData", () => $35239289cee1669b$export$c026d4a8850c302d);
$parcel$export(module.exports, "resetRedirectionData", () => $35239289cee1669b$export$7c6d6762f8b5b4db);
const $35239289cee1669b$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: redirectionData
        });
    };
const $35239289cee1669b$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: {
                onPublishRedirectUrl: '',
                onCloseRedirectUrl: ''
            }
        });
    };

});


parcelRegister("dAXEk", function(module, exports) {

$parcel$export(module.exports, "fetchLinkedSpaces", () => $1976703425aa0479$export$1999596e4ea30c16);

var $5ukFp = parcelRequire("5ukFp");
const $1976703425aa0479$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            linkedSpaces: {
                ...initialState.linkedSpaces,
                isLoading: true
            }
        });
        try {
            const response = await (0, $5ukFp.getLinkedSpaces)(projectKey);
            const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                    spaceKey: spaceKey,
                    spaceName: spaceName
                }));
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    data: linkedSpaces,
                    totalSize: linkedSpaces.length
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    error: error
                }
            });
        }
    };

});

parcelRegister("dIiIO", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $c701340a34445280$export$d1eac56717011ed4);

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $8FVnr = parcelRequire("8FVnr");
const $c701340a34445280$var$EVENT_NAME = 'fetchUserCapabilities';
const $c701340a34445280$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            userCapabilities: {
                ...initialState.userCapabilities,
                isLoading: true
            }
        });
        try {
            const data = await (0, $8FVnr.fetchUserCapabilities)(projectId, activationId);
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    data: data,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${$c701340a34445280$var$EVENT_NAME} succeeded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    error: error
                }
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, `${$c701340a34445280$var$EVENT_NAME} failed`, 'knowledgeCommon');
        }
    };

});
parcelRegister("8FVnr", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $11ef201d32e47a4e$export$d1eac56717011ed4);

var $7f4tk = parcelRequire("7f4tk");

const $11ef201d32e47a4e$export$d1eac56717011ed4 = (projectId, activationId)=>{
    const url = `${(0, $45c806b56a43da0e$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("jIuZj", function(module, exports) {

$parcel$export(module.exports, "removeCommonFlag", () => $3807c62af5ab354f$export$a2af96a4f99f3900);
const $3807c62af5ab354f$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
        const { flags: currentFlags } = getState();
        const flags = currentFlags.filter(({ id: id })=>id !== flagId);
        setState({
            ...getState(),
            flags: flags
        });
    };

});

parcelRegister("eP4xZ", function(module, exports) {

$parcel$export(module.exports, "reorderCategories", () => $d1c7d54ec7e0876f$export$32f957e287d37daa);

var $ajpes = parcelRequire("ajpes");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $261Bl = parcelRequire("261Bl");

var $1wnS6 = parcelRequire("1wnS6");
const $d1c7d54ec7e0876f$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
    const newCategories = [
        ...categories
    ];
    const movedItem = newCategories.splice(fromIndex, 1)[0];
    if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
    return newCategories;
};
const $d1c7d54ec7e0876f$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
        const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
        const initiallyOrderedCategories = [
            ...getState().categoriesData.categories
        ];
        const newlyOrderedCategories = $d1c7d54ec7e0876f$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: newlyOrderedCategories
            }
        });
        try {
            const { categories: categories } = await (0, $1wnS6.orderCategories)({
                projectId: projectId,
                activationId: activationId,
                categories: [
                    {
                        categoryId: categoryToBeMovedId,
                        order: toIndex
                    }
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                id: (0, $261Bl.categoryGuidToString)(categoryToBeMovedId)
            });
            const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
            const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                // Something about the category information in apollo is different to our store
                // e.g. another user has reordered categories, added a category, deleted a category
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: categories
                    }
                });
                onReorderMismatch();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'reorderCategories',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...initiallyOrderedCategories
                    ]
                }
            });
            onReorderFailure();
        }
    };

});
parcelRegister("261Bl", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $21d0c574129f0705$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $21d0c574129f0705$export$be5c80c4ad1faf99);
const $21d0c574129f0705$export$43162cfd3260b2fe = (guid)=>guid;
const $21d0c574129f0705$export$be5c80c4ad1faf99 = (guid)=>guid;

});

parcelRegister("1wnS6", function(module, exports) {

$parcel$export(module.exports, "orderCategories", () => $56b61b6811b7fda7$export$e90b3dc42a0ddf96);

var $7f4tk = parcelRequire("7f4tk");

const $56b61b6811b7fda7$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
    return (0, $7f4tk.default)(url, {
        method: 'PUT',
        body: JSON.stringify(categories)
    });
};

});


parcelRegister("8QyFO", function(module, exports) {

$parcel$export(module.exports, "resetDraftArticleData", () => $c895191ddea664b2$export$e4dbf2710e8c685d);
const $c895191ddea664b2$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            draftShareId: '',
            closed: false,
            published: false,
            showConfluenceCreatePageError: false,
            spaceKey: '',
            ...resetDelete && {
                deleted: false,
                articleId: ''
            }
        });
    };

});

parcelRegister("1VmcQ", function(module, exports) {

$parcel$export(module.exports, "updateCategorySuccess", () => $10ef8418d41dbca6$export$7d46e556893bba77);
const $10ef8418d41dbca6$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
            }
        });
    };

});


parcelRegister("cSB1I", function(module, exports) {

$parcel$export(module.exports, "getDraftShareId", () => $b10361f0e26ced23$export$f31b9480a5e4fdcf);
$parcel$export(module.exports, "getArticleId", () => $b10361f0e26ced23$export$2d21c0faccc1d33f);
$parcel$export(module.exports, "getIsFetchingDraftDetails", () => $b10361f0e26ced23$export$19d926b900e1c065);
$parcel$export(module.exports, "getRedirectionData", () => $b10361f0e26ced23$export$fdde4bb390e025db);
$parcel$export(module.exports, "getPermittedSpaces", () => $b10361f0e26ced23$export$4a419b2d3bb6a3fc);
$parcel$export(module.exports, "getLinkedSpaces", () => $b10361f0e26ced23$export$b764c9ef97480a8e);
$parcel$export(module.exports, "getUserCapabilities", () => $b10361f0e26ced23$export$f7db3ef62579b328);
$parcel$export(module.exports, "getCategoriesData", () => $b10361f0e26ced23$export$b416461ac52d8504);
$parcel$export(module.exports, "getCreateCategoryData", () => $b10361f0e26ced23$export$e0cf4a4b69bbc694);
$parcel$export(module.exports, "getCategory", () => $b10361f0e26ced23$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCommonFlags", () => $b10361f0e26ced23$export$b94d9d28300025a9);
$parcel$export(module.exports, "getKnowledgeCommonFlags", () => $b10361f0e26ced23$export$1a5b9662b382779c);

var $cVUDi = parcelRequire("cVUDi");

var $6udl5 = parcelRequire("6udl5");
const $b10361f0e26ced23$export$c9cab98530df1a79 = ({ published: published })=>published;
const $b10361f0e26ced23$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
const $b10361f0e26ced23$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
const $b10361f0e26ced23$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
const $b10361f0e26ced23$export$fdde4bb390e025db = (state)=>state.redirectionData;
const $b10361f0e26ced23$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
const $b10361f0e26ced23$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
const $b10361f0e26ced23$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
const $b10361f0e26ced23$export$b416461ac52d8504 = (state)=>state.categoriesData;
const $b10361f0e26ced23$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
const $b10361f0e26ced23$export$410364bbb673ddbc = (state, categoryId)=>(0, $6udl5.findCategory)(state.categoriesData, categoryId);
const $b10361f0e26ced23$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
const $b10361f0e26ced23$export$1a5b9662b382779c = (state, messages)=>(0, $cVUDi.getCommonFlagData)({
        ...state
    }, messages);

});


parcelRegister("ghVG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $271aace1fac64940$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $bC2fB = parcelRequire("bC2fB");

var $gLt7z = parcelRequire("gLt7z");

var $ealBh = parcelRequire("ealBh");
const $271aace1fac64940$var$mapStateToProps = (state)=>({
        projectKey: (0, $gLt7z.getProjectKey)(state),
        baseUrl: (0, $gLt7z.getBaseUrl)(state)
    });
var $271aace1fac64940$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($271aace1fac64940$var$mapStateToProps, {})((0, $8RXs9.default)((0, $ealBh.default)));

});
parcelRegister("gLt7z", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $5ee05ac4f84233bf$export$f654b28f82155665);
$parcel$export(module.exports, "getLocale", () => $5ee05ac4f84233bf$export$180605366c04f0cd);
$parcel$export(module.exports, "getProjectKey", () => $5ee05ac4f84233bf$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $5ee05ac4f84233bf$export$89040d072f281f85);
$parcel$export(module.exports, "getIsProjectSimplified", () => $5ee05ac4f84233bf$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getIsAdmin", () => $5ee05ac4f84233bf$export$7d046765d192af80);
$parcel$export(module.exports, "getActivationId", () => $5ee05ac4f84233bf$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getCloudId", () => $5ee05ac4f84233bf$export$fdd2c0ba94025c3c);
const $5ee05ac4f84233bf$export$f654b28f82155665 = (_)=>'';
const $5ee05ac4f84233bf$export$180605366c04f0cd = (state)=>state.app.locale;
const $5ee05ac4f84233bf$export$667f2a0f99c75faa = (state)=>state.app.projectKey;
const $5ee05ac4f84233bf$export$89040d072f281f85 = (state)=>state.app.projectId;
const $5ee05ac4f84233bf$export$5bde43fbba6edf90 = (state)=>state.app.isProjectSimplified;
const $5ee05ac4f84233bf$export$7d046765d192af80 = (state)=>state.app.isAdmin;
const $5ee05ac4f84233bf$export$3ad4bb31a1816ff6 = (state)=>state.app.activationId;
const $5ee05ac4f84233bf$export$fdd2c0ba94025c3c = (state)=>state.app.cloudId;

});

parcelRegister("ealBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7526018970629bef$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $jbwMx = parcelRequire("jbwMx");
class $7526018970629bef$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    renderKnowledgeBaseBreadcrumb() {
        const { children: children, baseUrl: baseUrl, projectKey: projectKey, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge`,
                text: formatMessage((0, $jbwMx.default).knowledgeBase),
                type: 'jsd-knowledge-base'
            }
        }, children);
    }
    render() {
        return this.renderKnowledgeBaseBreadcrumb();
    }
}

});
parcelRegister("jbwMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7699cc1a8f21589$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7699cc1a8f21589$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    articlesPageHeader: {
        "id": "servicedesk.knowledge-hub.common.i18n.articles-page-header",
        "defaultMessage": "Articles"
    },
    knowledgeBase: {
        "id": "servicedesk.knowledge-hub.common.i18n.knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    noCategoryText: {
        "id": "servicedesk.knowledge-hub.common.i18n.no-category-text",
        "defaultMessage": "Uncategorized"
    },
    editInConfluence: {
        "id": "servicedesk.knowledge-hub.common.i18n.edit-in-confluence",
        "defaultMessage": "Edit in Confluence"
    }
});

});



parcelRegister("g26cY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a57b9e40246f918$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $bC2fB = parcelRequire("bC2fB");

var $gLt7z = parcelRequire("gLt7z");

var $5ZQ3w = parcelRequire("5ZQ3w");
const $4a57b9e40246f918$var$mapStateToProps = (state)=>({
        projectKey: (0, $gLt7z.getProjectKey)(state),
        baseUrl: (0, $gLt7z.getBaseUrl)(state)
    });
var $4a57b9e40246f918$export$2e2bcd8739ae039 = (0, $8RXs9.default)((0, $bC2fB.connect)($4a57b9e40246f918$var$mapStateToProps, {})((0, $5ZQ3w.default)));

});
parcelRegister("5ZQ3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a35a15843ac8030$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $jTNvW = parcelRequire("jTNvW");
class $1a35a15843ac8030$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    renderKnowledgeBaseSearchBreadcrumb() {
        const { children: children, baseUrl: baseUrl, projectKey: projectKey, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge/search`,
                text: formatMessage((0, $jTNvW.default).searchTitle),
                type: 'jsd-knowledge-base-search'
            }
        }, children);
    }
    render() {
        return this.renderKnowledgeBaseSearchBreadcrumb();
    }
}

});
parcelRegister("jTNvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb15fc24ee6709dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bb15fc24ee6709dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchTitle: {
        "id": "servicedesk.knowledge-hub.common.knowledge-base-search-breadcrumb.search-title",
        "defaultMessage": "Search"
    }
});

});



parcelRegister("esWw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2847558c189ceb$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $2keUK = parcelRequire("2keUK");

var $iQv12 = parcelRequire("iQv12");

var $bC2fB = parcelRequire("bC2fB");

var $gMZw6 = parcelRequire("gMZw6");

var $la4EY = parcelRequire("la4EY");

var $fCYod = parcelRequire("fCYod");

var $gXg4u = parcelRequire("gXg4u");

var $gLt7z = parcelRequire("gLt7z");

var $3230b = parcelRequire("3230b");
var $ad2847558c189ceb$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
    (0, $iQv12.default)({
        onEditClicked: 'editInConfluence',
        onCopyClicked: 'copyShareUrl'
    }),
    (0, $2keUK.default)(),
    (0, $bC2fB.connect)((state, ownProps)=>({
            article: (0, $gXg4u.getArticle)(state, ownProps.id),
            projectKey: (0, $gLt7z.getProjectKey)(state),
            projectId: (0, $gLt7z.getProjectId)(state),
            appLinkState: (0, $fCYod.getAppLinkState)(state),
            activationId: (0, $gLt7z.getActivationId)(state)
        }), {
        onFetchArticle: (0, $la4EY.fetchArticle),
        onFetchAppLink: (0, $gMZw6.fetchAppLink)
    })
])((0, $3230b.default));

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("gMZw6", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINK", () => $ed5b7c76bdf86da2$export$da6ab0fd0c34565f);
$parcel$export(module.exports, "fetchAppLink", () => $ed5b7c76bdf86da2$export$6bb78bb661cf0859);
const $ed5b7c76bdf86da2$export$da6ab0fd0c34565f = 'state.actions.fetch-applink.FETCH_APPLINK';
const $ed5b7c76bdf86da2$export$6bb78bb661cf0859 = ()=>({
        type: $ed5b7c76bdf86da2$export$da6ab0fd0c34565f
    });

});

parcelRegister("la4EY", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE", () => $fdce37e75ad78af2$export$a55f0530be417648);
$parcel$export(module.exports, "fetchArticle", () => $fdce37e75ad78af2$export$b455945318d7989e);
const $fdce37e75ad78af2$export$a55f0530be417648 = 'state.actions.fetch-article.FETCH_ARTICLE';
const $fdce37e75ad78af2$export$b455945318d7989e = (id, articleType, accountId, createAnalyticsEvent)=>({
        type: $fdce37e75ad78af2$export$a55f0530be417648,
        payload: {
            id: id,
            articleType: articleType,
            accountId: accountId,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});

parcelRegister("fCYod", function(module, exports) {

$parcel$export(module.exports, "getAppLinkState", () => $681898a3e978aa85$export$5017a5295f2c0e75);
$parcel$export(module.exports, "getAppLinkOrError", () => $681898a3e978aa85$export$f313f4d9202e0f4e);
const $681898a3e978aa85$export$5017a5295f2c0e75 = (state)=>state.entities.appLink;
const $681898a3e978aa85$export$7d919ca1f3c09dd = (state)=>state.entities.appLink?.appLink;
const $681898a3e978aa85$export$56510b4953c6542b = (state)=>state.entities.appLink?.isLoaded || false;
const $681898a3e978aa85$export$f313f4d9202e0f4e = (state)=>{
    const { isLoaded: isLoaded, error: error, appLink: appLink } = state.entities.appLink || {};
    if (isLoaded && appLink) return appLink;
    if (error) return {
        error: error
    };
    return undefined;
};

});

parcelRegister("gXg4u", function(module, exports) {

$parcel$export(module.exports, "getFeaturedInCategoryIds", () => $daacc015e0475ec6$export$413b305383a0e001);
$parcel$export(module.exports, "getArticle", () => $daacc015e0475ec6$export$f8c0d0a39b0d7d4e);
$parcel$export(module.exports, "getCategoriesForArticle", () => $daacc015e0475ec6$export$458f158173f65de8);
$parcel$export(module.exports, "getCategoriesForArticleBulkUpdate", () => $daacc015e0475ec6$export$360e12e07ffc1cb0);
$parcel$export(module.exports, "getArticlesByIds", () => $daacc015e0475ec6$export$ba941551d0dc160c);
$parcel$export(module.exports, "getIsShowingBulkCategoryAdder", () => $daacc015e0475ec6$export$483e222b9f194c8a);
$parcel$export(module.exports, "getCategoriesInBulkCategoryAdder", () => $daacc015e0475ec6$export$d1f02a9ddd87bcc6);
$parcel$export(module.exports, "getSpaceKeyForArticle", () => $daacc015e0475ec6$export$ccf898e36d51a9bc);

var $dGvGJ = parcelRequire("dGvGJ");

var $7qDUb = parcelRequire("7qDUb");

var $5fBrW = parcelRequire("5fBrW");
const $daacc015e0475ec6$export$413b305383a0e001 = (state, articleId)=>state.entities.articles[articleId] && // @ts-expect-error - TS2339 - Property 'featuredInCategories' does not exist on type 'ArticleState'.
    state.entities.articles[articleId].featuredInCategories && // @ts-expect-error - TS2339 - Property 'featuredInCategories' does not exist on type 'ArticleState'.
    state.entities.articles[articleId].featuredInCategories;
const $daacc015e0475ec6$var$getArticleCategories = (allCategories, article)=>{
    if (article.categories) {
        const categories = article.categories.map((categoryId)=>allCategories.categories.find((category)=>category.id === categoryId)).filter(Boolean);
        const featuredInCategoryIds = article.featuredInCategories || [];
        if (featuredInCategoryIds.length === 0) return categories;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(categories, (cat)=>!featuredInCategoryIds.includes(cat.id));
    }
    return undefined;
};
const $daacc015e0475ec6$export$f8c0d0a39b0d7d4e = (0, $dGvGJ.createSelector)((state, articleId)=>state.entities.articles[articleId], (state)=>state.entities.categories, (articleOrError, allCategories)=>{
    if (!articleOrError) return undefined;
    if ('error' in articleOrError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return articleOrError;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const article = articleOrError;
    const categories = $daacc015e0475ec6$var$getArticleCategories(allCategories, article);
    const { categories: _, ...articleWithoutCategory } = article;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...articleWithoutCategory,
        categories: categories
    };
});
const $daacc015e0475ec6$var$getUpdatingCategoriesForArticle = (state, articleId)=>state.ui.articles[articleId] && state.ui.articles[articleId].categoryIds && state.ui.articles[articleId].categoryIds.map((id)=>(0, $5fBrW.getCategory)(state, id)).filter(Boolean);
const $daacc015e0475ec6$export$458f158173f65de8 = (state, articleId)=>{
    const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
    if (!article) return [];
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'Article | GenericError'.
    if (article.error) return [];
    // @ts-expect-error - TS2339 - Property 'categories' does not exist on type 'Article | GenericError'.
    return article.categories || [];
};
const $daacc015e0475ec6$export$360e12e07ffc1cb0 = (state, articleId)=>{
    const updatingCategories = $daacc015e0475ec6$var$getUpdatingCategoriesForArticle(state, articleId);
    // if there are updating categories value, we will use the updating state so it will
    // always reflect the latest categories for article
    if (updatingCategories) return updatingCategories;
    // retrieve from persisted state if there is no updating value available
    return $daacc015e0475ec6$export$458f158173f65de8(state, articleId);
};
const $daacc015e0475ec6$export$ba941551d0dc160c = (state, articleIds)=>articleIds.map((articleId)=>$daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId)).filter(Boolean);
const $daacc015e0475ec6$export$483e222b9f194c8a = (state, articleId)=>state.ui.articles[articleId] && !!state.ui.articles[articleId].isShowingBulkCategoryAdder;
const $daacc015e0475ec6$export$d1f02a9ddd87bcc6 = (state, articleId)=>{
    if (!state.ui.articles[articleId]) return [];
    return state.ui.articles[articleId].categoriesInBulkCategoryAdder || [];
};
const $daacc015e0475ec6$export$ccf898e36d51a9bc = (state, articleId)=>{
    const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
    if (!article) return '';
    // @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'Article | GenericError'.
    if (article.spaceKey) // @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'Article | GenericError'.
    return article.spaceKey;
    return '';
};

});
parcelRegister("5fBrW", function(module, exports) {

$parcel$export(module.exports, "getCategory", () => $45a4a0df582a0d3a$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCategoryName", () => $45a4a0df582a0d3a$export$67267455149572c9);
$parcel$export(module.exports, "getAllCategories", () => $45a4a0df582a0d3a$export$36bfd9279b3a24b7);
const $45a4a0df582a0d3a$export$410364bbb673ddbc = (state, id)=>state.entities.categories.categories.find((category)=>category.id === id);
const $45a4a0df582a0d3a$export$67267455149572c9 = (state, id)=>{
    const category = $45a4a0df582a0d3a$export$410364bbb673ddbc(state, id);
    if (category) return category.name;
    return undefined;
};
const $45a4a0df582a0d3a$export$36bfd9279b3a24b7 = (state)=>state.entities.categories.categories;

});


parcelRegister("3230b", function(module, exports) {

$parcel$export(module.exports, "default", () => $828bab14d335ddc0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h6QPt = parcelRequire("h6QPt");

var $1u3Jv = parcelRequire("1u3Jv");

var $79GY5 = parcelRequire("79GY5");

var $lw2HC = parcelRequire("lw2HC");

var $l8ruj = parcelRequire("l8ruj");

var $7fyET = parcelRequire("7fyET");

var $5Mrj8 = parcelRequire("5Mrj8");

var $fxVD7 = parcelRequire("fxVD7");

var $8WALy = parcelRequire("8WALy");

var $i3iLe = parcelRequire("i3iLe");
class $828bab14d335ddc0$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            projectKey: undefined,
            onEditClicked: undefined,
            onCopyClicked: undefined
        };
    }
    componentDidMount() {
        const { id: id, appLinkState: appLinkState, onFetchArticle: onFetchArticle, onFetchAppLink: onFetchAppLink, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        onFetchArticle(id, 'article', accountId, createAnalyticsEvent);
        // Fetch applink only if it has not been fetched before
        if (!appLinkState?.isLoaded) onFetchAppLink();
    }
    componentDidUpdate(prevProps) {
        const { id: id, onFetchArticle: onFetchArticle, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (prevProps.id !== id) onFetchArticle(id, 'article', accountId, createAnalyticsEvent);
    }
    render() {
        const { article: article, appLinkState: appLinkState, onFetchArticle: _, onFetchAppLink: __, id: id, projectId: projectId, activationId: activationId, createAnalyticsEvent: createAnalyticsEvent, accountId: accountId, ...passThroughProps } = this.props;
        const showAppLinkLoading = !appLinkState?.isLoaded;
        const showSpinner = showAppLinkLoading;
        if (showSpinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79GY5.default), null);
        if (appLinkState?.error) {
            (0, $7fyET.GlobalPageLoadExperience).markFMP();
            (0, $7fyET.GlobalPageLoadExperience).failure({
                force: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxVD7.default), null);
        }
        if (appLinkState?.appLink?.requireCredentials) {
            const onAuthenticate = async ()=>{
                try {
                    await (0, $h6QPt.default)(appLinkState?.appLink?.authUrl || '');
                    this.props.onFetchAppLink();
                    this.props.onFetchArticle(this.props.id, 'article', accountId, createAnalyticsEvent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                // do nothing
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Mrj8.default), {
                onAuthenticate: onAuthenticate,
                showDefaultTitle: true
            });
        }
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'Article | GenericError'.
        if (article && article.error) {
            (0, $7fyET.GlobalPageLoadExperience).markFMP();
            (0, $7fyET.GlobalPageLoadExperience).failure({
                force: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WALy.default), {
                // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'Article | GenericError'.
                error: article.error,
                screenName: "knowledgeArticleError",
                attributes: {
                    isConfluenceServer: appLinkState?.appLink?.isServer ?? false
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "knowledge-hub-view-article"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lw2HC.UserCapabilitiesSubscriber), null, ({ data: data }, { fetchUserCapabilities: fetchUserCapabilities })=>{
            const { hasConfluenceLicense: hasConfluenceLicense } = data;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
                op: fetchUserCapabilities,
                args: [
                    projectId,
                    activationId,
                    createAnalyticsEvent({})
                ]
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i3iLe.default), {
                ...passThroughProps,
                isServer: appLinkState?.appLink?.isServer,
                article: article,
                onIFrameLoaded: this.onIFrameLoaded,
                iframeLoading: this.state.iframeLoading,
                canViewSpaceUrl: hasConfluenceLicense,
                articleId: this.props.id
            }));
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            iframeLoading: true
        };
        this.onIFrameLoaded = ()=>{
            this.setState({
                iframeLoading: false
            });
        };
    }
}

});
parcelRegister("h6QPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c756de6db687f03$export$2e2bcd8739ae039);
/**
    This function is in order to encapsulate the behavior of the AppLinksUtils functionality

    AppLinksUtils is an Atlassian Plugin.

    AppLinks repository: https://bitbucket.org/atlassian/application-links
 */ /**
    The following function implements the same interface as the [OAuthCallback object](https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-plugin/src/main/resources/applinks/internal/feature/oauth/oauth-callback.js?at=master)

    It creates the object, assigns the object to a global variable in window and calls the plugin in a new window

    Once the Authentication dance is perform, the opened window will call success or failure callbacks from the window.opener.oauthCallback (https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-oauth-plugin/src/main/resources/com/atlassian/applinks/oauth/auth/oauth-dance.js?at=master)
 */ const $0c756de6db687f03$var$authenticateUsingAppLinks = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.oauthCallback) // preventing opening more than one authentication at the time.
    return null;
    const result = new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject)=>{
        let oauthWindow;
        let timer;
        let isPending = true;
        const oauthCallback = {
            success: ()=>{
                clearInterval(timer);
                // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                resolve();
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            },
            failure: ()=>{
                clearInterval(timer);
                reject(Error('Failed to authenticate with applinks'));
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.oauthCallback = oauthCallback;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
        timer = setInterval(()=>{
            if (oauthWindow && oauthWindow.closed && isPending) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                reject(Error('Failed to authenticate with applinks'));
                clearInterval(timer);
            }
        }, 500);
    });
    return result;
};
var $0c756de6db687f03$export$2e2bcd8739ae039 = $0c756de6db687f03$var$authenticateUsingAppLinks;

});

parcelRegister("79GY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bdab3bb4aeae840$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dyckQ = parcelRequire("dyckQ");
// No delay on this spinner; we don't know if the monolith had previously
// provided one. Better to increase risk a very brief display of a spinner
// than have the spinner vanish and return.
const $7bdab3bb4aeae840$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bdab3bb4aeae840$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyckQ.default), {
        size: "large",
        testId: "servicedesk-common.ui.components.page-spinner.spinner"
    }));
var $7bdab3bb4aeae840$export$2e2bcd8739ae039 = $7bdab3bb4aeae840$var$LoadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bdab3bb4aeae840$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5Mrj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d594bd1436f5525e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kbNdD = parcelRequire("kbNdD");

var $6z7Gx = parcelRequire("6z7Gx");

var $7PiB9 = parcelRequire("7PiB9");
const $d594bd1436f5525e$var$AuthenticationPanelWithBreadcrumbsAndAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbNdD.default), {
        data: {
            attributes: {
                context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7PiB9.default), props));
var $d594bd1436f5525e$export$2e2bcd8739ae039 = $d594bd1436f5525e$var$AuthenticationPanelWithBreadcrumbsAndAnalytics;

});
parcelRegister("6z7Gx", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $c0766aa675d05766$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $c0766aa675d05766$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $c0766aa675d05766$export$ebdbd98df5a27905);
$parcel$export(module.exports, "fireJsonOnlyErrorAnalytics", () => $c0766aa675d05766$export$32233c6edb041cf2);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $a7EYT = parcelRequire("a7EYT");
const $c0766aa675d05766$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $c0766aa675d05766$export$cca3c4e11cb0a5ce = 1000;
const $c0766aa675d05766$export$dc391c7d81907d3a = 4000;
const $c0766aa675d05766$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $a7EYT.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $jcw0u.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $jcw0u.trackFetchErrors)(payload);
};
function $c0766aa675d05766$export$32233c6edb041cf2({ error: error, ...rest }) {
    let tempError = error;
    if (error instanceof Error) try {
        JSON.parse(error.message);
    } catch (e) {
        if (error instanceof (0, $jJZqs.default)) // cloning as we're unable to mutate the original message property
        tempError = new (0, $jJZqs.default)(error?.statusCode, `Error server response: ${error?.statusCode}`, error?.traceId, error?.originalResponse);
        else // Strip the message incase it contains sensitive information
        tempError = new Error('');
    }
    (0, $jcw0u.default)({
        error: tempError instanceof Error ? tempError : undefined,
        ...rest
    });
}

});
parcelRegister("a7EYT", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $99def0fa5fc488a1$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $99def0fa5fc488a1$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $99def0fa5fc488a1$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $99def0fa5fc488a1$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $99def0fa5fc488a1$export$8ef51cba9d28f819);

var $gccSB = parcelRequire("gccSB");

var $cjFoH = parcelRequire("cjFoH");

var $aDvGo = parcelRequire("aDvGo");


var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, $jJZqs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(response)) this.response = response;
    }
}
const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $99def0fa5fc488a1$var$putOptions = {
    ...(0, $aDvGo.default),
    method: 'PUT'
};
const $99def0fa5fc488a1$var$postOptions = {
    ...(0, $aDvGo.default),
    method: 'POST'
};
const $99def0fa5fc488a1$var$deleteOptions = {
    ...(0, $aDvGo.default),
    method: 'DELETE'
};
const $99def0fa5fc488a1$var$patchOptions = {
    ...(0, $aDvGo.default),
    method: 'PATCH'
};
const $99def0fa5fc488a1$var$processResponse = async (response)=>{
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, $eusud.transformValidationErrorFromServer)(jsonResponse);
        const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
        throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $aDvGo.default),
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$putOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$postOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$deleteOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$patchOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;



parcelRegister("7PiB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $773127266287e63c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4NLf2 = parcelRequire("4NLf2");
var $dUThW = parcelRequire("dUThW");

var $6geWD = parcelRequire("6geWD");

var $OuhAr = parcelRequire("OuhAr");
const $773127266287e63c$export$5269a8ea972747c7 = ({ onAuthenticate: onAuthenticate, showDefaultTitle: showDefaultTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NLf2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUThW.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default), {
        truncateTitle: true,
        showDefaultTitle: showDefaultTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $OuhAr.default), {
        onAuthenticate: onAuthenticate
    })));
var $773127266287e63c$export$2e2bcd8739ae039 = $773127266287e63c$export$5269a8ea972747c7;

});
parcelRegister("4NLf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e0ad3e88579755b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eIqqh = parcelRequire("eIqqh");

var $8DE21 = parcelRequire("8DE21");

var $dUThW = parcelRequire("dUThW");

var $lGem7 = parcelRequire("lGem7");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2e0ad3e88579755b$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $lGem7.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $dUThW.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $eIqqh.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $eIqqh.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGem7.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8DE21.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $2e0ad3e88579755b$export$2e2bcd8739ae039 = $2e0ad3e88579755b$var$GridWrapper;

});
parcelRegister("eIqqh", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $27f7fdad3532f4bc$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $27f7fdad3532f4bc$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $27f7fdad3532f4bc$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $27f7fdad3532f4bc$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $27f7fdad3532f4bc$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $27f7fdad3532f4bc$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $27f7fdad3532f4bc$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $27f7fdad3532f4bc$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $27f7fdad3532f4bc$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $27f7fdad3532f4bc$export$936829b4511db3e4);
const $27f7fdad3532f4bc$export$3aaf3a78c909ea56 = 8;
const $27f7fdad3532f4bc$export$74797698e12f8baa = 12;
const $27f7fdad3532f4bc$export$b8241a1616ab1b96 = $27f7fdad3532f4bc$export$3aaf3a78c909ea56 * 10;
const $27f7fdad3532f4bc$export$2a89a65a43bab52d = {
    comfortable: $27f7fdad3532f4bc$export$3aaf3a78c909ea56 * 5,
    cosy: $27f7fdad3532f4bc$export$3aaf3a78c909ea56 * 2,
    compact: $27f7fdad3532f4bc$export$3aaf3a78c909ea56 * 0.5
};
const $27f7fdad3532f4bc$export$8ec7372efd74b753 = 'cosy';
const $27f7fdad3532f4bc$export$d77f83c3d17a7b8a = 52;
const $27f7fdad3532f4bc$export$f8725d21f81f3e01 = 0;
const $27f7fdad3532f4bc$export$2303d2bd9eeff99a = 'fixed';
const $27f7fdad3532f4bc$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $27f7fdad3532f4bc$export$8b7e31f391e6e681 = '--ds-column-span';
const $27f7fdad3532f4bc$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("8DE21", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $021d6160305762fe$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eIqqh = parcelRequire("eIqqh");

var $lGem7 = parcelRequire("lGem7");
function $021d6160305762fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $021d6160305762fe$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $eIqqh.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $021d6160305762fe$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $eIqqh.varColumnsNum)}) * ${(0, $eIqqh.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $021d6160305762fe$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $eIqqh.varGridSpacing)}))`
});
const $021d6160305762fe$export$ef2184bd89960b14 = ({ layout: layout = (0, $eIqqh.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $lGem7.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $021d6160305762fe$var$gridStyles,
            $021d6160305762fe$var$gridLayoutStyles[layout],
            isNested && $021d6160305762fe$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $eIqqh.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $eIqqh.varGridSpacing)]: `${(0, $eIqqh.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("lGem7", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $cfc0866efee846dd$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $eIqqh = parcelRequire("eIqqh");
const $cfc0866efee846dd$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $eIqqh.defaultSpacing),
    columns: (0, $eIqqh.defaultGridColumns)
});

});


parcelRegister("dUThW", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $f10082e1a8903b4a$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $f10082e1a8903b4a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eIqqh = parcelRequire("eIqqh");

var $lGem7 = parcelRequire("lGem7");
var $f10082e1a8903b4a$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($f10082e1a8903b4a$var$ColumnVariant || ($f10082e1a8903b4a$var$ColumnVariant = {}));
const $f10082e1a8903b4a$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $eIqqh.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $f10082e1a8903b4a$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $f10082e1a8903b4a$var$singleColumnWidth = `(${$f10082e1a8903b4a$var$availableWidth} / var(${(0, $eIqqh.varColumnsNum)}))`;
const $f10082e1a8903b4a$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$f10082e1a8903b4a$var$singleColumnWidth} - var(${(0, $eIqqh.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $eIqqh.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $f10082e1a8903b4a$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $eIqqh.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$f10082e1a8903b4a$var$singleColumnWidth} *  var(${(0, $eIqqh.varColumnSpan)}) - var(${(0, $eIqqh.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $eIqqh.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $f10082e1a8903b4a$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $eIqqh.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $f10082e1a8903b4a$var$GridColumn = ({ medium: medium = (0, $eIqqh.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $lGem7.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $f10082e1a8903b4a$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($f10082e1a8903b4a$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $f10082e1a8903b4a$var$gridColumnStyles,
            $f10082e1a8903b4a$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $eIqqh.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $f10082e1a8903b4a$export$2e2bcd8739ae039 = $f10082e1a8903b4a$var$GridColumn;

});


parcelRegister("6geWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $805b9f255efa1904$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jS4lj = parcelRequire("jS4lj");

var $cS37j = parcelRequire("cS37j");

var $koVbs = parcelRequire("koVbs");

var $jbwMx = parcelRequire("jbwMx");
function $805b9f255efa1904$export$fea23bd0b48d9710(props) {
    const { children: children, description: description, showDefaultTitle: showDefaultTitle, bottomBar: bottomBar, ...restProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        bottomBar: description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($805b9f255efa1904$var$Description, null, description) : bottomBar,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null),
        ...restProps
    }, children || (showDefaultTitle ? formatMessage((0, $jbwMx.default).knowledgeBase) : null));
}
$805b9f255efa1904$export$fea23bd0b48d9710.defaultProps = {
    actions: undefined,
    bottomBar: undefined,
    children: null,
    showDefaultTitle: true,
    description: undefined,
    onBreadcrumbClicked: undefined
};
var $805b9f255efa1904$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $805b9f255efa1904$export$fea23bd0b48d9710;
const $805b9f255efa1904$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkmgjw _1i4q1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mGzM = parcelRequire("4mGzM");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mGzM.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4mGzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e894dbadf73bd3$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5uXOq = parcelRequire("5uXOq");

var $kvBlW = parcelRequire("kvBlW");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $69e894dbadf73bd3$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvBlW.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvBlW.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvBlW.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvBlW.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvBlW.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvBlW.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $69e894dbadf73bd3$export$2e2bcd8739ae039 = $69e894dbadf73bd3$var$PageHeader;

});
parcelRegister("kvBlW", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $f668b39d4b38db17$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $f668b39d4b38db17$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $f668b39d4b38db17$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $f668b39d4b38db17$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $f668b39d4b38db17$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $f668b39d4b38db17$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");
function $f668b39d4b38db17$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f668b39d4b38db17$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $f668b39d4b38db17$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $f668b39d4b38db17$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $f668b39d4b38db17$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $f668b39d4b38db17$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $f668b39d4b38db17$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $f668b39d4b38db17$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $f668b39d4b38db17$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $f668b39d4b38db17$var$bottomBarStyles = (0, $ii5wQ.xcss)({
    marginBlockStart: 'space.200'
});
const $f668b39d4b38db17$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f668b39d4b38db17$var$outerStyles
    }, children);
};
const $f668b39d4b38db17$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("h1", {
        css: [
            $f668b39d4b38db17$var$titleStyles,
            truncateTitle && $f668b39d4b38db17$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $f668b39d4b38db17$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $f668b39d4b38db17$var$titleWrapperStyles,
            truncateTitle && $f668b39d4b38db17$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $f668b39d4b38db17$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $f668b39d4b38db17$var$titleContainerStyles,
            truncateTitle && $f668b39d4b38db17$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $f668b39d4b38db17$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f668b39d4b38db17$var$actionStyles
    }, children);
};
const $f668b39d4b38db17$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e65Lk.default), {
        xcss: $f668b39d4b38db17$var$bottomBarStyles
    }, children);
};

});




parcelRegister("OuhAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $19f2d1dc625a92a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kbNdD = parcelRequire("kbNdD");

var $6z7Gx = parcelRequire("6z7Gx");

var $8xabp = parcelRequire("8xabp");
const $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbNdD.default), {
        data: {
            context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xabp.default), props));
var $19f2d1dc625a92a7$export$2e2bcd8739ae039 = $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics;

});
parcelRegister("8xabp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4394b6b9f879006e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $goLm2 = parcelRequire("goLm2");

var $4D9xG = parcelRequire("4D9xG");

var $koVbs = parcelRequire("koVbs");

var $i9Ubb = parcelRequire("i9Ubb");

var $13x0I = parcelRequire("13x0I");

var $jam2I = parcelRequire("jam2I");
const $4394b6b9f879006e$export$9277c11b36960dfe = ({ onAuthenticate: onAuthenticate })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onActionClick = ()=>{
        onAuthenticate();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i9Ubb))),
        header: "",
        description: formatMessage((0, $jam2I.default).pageDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goLm2.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4D9xG))), {
                label: "authenticate"
            }),
            appearance: "primary",
            onClick: onActionClick
        }, formatMessage((0, $jam2I.default).primaryAction))
    });
};
var $4394b6b9f879006e$export$2e2bcd8739ae039 = $4394b6b9f879006e$export$9277c11b36960dfe;

});
parcelRegister("4D9xG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35f234dabd30aab6$var$_react = $35f234dabd30aab6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $35f234dabd30aab6$var$_lockLocked = $35f234dabd30aab6$var$_interopRequireDefault((parcelRequire("auvAy")));
function $35f234dabd30aab6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $35f234dabd30aab6$var$LockFilledIcon = (props)=>/*#__PURE__*/ $35f234dabd30aab6$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $35f234dabd30aab6$var$_lockLocked.default
    }));
$35f234dabd30aab6$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $35f234dabd30aab6$var$_default = module.exports.default = $35f234dabd30aab6$var$LockFilledIcon;

});
parcelRegister("auvAy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::416fbcb8404b026ec5d40aeabfb0a441>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a353595c3f68918$var$_react = $7a353595c3f68918$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7a353595c3f68918$var$_UNSAFE_baseNew = $7a353595c3f68918$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $7a353595c3f68918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a353595c3f68918$var$LockLockedIcon = (props)=>/*#__PURE__*/ $7a353595c3f68918$var$_react.default.createElement($7a353595c3f68918$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$7a353595c3f68918$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $7a353595c3f68918$var$_default = module.exports.default = $7a353595c3f68918$var$LockLockedIcon;

});


parcelRegister("i9Ubb", function(module, exports) {
module.exports = new URL("authenticate-confluence.4d07da41.svg", import.meta.url).toString();

});

parcelRegister("13x0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $13dd6aa4f4b38a0c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ktx1d = parcelRequire("ktx1d");

var $gwIPs = parcelRequire("gwIPs");
function $13dd6aa4f4b38a0c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ktx1d.default), {
        maxImageWidth: $13dd6aa4f4b38a0c$export$7e3df82ee760448c,
        maxImageHeight: $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a,
        ...props
    }));
}
$13dd6aa4f4b38a0c$export$2e2bcd8739ae039.defaultProps = {
    isLoading: false,
    primaryAction: undefined,
    secondaryAction: undefined,
    tertiaryAction: undefined
};
const $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a = (0, $gwIPs.gridSize) * 20.5;
const $13dd6aa4f4b38a0c$export$7e3df82ee760448c = (0, $gwIPs.gridSize) * 48;
const $13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ik51pl1 _bhl91wug _qci81jje",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jam2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $a812dd379bbb5f8f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a812dd379bbb5f8f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageDescription: {
        "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.page-description",
        "defaultMessage": "Authenticate with Confluence to access articles from your linked spaces."
    },
    primaryAction: {
        "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.primary-action",
        "defaultMessage": "Authenticate"
    }
});

});





parcelRegister("fxVD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $112a70946b83e16d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kbNdD = parcelRequire("kbNdD");

var $6z7Gx = parcelRequire("6z7Gx");

var $cIhXH = parcelRequire("cIhXH");
const $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbNdD.default), {
        data: {
            attributes: {
                context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cIhXH.default), props));
var $112a70946b83e16d$export$2e2bcd8739ae039 = $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics;

});
parcelRegister("cIhXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $889aaaaf1f3263e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $75gFv = parcelRequire("75gFv");

var $13x0I = parcelRequire("13x0I");

var $hW1Vu = parcelRequire("hW1Vu");
const $889aaaaf1f3263e7$export$e0621c26812fcde2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75gFv))),
        header: formatMessage((0, $hW1Vu.default).applinkErrorHeader),
        description: formatMessage((0, $hW1Vu.default).applinkErrorMessage)
    });
};
var $889aaaaf1f3263e7$export$2e2bcd8739ae039 = $889aaaaf1f3263e7$export$e0621c26812fcde2;

});
parcelRegister("75gFv", function(module, exports) {
module.exports = new URL("error.5b530682.svg", import.meta.url).toString();

});

parcelRegister("hW1Vu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbfeba0604b7d141$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fbfeba0604b7d141$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    applinkErrorHeader: {
        "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-header",
        "defaultMessage": "We couldn\u2019t load this article"
    },
    applinkErrorMessage: {
        "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-message",
        "defaultMessage": "Refresh and try again"
    }
});

});



parcelRegister("8WALy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4715523505b99e61$export$2e2bcd8739ae039);

var $9tOEo = parcelRequire("9tOEo");

var $6z7Gx = parcelRequire("6z7Gx");

var $axsl2 = parcelRequire("axsl2");
const $4715523505b99e61$var$ErrorPageWithAnalytics = (0, $9tOEo.default)({
    attributes: {
        context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
    }
})((0, $axsl2.default));
var $4715523505b99e61$export$2e2bcd8739ae039 = $4715523505b99e61$var$ErrorPageWithAnalytics;

});
parcelRegister("9tOEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2220d181f8eca1$export$2e2bcd8739ae039);

var $jiu8g = parcelRequire("jiu8g");

var $i4iBk = parcelRequire("i4iBk");
var /**
 * @deprecated - Just provide the data when firing analytics events.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d2220d181f8eca1$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, $jiu8g.default)((0, $i4iBk.default)(payload))(WrappedComponent);

});

parcelRegister("axsl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c66f766909105fb1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kbNdD = parcelRequire("kbNdD");

var $4NLf2 = parcelRequire("4NLf2");
var $dUThW = parcelRequire("dUThW");

var $hZHze = parcelRequire("hZHze");

var $jS4lj = parcelRequire("jS4lj");

var $6Ndma = parcelRequire("6Ndma");

var $8RXs9 = parcelRequire("8RXs9");


var $75gFv = parcelRequire("75gFv");

var $iDMMZ = parcelRequire("iDMMZ");

var $13x0I = parcelRequire("13x0I");

var $6geWD = parcelRequire("6geWD");
function $c66f766909105fb1$export$c120a0e80fd44ca6(props) {
    const { intl: intl, error: error, screenName: screenName, attributes: attributes } = props;
    const isKBRouteWithHorizontalNav = (0, $6Ndma.useIsKBRouteWithHorizontalNav)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbNdD.default), {
        data: {
            source: `${screenName}${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
            attributes: attributes ? {
                ...attributes
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NLf2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUThW.default), null, !isKBRouteWithHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default), {
        // @ts-expect-error - TS2769 - No overload matches this call.
        truncateTitle: true,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75gFv))),
        header: intl.formatMessage(error.header),
        description: intl.formatMessage(error.message),
        primaryAction: error.ctaLink && error.ctaText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDMMZ.default), {
            to: error.ctaLink || ''
        }, intl.formatMessage(error.ctaText)) : undefined
    }))));
}
var $c66f766909105fb1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($c66f766909105fb1$export$c120a0e80fd44ca6);

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jiu8g = parcelRequire("jiu8g");
var $2keUK = parcelRequire("2keUK");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $jiu8g.default)({
    componentName: 'view-tracker'
})((0, $2keUK.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("6Ndma", function(module, exports) {

$parcel$export(module.exports, "useIsKBRouteWithHorizontalNav", () => $76f1b69b9a6db003$export$49e43abdbfaa6622);

var $65Ltd = parcelRequire("65Ltd");

var $jIAHH = parcelRequire("jIAHH");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");
const $76f1b69b9a6db003$export$49e43abdbfaa6622 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    return (0, $3HwlS.getWillShowNav4)() && route.group === (0, $65Ltd.ROUTE_GROUPS_SERVICEDESK) && HorizontalNavComponent === (0, $jIAHH.AsyncKbNav);
};

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("iDMMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8906b3331e8371f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS0Qm = parcelRequire("cS0Qm");

var $dIdda = parcelRequire("dIdda");
const $8906b3331e8371f5$var$KnowledgeHubSpaLink = (props)=>{
    const { RouterSubscriber: RouterSubscriber, to: to, children: children, innerRef: innerRef, style: style, replace: replace } = props;
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const path = to.charAt(0) === '/' ? to : `/${to}`;
    return __SPA__ ? // @ts-expect-error - TS2604 - JSX element type 'RouterSubscriber' does not have any construct or call signatures.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match && match.params && match.params.projectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            href: `/jira/servicedesk/projects/${match.params.projectKey}${path}`,
            replace: replace
        }, children || null) : null) : // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS0Qm.default), {
        to: to,
        innerRef: innerRef,
        style: style,
        replace: replace
    }, children);
};
$8906b3331e8371f5$var$KnowledgeHubSpaLink.defaultProps = {
    RouterSubscriber: (0, $dIdda.RouterSubscriber)
};
var $8906b3331e8371f5$export$2e2bcd8739ae039 = $8906b3331e8371f5$var$KnowledgeHubSpaLink;

});
parcelRegister("cS0Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $95eb2eaf9d2a8414$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $aE1Lc = parcelRequire("aE1Lc");

var $7bpAK = parcelRequire("7bpAK");
var $95eb2eaf9d2a8414$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $95eb2eaf9d2a8414$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $95eb2eaf9d2a8414$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95eb2eaf9d2a8414$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95eb2eaf9d2a8414$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $95eb2eaf9d2a8414$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $95eb2eaf9d2a8414$var$Link = function(_React$Component) {
    $95eb2eaf9d2a8414$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $95eb2eaf9d2a8414$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95eb2eaf9d2a8414$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$95eb2eaf9d2a8414$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $95eb2eaf9d2a8414$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $95eb2eaf9d2a8414$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $7bpAK.createLocation)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", $95eb2eaf9d2a8414$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$95eb2eaf9d2a8414$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
    ])
};
$95eb2eaf9d2a8414$var$Link.defaultProps = {
    replace: false
};
$95eb2eaf9d2a8414$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired
        }).isRequired
    }).isRequired
};
var $95eb2eaf9d2a8414$export$2e2bcd8739ae039 = $95eb2eaf9d2a8414$var$Link;

});




parcelRegister("i3iLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $41c7ee176a3c4624$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $9tOEo = parcelRequire("9tOEo");

var $jzjy1 = parcelRequire("jzjy1");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $bC2fB = parcelRequire("bC2fB");

var $6z7Gx = parcelRequire("6z7Gx");

var $7B17s = parcelRequire("7B17s");

var $jkPmE = parcelRequire("jkPmE");

const $41c7ee176a3c4624$var$LazyKnowledgeHubArticleCategoryList = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("lcClb")), {
    moduleId: "./src/packages/servicedesk/knowledge-hub/src/view/knowledge-hub-article-category-list/index.tsx"
});
const $41c7ee176a3c4624$var$KnowledgeHubArticleCategoryListAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "knowledge-hub-article-category-list",
        packageName: "@atlassian/jira-servicedesk-knowledge-hub"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "knowledge-hub-article-category-list",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($41c7ee176a3c4624$var$LazyKnowledgeHubArticleCategoryList, props)));

const $41c7ee176a3c4624$var$LazyKnowledgeHubArticleLabelList = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("3TeJf")), {
    moduleId: "./src/packages/servicedesk/knowledge-hub/src/view/knowledge-hub-article-label-list/index.tsx"
});
const $41c7ee176a3c4624$var$KnowledgeHubArticleLabelListAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "knowledge-hub-article-label-list",
        packageName: "@atlassian/jira-servicedesk-knowledge-hub"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "knowledge-hub-article-label-list",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($41c7ee176a3c4624$var$LazyKnowledgeHubArticleLabelList, props)));
var $41c7ee176a3c4624$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $9tOEo.default)({
    attributes: {
        context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
    }
}), (0, $jzjy1.AnalyticsSubject)('article'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $bC2fB.connect)(()=>({
        KnowledgeHubArticleCategoryList: $41c7ee176a3c4624$var$KnowledgeHubArticleCategoryListAsync,
        KnowledgeHubArticleLabelList: $41c7ee176a3c4624$var$KnowledgeHubArticleLabelListAsync
    }), {}))((0, $jkPmE.default));

});
parcelRegister("jkPmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c9661f02a259bd$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kbNdD = parcelRequire("kbNdD");

var $goLm2 = parcelRequire("goLm2");

var $8pO1a = parcelRequire("8pO1a");

var $4NLf2 = parcelRequire("4NLf2");
var $dUThW = parcelRequire("dUThW");

var $9fYN9 = parcelRequire("9fYN9");

var $jKL06 = parcelRequire("jKL06");

var $hZHze = parcelRequire("hZHze");

var $b6nbP = parcelRequire("b6nbP");

var $8RXs9 = parcelRequire("8RXs9");

var $8n9Eh = parcelRequire("8n9Eh");


var $3TpKp = parcelRequire("3TpKp");

var $6w1ky = parcelRequire("6w1ky");

var $7fyET = parcelRequire("7fyET");

var $c9JME = parcelRequire("c9JME");

var $jbwMx = parcelRequire("jbwMx");

var $6geWD = parcelRequire("6geWD");

var $8qDpT = parcelRequire("8qDpT");

var $6y0Ij = parcelRequire("6y0Ij");
class $a3c9661f02a259bd$export$f4355f2899a3af98 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onEditClicked: undefined,
            onCopyClicked: undefined
        };
    }
    getCategoryIds() {
        if (!this.props.article) return '';
        const categoryIds = // @ts-expect-error - TS2304 - Cannot find name 'Category'.
        this.props.article.categories?.map((category)=>category.id).join(',') || '';
        return categoryIds;
    }
    render() {
        const { intl: intl, onCopyClicked: onCopyClicked, onEditClicked: onEditClicked, KnowledgeHubArticleCategoryList: KnowledgeHubArticleCategoryList, KnowledgeHubArticleLabelList: KnowledgeHubArticleLabelList, onIFrameLoaded: onIFrameLoaded, iframeLoading: iframeLoading, isServer: isServer, projectKey: projectKey, article: article, canViewSpaceUrl: canViewSpaceUrl, spaceKey: propSpaceKey, articleId: articleId } = this.props;
        const { viewUrl: viewUrl, shareUrl: shareUrl, editUrl: editUrl, title: title, categories: categories, id: id, spaceKey: apiSpaceKey, spaceName: spaceName, spaceUrl: spaceUrl, spaceId: spaceId, categoriesSupported: categoriesSupported, isBusy: isBusy, labelState: labelState, isEditable: isEditable } = article || {};
        const isConfluenceServerArticle = isServer;
        const showConfluenceEditLink = isConfluenceServerArticle;
        const hideKnowledgeHubArticleCategoryList = categoriesSupported === false;
        const spaceKey = apiSpaceKey || propSpaceKey;
        if (!iframeLoading) (0, $7fyET.GlobalPageLoadExperience).markFMP();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbNdD.default), {
            data: {
                source: `knowledgeArticle${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
                attributes: {
                    'Category Ids': this.getCategoryIds(),
                    source: 'KB Hub',
                    isConfluenceServer: isServer,
                    spaceId: spaceId
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$FullPageWidthContainer, null, article && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKL06.default), {
            embeddedProduct: "confluence"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.breadcrumbsRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NLf2.default), {
            layout: "fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUThW.default), null, article && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default), {
            showDefaultTitle: false
        }, !isConfluenceServerArticle ? null : title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$GridContainerWithStickyLastGridColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4NLf2.default), {
            layout: "fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUThW.default), {
            medium: 8
        }, article || spaceKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isConfluenceServerArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qDpT.ConfluenceEmbeddedViewWrapper), {
            spaceKey: spaceKey,
            pageId: articleId,
            breadcrumbsRef: this.breadcrumbsRef,
            projectKey: projectKey,
            spaceId: spaceId,
            onIFrameLoaded: onIFrameLoaded
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledConfluenceArticle // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        , {
            src: viewUrl,
            onIFrameLoaded: onIFrameLoaded
        })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUThW.default), {
            medium: 4
        }, article && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$Aside, null, showConfluenceEditLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8n9Eh.default // @ts-expect-error - TS2769 - No overload matches this call.
        ), {
            href: editUrl,
            onClick: onEditClicked
        }, intl.formatMessage((0, $jbwMx.default).editInConfluence))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pO1a.default), {
            size: "small"
        }, intl.formatMessage((0, $6y0Ij.default).shareArticle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledFieldCopyText, {
            shouldFitContainer: true,
            label: intl.formatMessage((0, $6y0Ij.default).shareableUrlLabel),
            tooltipLabel: intl.formatMessage((0, $6y0Ij.default).copyArticleUrlLabel),
            value: shareUrl,
            onCopyClick: onCopyClicked
        })), spaceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pO1a.default), {
            size: "small"
        }, intl.formatMessage((0, $6y0Ij.default).belongsToThisSpace)), canViewSpaceUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledSpaceInfo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fYN9.default), {
            content: intl.formatMessage((0, $6y0Ij.default).tooltipText)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goLm2.default), {
            href: spaceUrl,
            target: "_blank",
            appearance: "link",
            rel: "noopener noreferrer nofollow",
            spacing: "none"
        }, spaceName))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledSpaceInfo, null, spaceName)), categories && !hideKnowledgeHubArticleCategoryList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeHubArticleCategoryList // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        , {
            articleId: id,
            currentCategories: categories,
            isUpdatingCategories: isBusy,
            isEditable: !!isEditable
        })), !isConfluenceServerArticle && labelState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeHubArticleLabelList, {
            isEditable: !!isEditable,
            labelState: labelState,
            projectKey: projectKey || '',
            articleId: id,
            spaceKey: spaceKey || ''
        }))))))), !iframeLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9JME.DraftArticleSuccessFlags), null)));
    }
    constructor(...args){
        super(...args);
        this.breadcrumbsRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
}
var $a3c9661f02a259bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($a3c9661f02a259bd$export$f4355f2899a3af98);
const $a3c9661f02a259bd$var$Aside = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "aside", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c9661f02a259bd$var$AsideSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n3td1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c9661f02a259bd$var$FullPageWidthContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1kx0 _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c9661f02a259bd$var$GridContainerWithStickyLastGridColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16tz1if8 _1u0cxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c9661f02a259bd$var$StyledSpaceInfo = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c9661f02a259bd$var$StyledFieldCopyText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $b6nbP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkr5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c9661f02a259bd$var$StyledConfluenceArticle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6w1ky.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jKL06", function(module, exports) {

$parcel$export(module.exports, "default", () => $1592c614284434f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8wYzC = parcelRequire("8wYzC");
class $1592c614284434f1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        (0, $8wYzC.set)(this.props.embeddedProduct).catch((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }
    componentWillUnmount() {
        (0, $8wYzC.clear)().catch((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }
    render() {
        return null;
    }
}

});
parcelRegister("8wYzC", function(module, exports) {

$parcel$export(module.exports, "set", () => $49f86daa66e50eb0$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "clear", () => $49f86daa66e50eb0$export$42ffd38884aecdac);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");

var $dJl1T = parcelRequire("dJl1T");

var $g9E9n = parcelRequire("g9E9n");
const $49f86daa66e50eb0$export$7271276960377470 = 'jira.analytics.embedded-product';
let $49f86daa66e50eb0$var$cachedResolver;
const $49f86daa66e50eb0$export$5a1ebbbe9b82546e = ()=>{
    if ($49f86daa66e50eb0$var$cachedResolver) return $49f86daa66e50eb0$var$cachedResolver;
    const wrmKeys = [
        'wrc!jira.webresources:top-same-origin-window',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
    ];
    // eslint-disable-next-line jira/wrm/no-load-bridge
    $49f86daa66e50eb0$var$cachedResolver = (0, $6BZYo.loadBridge)({
        name: 'jira/analytics/embedded-product-resolver',
        wrmKeys: wrmKeys,
        shouldLogError: false
    }).then((embeddedProductResolver)=>{
        const updateValue = (embeddedProduct)=>{
            // Set embedded product fn to reset the "track" interval (check analytics-web-client sources for more details).
            // User has to be at least active for 2 seconds before we can submit the track event.
            embeddedProduct ? (0, $g9E9n.getAnalyticsWebClient)().setEmbeddedProduct(embeddedProduct) : (0, $g9E9n.getAnalyticsWebClient)().clearEmbeddedProduct();
        };
        updateValue(embeddedProductResolver.get());
        embeddedProductResolver.onChange(updateValue);
        return embeddedProductResolver;
    }).catch((e)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData($49f86daa66e50eb0$export$7271276960377470, 'Cannot get embedded product resolver via bridge', e);
        throw e;
    });
    return $49f86daa66e50eb0$var$cachedResolver;
};
const $49f86daa66e50eb0$export$adaa4cf7ef1b65be = (embeddedProduct)=>$49f86daa66e50eb0$export$5a1ebbbe9b82546e().then((resolver)=>resolver.set(embeddedProduct));
const $49f86daa66e50eb0$export$42ffd38884aecdac = ()=>$49f86daa66e50eb0$export$5a1ebbbe9b82546e().then((resolver)=>resolver.clear());
const $49f86daa66e50eb0$export$5428ebc594af9d04 = (value)=>{
    $49f86daa66e50eb0$var$cachedResolver = value;
};

});


parcelRegister("b6nbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75a19e3ebf5c6c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7EEmi = parcelRequire("7EEmi");
class $f75a19e3ebf5c6c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EEmi.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            copied: false,
            copyFailed: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        };
        this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("7EEmi", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $4e1842edd397110a$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $4e1842edd397110a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $74FvT = parcelRequire("74FvT");

var $hu33e = parcelRequire("hu33e");

var $dvaUE = parcelRequire("dvaUE");

var $9fYN9 = parcelRequire("9fYN9");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $4gmb8 = parcelRequire("4gmb8");

var $az4zD = parcelRequire("az4zD");


var $gT8ZY = parcelRequire("gT8ZY");

var $9iXoh = parcelRequire("9iXoh");
class $4e1842edd397110a$export$71579edc8f362e35 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            id: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$export$2d5d2ba3c7c8c40b, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hu33e))), {
                label: tooltipLabel
            })),
            onClick: onCopyClick
        });
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvaUE.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fYN9.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel)
        }, copyButton || this.renderDefaultButton())));
    }
}
var $4e1842edd397110a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4e1842edd397110a$export$71579edc8f362e35);
const $4e1842edd397110a$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74FvT.default), {
        ...props,
        theme: (0, $4gmb8.getTheme)({
            buttonStyles: {
                default: {
                    height: `${(0, $gwIPs.gridSize) * 5}px`,
                    width: `${(0, $gwIPs.gridSize) * 5}px`
                }
            }
        })
    });
$4e1842edd397110a$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e1842edd397110a$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e1842edd397110a$var$FlexGrow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hu33e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cba79ae2b60c685a$var$_react = $cba79ae2b60c685a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $cba79ae2b60c685a$var$_copy = $cba79ae2b60c685a$var$_interopRequireDefault((parcelRequire("aqrFt")));
function $cba79ae2b60c685a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cba79ae2b60c685a$var$CopyIcon = (props)=>/*#__PURE__*/ $cba79ae2b60c685a$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $cba79ae2b60c685a$var$_copy.default
    }));
$cba79ae2b60c685a$var$CopyIcon.displayName = 'CopyIcon';
var $cba79ae2b60c685a$var$_default = module.exports.default = $cba79ae2b60c685a$var$CopyIcon;

});
parcelRegister("aqrFt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7971cb5fd0a3c4f5$var$_react = $7971cb5fd0a3c4f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7971cb5fd0a3c4f5$var$_UNSAFE_baseNew = $7971cb5fd0a3c4f5$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $7971cb5fd0a3c4f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7971cb5fd0a3c4f5$var$CopyIcon = (props)=>/*#__PURE__*/ $7971cb5fd0a3c4f5$var$_react.default.createElement($7971cb5fd0a3c4f5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$7971cb5fd0a3c4f5$var$CopyIcon.displayName = 'CopyIcon';
var $7971cb5fd0a3c4f5$var$_default = module.exports.default = $7971cb5fd0a3c4f5$var$CopyIcon;

});


parcelRegister("dvaUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76b2dcab00efc18$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7UFJi = parcelRequire("7UFJi");

var $0xqmn = parcelRequire("0xqmn");
const $a76b2dcab00efc18$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $a76b2dcab00efc18$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $7UFJi.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$a76b2dcab00efc18$var$analyticsParams
    });
    const handleOnBlur = (0, $7UFJi.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$a76b2dcab00efc18$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $5uXOq.useMemo)(()=>(0, $0xqmn.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $0xqmn.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $a76b2dcab00efc18$export$2e2bcd8739ae039 = $a76b2dcab00efc18$var$Textfield;

});
parcelRegister("0xqmn", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $4debfbd4861889ad$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $4debfbd4861889ad$export$3eeb47dc8e6249d9);

const $4debfbd4861889ad$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $dbda9f692ace54dd$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $4debfbd4861889ad$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $4debfbd4861889ad$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $4debfbd4861889ad$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $4debfbd4861889ad$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $4debfbd4861889ad$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $4debfbd4861889ad$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $4debfbd4861889ad$var$backgroundColor[appearance],
        borderColor: $4debfbd4861889ad$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $dbda9f692ace54dd$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $4debfbd4861889ad$var$backgroundColorHover[appearance],
            borderColor: $4debfbd4861889ad$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $4debfbd4861889ad$var$backgroundColorFocus[appearance],
            borderColor: $4debfbd4861889ad$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$4debfbd4861889ad$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $dbda9f692ace54dd$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $dbda9f692ace54dd$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $dbda9f692ace54dd$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $dbda9f692ace54dd$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $dbda9f692ace54dd$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $dbda9f692ace54dd$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $dbda9f692ace54dd$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $4debfbd4861889ad$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $4debfbd4861889ad$var$getMaxWidth = (width)=>!width ? `100%` : width in $4debfbd4861889ad$var$widthMap ? $4debfbd4861889ad$var$widthMap[width] : +width;
const $4debfbd4861889ad$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$4debfbd4861889ad$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $4debfbd4861889ad$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $4debfbd4861889ad$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $dbda9f692ace54dd$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});
var $dbda9f692ace54dd$exports = {};

$parcel$export($dbda9f692ace54dd$exports, "R50", () => $dbda9f692ace54dd$export$4b84fd0e2c617bd);
$parcel$export($dbda9f692ace54dd$exports, "R75", () => $dbda9f692ace54dd$export$b34b069eff244586);
$parcel$export($dbda9f692ace54dd$exports, "R100", () => $dbda9f692ace54dd$export$be802dd0d8b57f35);
$parcel$export($dbda9f692ace54dd$exports, "R200", () => $dbda9f692ace54dd$export$60847d42f9da92a6);
$parcel$export($dbda9f692ace54dd$exports, "R300", () => $dbda9f692ace54dd$export$4a7404f376229999);
$parcel$export($dbda9f692ace54dd$exports, "R400", () => $dbda9f692ace54dd$export$2010d0fb4295b346);
$parcel$export($dbda9f692ace54dd$exports, "R500", () => $dbda9f692ace54dd$export$2837b5a1a71d5c02);
$parcel$export($dbda9f692ace54dd$exports, "Y50", () => $dbda9f692ace54dd$export$8d9596b529bbb9cf);
$parcel$export($dbda9f692ace54dd$exports, "Y75", () => $dbda9f692ace54dd$export$41060a744ab0b7ae);
$parcel$export($dbda9f692ace54dd$exports, "Y100", () => $dbda9f692ace54dd$export$1cc05bbbf340e559);
$parcel$export($dbda9f692ace54dd$exports, "Y200", () => $dbda9f692ace54dd$export$5aae31392d72caaa);
$parcel$export($dbda9f692ace54dd$exports, "Y300", () => $dbda9f692ace54dd$export$c6930421db9fa514);
$parcel$export($dbda9f692ace54dd$exports, "Y400", () => $dbda9f692ace54dd$export$59619663aa6500fb);
$parcel$export($dbda9f692ace54dd$exports, "Y500", () => $dbda9f692ace54dd$export$874739ea9e379ab6);
$parcel$export($dbda9f692ace54dd$exports, "G50", () => $dbda9f692ace54dd$export$8a6341c32b6a3ee6);
$parcel$export($dbda9f692ace54dd$exports, "G75", () => $dbda9f692ace54dd$export$69a3bf21b9686c2b);
$parcel$export($dbda9f692ace54dd$exports, "G100", () => $dbda9f692ace54dd$export$afbce1382ec95f73);
$parcel$export($dbda9f692ace54dd$exports, "G200", () => $dbda9f692ace54dd$export$747d86715d4175de);
$parcel$export($dbda9f692ace54dd$exports, "G300", () => $dbda9f692ace54dd$export$940e1f69e873f202);
$parcel$export($dbda9f692ace54dd$exports, "G400", () => $dbda9f692ace54dd$export$a49394138f7b8e85);
$parcel$export($dbda9f692ace54dd$exports, "G500", () => $dbda9f692ace54dd$export$6fa04827ac68a4fb);
$parcel$export($dbda9f692ace54dd$exports, "B50", () => $dbda9f692ace54dd$export$226de0355ed012f8);
$parcel$export($dbda9f692ace54dd$exports, "B75", () => $dbda9f692ace54dd$export$8c13c2ee36917869);
$parcel$export($dbda9f692ace54dd$exports, "B100", () => $dbda9f692ace54dd$export$ecfc1dff386a3e7a);
$parcel$export($dbda9f692ace54dd$exports, "B200", () => $dbda9f692ace54dd$export$215b7063051591f1);
$parcel$export($dbda9f692ace54dd$exports, "B300", () => $dbda9f692ace54dd$export$e62e8919cca44969);
$parcel$export($dbda9f692ace54dd$exports, "B400", () => $dbda9f692ace54dd$export$b3de0ae08da2ce64);
$parcel$export($dbda9f692ace54dd$exports, "B500", () => $dbda9f692ace54dd$export$a6ee3d71bc067634);
$parcel$export($dbda9f692ace54dd$exports, "B600", () => $dbda9f692ace54dd$export$67f15409e87642a1);
$parcel$export($dbda9f692ace54dd$exports, "B700", () => $dbda9f692ace54dd$export$f0539dbc42dbb067);
$parcel$export($dbda9f692ace54dd$exports, "P50", () => $dbda9f692ace54dd$export$363e4475840015bb);
$parcel$export($dbda9f692ace54dd$exports, "P75", () => $dbda9f692ace54dd$export$4b0a4417ed59760f);
$parcel$export($dbda9f692ace54dd$exports, "P100", () => $dbda9f692ace54dd$export$6011520a64d9a187);
$parcel$export($dbda9f692ace54dd$exports, "P200", () => $dbda9f692ace54dd$export$a7175d4e9206bc80);
$parcel$export($dbda9f692ace54dd$exports, "P300", () => $dbda9f692ace54dd$export$b48405b95304b5a1);
$parcel$export($dbda9f692ace54dd$exports, "P400", () => $dbda9f692ace54dd$export$c71e4279dd54a18d);
$parcel$export($dbda9f692ace54dd$exports, "P500", () => $dbda9f692ace54dd$export$147899de772240ec);
$parcel$export($dbda9f692ace54dd$exports, "T50", () => $dbda9f692ace54dd$export$2cf711fe14c66f06);
$parcel$export($dbda9f692ace54dd$exports, "T75", () => $dbda9f692ace54dd$export$7a8f4d33f6f9772c);
$parcel$export($dbda9f692ace54dd$exports, "T100", () => $dbda9f692ace54dd$export$776c9c497ef08533);
$parcel$export($dbda9f692ace54dd$exports, "T200", () => $dbda9f692ace54dd$export$69cb3ca10c1e330e);
$parcel$export($dbda9f692ace54dd$exports, "T300", () => $dbda9f692ace54dd$export$9dc1ef0f3f48059b);
$parcel$export($dbda9f692ace54dd$exports, "T400", () => $dbda9f692ace54dd$export$7c835c78b6fcdef8);
$parcel$export($dbda9f692ace54dd$exports, "T500", () => $dbda9f692ace54dd$export$6036577f95c3877e);
$parcel$export($dbda9f692ace54dd$exports, "N0", () => $dbda9f692ace54dd$export$29a4f05edc054374);
$parcel$export($dbda9f692ace54dd$exports, "N10", () => $dbda9f692ace54dd$export$e655ef011c4aa1a2);
$parcel$export($dbda9f692ace54dd$exports, "N20", () => $dbda9f692ace54dd$export$9fdfb749e33cdf97);
$parcel$export($dbda9f692ace54dd$exports, "N30", () => $dbda9f692ace54dd$export$3e51e8f1440314ba);
$parcel$export($dbda9f692ace54dd$exports, "N40", () => $dbda9f692ace54dd$export$1ce2d1575d444ceb);
$parcel$export($dbda9f692ace54dd$exports, "N50", () => $dbda9f692ace54dd$export$8754fc7e6d8b3000);
$parcel$export($dbda9f692ace54dd$exports, "N60", () => $dbda9f692ace54dd$export$c2e91cbeada39b8b);
$parcel$export($dbda9f692ace54dd$exports, "N70", () => $dbda9f692ace54dd$export$5f71e19f3a7ad9de);
$parcel$export($dbda9f692ace54dd$exports, "N80", () => $dbda9f692ace54dd$export$eaa8c8a70ac22806);
$parcel$export($dbda9f692ace54dd$exports, "N90", () => $dbda9f692ace54dd$export$7c87d337fb91a97d);
$parcel$export($dbda9f692ace54dd$exports, "N100", () => $dbda9f692ace54dd$export$d6447c357493214f);
$parcel$export($dbda9f692ace54dd$exports, "N200", () => $dbda9f692ace54dd$export$f563ee71e9ee74cd);
$parcel$export($dbda9f692ace54dd$exports, "N300", () => $dbda9f692ace54dd$export$e2ef2124cf4024b1);
$parcel$export($dbda9f692ace54dd$exports, "N400", () => $dbda9f692ace54dd$export$eece5f492e429f08);
$parcel$export($dbda9f692ace54dd$exports, "N500", () => $dbda9f692ace54dd$export$c39c0fe0f26207ae);
$parcel$export($dbda9f692ace54dd$exports, "N600", () => $dbda9f692ace54dd$export$7090862dc3038a9f);
$parcel$export($dbda9f692ace54dd$exports, "N700", () => $dbda9f692ace54dd$export$ad0bacf983b7ddaa);
$parcel$export($dbda9f692ace54dd$exports, "N800", () => $dbda9f692ace54dd$export$7d61b15e0da132af);
$parcel$export($dbda9f692ace54dd$exports, "N900", () => $dbda9f692ace54dd$export$fbda843f0a27fe96);
$parcel$export($dbda9f692ace54dd$exports, "N10A", () => $dbda9f692ace54dd$export$791e57b27ca738ef);
$parcel$export($dbda9f692ace54dd$exports, "N20A", () => $dbda9f692ace54dd$export$8d43898f60b96a82);
$parcel$export($dbda9f692ace54dd$exports, "N30A", () => $dbda9f692ace54dd$export$920c0d5c49070351);
$parcel$export($dbda9f692ace54dd$exports, "N40A", () => $dbda9f692ace54dd$export$46987b49aab6d1a8);
$parcel$export($dbda9f692ace54dd$exports, "N50A", () => $dbda9f692ace54dd$export$7d3359664e8bb0e5);
$parcel$export($dbda9f692ace54dd$exports, "N60A", () => $dbda9f692ace54dd$export$d2d3bedfb276cac0);
$parcel$export($dbda9f692ace54dd$exports, "N70A", () => $dbda9f692ace54dd$export$6e5e7499ff054f6d);
$parcel$export($dbda9f692ace54dd$exports, "N80A", () => $dbda9f692ace54dd$export$59264b346c877fa7);
$parcel$export($dbda9f692ace54dd$exports, "N90A", () => $dbda9f692ace54dd$export$d092757d7c64925c);
$parcel$export($dbda9f692ace54dd$exports, "N100A", () => $dbda9f692ace54dd$export$486ab785e4bac3c6);
$parcel$export($dbda9f692ace54dd$exports, "N200A", () => $dbda9f692ace54dd$export$fba592bbc6419fea);
$parcel$export($dbda9f692ace54dd$exports, "N300A", () => $dbda9f692ace54dd$export$13609db0e6812ab8);
$parcel$export($dbda9f692ace54dd$exports, "N400A", () => $dbda9f692ace54dd$export$fbae4efaa892d883);
$parcel$export($dbda9f692ace54dd$exports, "N500A", () => $dbda9f692ace54dd$export$f13946d26f440ce6);
$parcel$export($dbda9f692ace54dd$exports, "N600A", () => $dbda9f692ace54dd$export$19f58225ac52a306);
$parcel$export($dbda9f692ace54dd$exports, "N700A", () => $dbda9f692ace54dd$export$6384f09da70e7b62);
$parcel$export($dbda9f692ace54dd$exports, "N800A", () => $dbda9f692ace54dd$export$d0dccc730683edc2);
$parcel$export($dbda9f692ace54dd$exports, "DN900", () => $dbda9f692ace54dd$export$2f6319cf7d736c2a);
$parcel$export($dbda9f692ace54dd$exports, "DN800", () => $dbda9f692ace54dd$export$95126bc8884d6634);
$parcel$export($dbda9f692ace54dd$exports, "DN700", () => $dbda9f692ace54dd$export$8338d8c35d44ff1);
$parcel$export($dbda9f692ace54dd$exports, "DN600", () => $dbda9f692ace54dd$export$5368d76ae4fbbda7);
$parcel$export($dbda9f692ace54dd$exports, "DN500", () => $dbda9f692ace54dd$export$9f0a771d16ec8d36);
$parcel$export($dbda9f692ace54dd$exports, "DN400", () => $dbda9f692ace54dd$export$abcf8c38338b4aa5);
$parcel$export($dbda9f692ace54dd$exports, "DN300", () => $dbda9f692ace54dd$export$97e81faa16a182c7);
$parcel$export($dbda9f692ace54dd$exports, "DN200", () => $dbda9f692ace54dd$export$bfe21c59123ecf33);
$parcel$export($dbda9f692ace54dd$exports, "DN100", () => $dbda9f692ace54dd$export$ee82aa2ea6a1558);
$parcel$export($dbda9f692ace54dd$exports, "DN90", () => $dbda9f692ace54dd$export$682927c6ed76be02);
$parcel$export($dbda9f692ace54dd$exports, "DN80", () => $dbda9f692ace54dd$export$91fd9994c5be9757);
$parcel$export($dbda9f692ace54dd$exports, "DN70", () => $dbda9f692ace54dd$export$d281fbfe3cff2df6);
$parcel$export($dbda9f692ace54dd$exports, "DN60", () => $dbda9f692ace54dd$export$3902c91d8b98a753);
$parcel$export($dbda9f692ace54dd$exports, "DN50", () => $dbda9f692ace54dd$export$8e8133c1ba5845b5);
$parcel$export($dbda9f692ace54dd$exports, "DN40", () => $dbda9f692ace54dd$export$33ff357f6620b39);
$parcel$export($dbda9f692ace54dd$exports, "DN30", () => $dbda9f692ace54dd$export$633847cf062b69e0);
$parcel$export($dbda9f692ace54dd$exports, "DN20", () => $dbda9f692ace54dd$export$9776a6e503bdbf76);
$parcel$export($dbda9f692ace54dd$exports, "DN10", () => $dbda9f692ace54dd$export$6c813d5160dff5db);
$parcel$export($dbda9f692ace54dd$exports, "DN0", () => $dbda9f692ace54dd$export$3d4f271a500072a);
$parcel$export($dbda9f692ace54dd$exports, "DN800A", () => $dbda9f692ace54dd$export$fe151285c22759ec);
$parcel$export($dbda9f692ace54dd$exports, "DN700A", () => $dbda9f692ace54dd$export$a101c6190d0da34);
$parcel$export($dbda9f692ace54dd$exports, "DN600A", () => $dbda9f692ace54dd$export$4b16f52932fda51);
$parcel$export($dbda9f692ace54dd$exports, "DN500A", () => $dbda9f692ace54dd$export$a74bcd7b9845b0d8);
$parcel$export($dbda9f692ace54dd$exports, "DN400A", () => $dbda9f692ace54dd$export$9209c179316d1751);
$parcel$export($dbda9f692ace54dd$exports, "DN300A", () => $dbda9f692ace54dd$export$88f55133f636c8dd);
$parcel$export($dbda9f692ace54dd$exports, "DN200A", () => $dbda9f692ace54dd$export$51126f85d1009512);
$parcel$export($dbda9f692ace54dd$exports, "DN100A", () => $dbda9f692ace54dd$export$a069b547bd23af78);
$parcel$export($dbda9f692ace54dd$exports, "DN90A", () => $dbda9f692ace54dd$export$40cce05af3b2600a);
$parcel$export($dbda9f692ace54dd$exports, "DN80A", () => $dbda9f692ace54dd$export$b78942185925a0d);
$parcel$export($dbda9f692ace54dd$exports, "DN70A", () => $dbda9f692ace54dd$export$e058fb44b8eaafca);
$parcel$export($dbda9f692ace54dd$exports, "DN60A", () => $dbda9f692ace54dd$export$92b0b8de26920c18);
$parcel$export($dbda9f692ace54dd$exports, "DN50A", () => $dbda9f692ace54dd$export$67564f7459d3fc9e);
$parcel$export($dbda9f692ace54dd$exports, "DN40A", () => $dbda9f692ace54dd$export$77868e1ca884ffa3);
$parcel$export($dbda9f692ace54dd$exports, "DN30A", () => $dbda9f692ace54dd$export$2afd71d7d3ea2cd5);
$parcel$export($dbda9f692ace54dd$exports, "DN20A", () => $dbda9f692ace54dd$export$f2a0acaab9972c70);
$parcel$export($dbda9f692ace54dd$exports, "DN10A", () => $dbda9f692ace54dd$export$9ab70e67d6475361);
$parcel$export($dbda9f692ace54dd$exports, "T30", () => $dbda9f692ace54dd$export$d2adc5dedf09fced);
$parcel$export($dbda9f692ace54dd$exports, "L50", () => $dbda9f692ace54dd$export$f51762073d2bb381);
$parcel$export($dbda9f692ace54dd$exports, "L75", () => $dbda9f692ace54dd$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $dbda9f692ace54dd$export$4b84fd0e2c617bd = '#FFEBE6';
const $dbda9f692ace54dd$export$b34b069eff244586 = '#FFBDAD';
const $dbda9f692ace54dd$export$be802dd0d8b57f35 = '#FF8F73';
const $dbda9f692ace54dd$export$60847d42f9da92a6 = '#FF7452';
const $dbda9f692ace54dd$export$4a7404f376229999 = '#FF5630';
const $dbda9f692ace54dd$export$2010d0fb4295b346 = '#DE350B';
const $dbda9f692ace54dd$export$2837b5a1a71d5c02 = '#BF2600';
const $dbda9f692ace54dd$export$8d9596b529bbb9cf = '#FFFAE6';
const $dbda9f692ace54dd$export$41060a744ab0b7ae = '#FFF0B3';
const $dbda9f692ace54dd$export$1cc05bbbf340e559 = '#FFE380';
const $dbda9f692ace54dd$export$5aae31392d72caaa = '#FFC400';
const $dbda9f692ace54dd$export$c6930421db9fa514 = '#FFAB00';
const $dbda9f692ace54dd$export$59619663aa6500fb = '#FF991F';
const $dbda9f692ace54dd$export$874739ea9e379ab6 = '#FF8B00';
const $dbda9f692ace54dd$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dbda9f692ace54dd$export$69a3bf21b9686c2b = '#ABF5D1';
const $dbda9f692ace54dd$export$afbce1382ec95f73 = '#79F2C0';
const $dbda9f692ace54dd$export$747d86715d4175de = '#57D9A3';
const $dbda9f692ace54dd$export$940e1f69e873f202 = '#36B37E';
const $dbda9f692ace54dd$export$a49394138f7b8e85 = '#00875A';
const $dbda9f692ace54dd$export$6fa04827ac68a4fb = '#006644';
const $dbda9f692ace54dd$export$226de0355ed012f8 = '#DEEBFF';
const $dbda9f692ace54dd$export$8c13c2ee36917869 = '#B3D4FF';
const $dbda9f692ace54dd$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dbda9f692ace54dd$export$215b7063051591f1 = '#2684FF';
const $dbda9f692ace54dd$export$e62e8919cca44969 = '#0065FF';
const $dbda9f692ace54dd$export$b3de0ae08da2ce64 = '#0052CC';
const $dbda9f692ace54dd$export$a6ee3d71bc067634 = '#0747A6';
const $dbda9f692ace54dd$export$67f15409e87642a1 = '#669DF1';
const $dbda9f692ace54dd$export$f0539dbc42dbb067 = '#8FB8F6';
const $dbda9f692ace54dd$export$363e4475840015bb = '#EAE6FF';
const $dbda9f692ace54dd$export$4b0a4417ed59760f = '#C0B6F2';
const $dbda9f692ace54dd$export$6011520a64d9a187 = '#998DD9';
const $dbda9f692ace54dd$export$a7175d4e9206bc80 = '#8777D9';
const $dbda9f692ace54dd$export$b48405b95304b5a1 = '#6554C0';
const $dbda9f692ace54dd$export$c71e4279dd54a18d = '#5243AA';
const $dbda9f692ace54dd$export$147899de772240ec = '#403294';
const $dbda9f692ace54dd$export$2cf711fe14c66f06 = '#E6FCFF';
const $dbda9f692ace54dd$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dbda9f692ace54dd$export$776c9c497ef08533 = '#79E2F2';
const $dbda9f692ace54dd$export$69cb3ca10c1e330e = '#00C7E6';
const $dbda9f692ace54dd$export$9dc1ef0f3f48059b = '#00B8D9';
const $dbda9f692ace54dd$export$7c835c78b6fcdef8 = '#00A3BF';
const $dbda9f692ace54dd$export$6036577f95c3877e = '#008DA6';
const $dbda9f692ace54dd$export$29a4f05edc054374 = '#FFFFFF';
const $dbda9f692ace54dd$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dbda9f692ace54dd$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dbda9f692ace54dd$export$3e51e8f1440314ba = '#EBECF0';
const $dbda9f692ace54dd$export$1ce2d1575d444ceb = '#DFE1E6';
const $dbda9f692ace54dd$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dbda9f692ace54dd$export$c2e91cbeada39b8b = '#B3BAC5';
const $dbda9f692ace54dd$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dbda9f692ace54dd$export$eaa8c8a70ac22806 = '#97A0AF';
const $dbda9f692ace54dd$export$7c87d337fb91a97d = '#8993A4';
const $dbda9f692ace54dd$export$d6447c357493214f = '#7A869A';
const $dbda9f692ace54dd$export$f563ee71e9ee74cd = '#6B778C';
const $dbda9f692ace54dd$export$e2ef2124cf4024b1 = '#5E6C84';
const $dbda9f692ace54dd$export$eece5f492e429f08 = '#505F79';
const $dbda9f692ace54dd$export$c39c0fe0f26207ae = '#42526E';
const $dbda9f692ace54dd$export$7090862dc3038a9f = '#344563';
const $dbda9f692ace54dd$export$ad0bacf983b7ddaa = '#253858';
const $dbda9f692ace54dd$export$7d61b15e0da132af = '#172B4D';
const $dbda9f692ace54dd$export$fbda843f0a27fe96 = '#091E42';
const $dbda9f692ace54dd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dbda9f692ace54dd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dbda9f692ace54dd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dbda9f692ace54dd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dbda9f692ace54dd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dbda9f692ace54dd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dbda9f692ace54dd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dbda9f692ace54dd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dbda9f692ace54dd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dbda9f692ace54dd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dbda9f692ace54dd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dbda9f692ace54dd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dbda9f692ace54dd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dbda9f692ace54dd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dbda9f692ace54dd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dbda9f692ace54dd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dbda9f692ace54dd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dbda9f692ace54dd$export$2f6319cf7d736c2a = '#E6EDFA';
const $dbda9f692ace54dd$export$95126bc8884d6634 = '#DCE5F5';
const $dbda9f692ace54dd$export$8338d8c35d44ff1 = '#CED9EB';
const $dbda9f692ace54dd$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dbda9f692ace54dd$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dbda9f692ace54dd$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dbda9f692ace54dd$export$97e81faa16a182c7 = '#8C9CB8';
const $dbda9f692ace54dd$export$bfe21c59123ecf33 = '#7988A3';
const $dbda9f692ace54dd$export$ee82aa2ea6a1558 = '#67758F';
const $dbda9f692ace54dd$export$682927c6ed76be02 = '#56637A';
const $dbda9f692ace54dd$export$91fd9994c5be9757 = '#455166';
const $dbda9f692ace54dd$export$d281fbfe3cff2df6 = '#3B475C';
const $dbda9f692ace54dd$export$3902c91d8b98a753 = '#313D52';
const $dbda9f692ace54dd$export$8e8133c1ba5845b5 = '#283447';
const $dbda9f692ace54dd$export$33ff357f6620b39 = '#202B3D';
const $dbda9f692ace54dd$export$633847cf062b69e0 = '#1B2638';
const $dbda9f692ace54dd$export$9776a6e503bdbf76 = '#121A29';
const $dbda9f692ace54dd$export$6c813d5160dff5db = '#0E1624';
const $dbda9f692ace54dd$export$3d4f271a500072a = '#0D1424';
const $dbda9f692ace54dd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dbda9f692ace54dd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dbda9f692ace54dd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dbda9f692ace54dd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dbda9f692ace54dd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dbda9f692ace54dd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dbda9f692ace54dd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dbda9f692ace54dd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dbda9f692ace54dd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dbda9f692ace54dd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dbda9f692ace54dd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dbda9f692ace54dd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dbda9f692ace54dd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dbda9f692ace54dd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dbda9f692ace54dd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dbda9f692ace54dd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dbda9f692ace54dd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dbda9f692ace54dd$export$d2adc5dedf09fced = '#292A2E';
const $dbda9f692ace54dd$export$f51762073d2bb381 = '#94C748';
const $dbda9f692ace54dd$export$95e26d54def96891 = '#B3DF72';



parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");


var $8KFiV = parcelRequire("8KFiV");

var $gwIPs = parcelRequire("gwIPs");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$LabelText = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $8KFiV.h200)()} display:block;font-family:${(0, $gwIPs.fontFamily)};margin:0;${(0, $47bDC.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$RequiredIndicator = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $dbda9f692ace54dd$exports).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $gwIPs.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';

});

parcelRegister("4gmb8", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $26e3b01c3b885768$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $26e3b01c3b885768$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $dbda9f692ace54dd$exports).P400,
            '> span': {
                color: (0, $dbda9f692ace54dd$exports).N0
            }
        }
    };
    return theme;
};
const $26e3b01c3b885768$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $26e3b01c3b885768$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $26e3b01c3b885768$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

const $68788ede79b59f1f$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("gT8ZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb069c8c90804ba8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb069c8c90804ba8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("9iXoh", function(module, exports) {

$parcel$export(module.exports, "Root", () => $d3bb6eb164541ffa$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $d3bb6eb164541ffa$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        userSelect: 'none'
    }) : '');
const $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});



parcelRegister("8n9Eh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef60ceb7a2a29db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $goLm2 = parcelRequire("goLm2");

var $aa6tf = parcelRequire("aa6tf");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $9fYN9 = parcelRequire("9fYN9");

var $az4zD = parcelRequire("az4zD");

var $jsotm = parcelRequire("jsotm");
const $0ef60ceb7a2a29db$export$2c7b2957f409c48f = ({ href: href, children: children, intl: intl, onClick: onClick, appearance: appearance, spacing: spacing, showShortcutIcon: showShortcutIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fYN9.default), {
        tag: "span",
        content: intl.formatMessage((0, $jsotm.default).opensInNewWindow),
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goLm2.default), {
        href: href,
        appearance: appearance,
        target: "_blank",
        spacing: spacing,
        onClick: onClick,
        iconAfter: showShortcutIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e65Lk.default), {
            xcss: $0ef60ceb7a2a29db$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aa6tf))), {
            size: "small",
            label: intl.formatMessage((0, $jsotm.default).opensInNewWindow)
        })) : undefined
    }, children));
$0ef60ceb7a2a29db$export$2c7b2957f409c48f.defaultProps = {
    onClick: undefined,
    showShortcutIcon: true,
    appearance: 'link',
    spacing: 'none'
};
var $0ef60ceb7a2a29db$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($0ef60ceb7a2a29db$export$2c7b2957f409c48f);
const $0ef60ceb7a2a29db$var$iconContainerStyles = (0, $ii5wQ.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("jsotm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15876084b060a35f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15876084b060a35f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    opensInNewWindow: {
        "id": "packages-components-external-link-button.opens-in-new-window",
        "defaultMessage": "Opens in a new window"
    }
});

});


parcelRegister("3TpKp", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $bbb7386cf97044f2$export$c4ba40c380ee9a11);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");
const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), args);
$bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $9eD1s = parcelRequire("9eD1s");

var $eTwBl = parcelRequire("eTwBl");

var $99lTN = parcelRequire("99lTN");

var $7fyET = parcelRequire("7fyET");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $co1wz.ff)('uip.ufo') && (0, $7fyET.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9eD1s.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eTwBl.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $99lTN.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eTwBl", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $c81bb2abf80e5664$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $c81bb2abf80e5664$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $c81bb2abf80e5664$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $7sZUk = parcelRequire("7sZUk");

var $99lTN = parcelRequire("99lTN");

var $hhGDe = parcelRequire("hhGDe");
function $c81bb2abf80e5664$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $c81bb2abf80e5664$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $7sZUk.default));
    const interactionId = (0, $99lTN.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $hhGDe.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $c81bb2abf80e5664$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $c81bb2abf80e5664$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $99lTN.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $hhGDe.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $c81bb2abf80e5664$export$f02972da195a43bb(marks, timingsConfig);
        (0, $hhGDe.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $gWHEk = parcelRequire("gWHEk");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $co1wz = parcelRequire("co1wz");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

var $7sZUk = parcelRequire("7sZUk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $co1wz.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $co1wz.ff)('bm3.wait-for-long-task') ? (0, $gWHEk.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                }
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7sZUk.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $7sZUk = parcelRequire("7sZUk");

var $7fyET = parcelRequire("7fyET");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $7fyET.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $7fyET.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7sZUk.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $99lTN = parcelRequire("99lTN");

var $hhGDe = parcelRequire("hhGDe");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $99lTN.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $hhGDe.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $99lTN = parcelRequire("99lTN");

var $hhGDe = parcelRequire("hhGDe");

var $7fyET = parcelRequire("7fyET");
var $8cWTy = parcelRequire("8cWTy");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $99lTN.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $7fyET.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8cWTy.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $hhGDe.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $y7eb2 = parcelRequire("y7eb2");

var $99lTN = parcelRequire("99lTN");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $99lTN.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("6w1ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a6a1affcd2a8451$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4hHHl = parcelRequire("4hHHl");

var $9TfOG = parcelRequire("9TfOG");
class $1a6a1affcd2a8451$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            className: undefined
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static attachHostOffsetOverride(window1) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const calculateDepth = (hostWindow, offset = 0)=>{
            let hostFrameOffset = 0;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            while(hostWindow !== window1.top){
                hostFrameOffset += 1;
                // eslint-disable-next-line no-param-reassign
                hostWindow = hostWindow.parent;
            }
            return hostFrameOffset - offset;
        };
        const containerDepth = calculateDepth(window1);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-param-reassign, jira/jira-ssr/no-unchecked-globals-usage
        window1.top.getHostOffsetFunctionOverride = (hostWindow)=>calculateDepth(hostWindow, containerDepth + 1);
    }
    static detachHostOffsetOverride() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.top && window.top.getHostOffsetFunctionOverride) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.top.getHostOffsetFunctionOverride;
    }
    componentDidMount() {
        $1a6a1affcd2a8451$export$2e2bcd8739ae039.attachHostOffsetOverride(window);
    }
    componentWillUnmount() {
        $1a6a1affcd2a8451$export$2e2bcd8739ae039.detachHostOffsetOverride();
    }
    render() {
        const { src: src, onIFrameLoaded: onIFrameLoaded, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a6a1affcd2a8451$var$Article, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TfOG.default), {
            title: "confluence-article-iframe",
            src: src,
            sameOriginResize: true,
            resizePoll: true,
            onIFrameLoaded: onIFrameLoaded
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hHHl.default), {
            src: src
        }));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a6a1affcd2a8451$var$Article = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "article", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0c7mi _19pkc7mi _2hwxc7mi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4hHHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ba579c57f80b0c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $dZw8H = parcelRequire("dZw8H");
class $86ba579c57f80b0c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('message', this.onResizing);
        // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
        this.timeoutId = setTimeout(this.onEstimatedIframeReady, 500);
    }
    shouldComponentUpdate() {
        return !this.state.resizing;
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('message', this.onResizing);
    }
    render() {
        const { resizing: resizing } = this.state;
        return resizing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null) : null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            resizing: false
        };
        this.onResizing = (ev)=>{
            if (ev.data.fn === 'resize' && (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(ev.origin).hostname === (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(this.props.src).hostname) {
                this.onEstimatedIframeReady();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.removeEventListener('message', this.onResizing);
                clearTimeout(this.timeoutId);
            }
        };
        this.onEstimatedIframeReady = ()=>{
            this.setState({
                resizing: true
            });
        };
    }
}

});

parcelRegister("9TfOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6e2013fd63a854$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $iALll = parcelRequire("iALll");
class $5c6e2013fd63a854$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            sameOriginResize: false,
            resizePoll: false,
            resizePollInterval: 500
        };
    }
    componentWillUnmount() {
        this.removeResizeListener();
        this.removeResizePolling();
    }
    render() {
        const { src: src, title: title } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iALll.IFrame), {
            title: title,
            ref: this.setIFrameRef,
            key: src,
            src: src,
            onLoad: this.onLoaded
        });
    }
    constructor(...args){
        super(...args);
        this.onLoaded = ()=>{
            this.props.onIFrameLoaded && this.props.onIFrameLoaded();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (this.props.sameOriginResize && this.props.src.startsWith(window.location.origin)) {
                this.resizeIFrameHeight();
                this.removeResizeListener();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.addEventListener('resize', this.resizeIFrameHeight);
                this.removeResizeListener = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.removeEventListener('resize', this.resizeIFrameHeight);
                this.removeResizePolling();
                this.beginResizePolling();
            }
        };
        this.setIFrameRef = (ref)=>{
            this.iFrameRef = ref;
            this.resizeIFrameHeight();
            this.beginResizePolling();
        };
        this.removeResizeListener = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.removeResizePolling = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.beginResizePolling = ()=>{
            if (this.props.resizePoll) {
                this.removeResizePolling();
                const intervalId = setInterval(this.resizeIFrameHeight, this.props.resizePollInterval);
                this.removeResizePolling = ()=>clearInterval(intervalId);
            }
        };
        this.resizeIFrameHeight = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
            if (this.iFrameRef && this.iFrameRef.contentWindow && this.iFrameRef.contentWindow.document && this.iFrameRef.contentWindow.document.body) {
                // we dive into the iframe's body – we can do this as the article contents are proxied through Jira
                // the body is the right container on all browsers – documentElement is wrong on Safari, hence its not being used
                const iframeBody = this.iFrameRef.contentWindow.document.body;
                // clientHeight has the correct content height – scrollHeight only ever increases on Safari
                //       that is to say, it doesn't reflect the content height but the container height, which we're setting here
                // iframe.height = ... sets the container height so the content height is left unaffected, so decreases can be detected
                this.iFrameRef.height = `${iframeBody.clientHeight}px`;
                // overflowY = 'hidden' forces Safari to obey the iframe height without adding a scrollbar
                //       without it, it adds the scrollbar which reduces the width + increases the height which
                //       removes the scrollbar which increases the width + reduces the height which
                //       ... yeah it's basically an infinite loop of pure pain
                iframeBody.style.overflowY = 'hidden';
            }
        });
    }
}

});
parcelRegister("iALll", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $51b8681a9830dbe2$export$b32b5f1ee4493319);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $51b8681a9830dbe2$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "iframe", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("c9JME", function(module, exports) {

$parcel$export(module.exports, "DraftArticleSuccessFlags", () => $e2abc86780787baa$export$a396c03fd23667ef);

var $5uXOq = parcelRequire("5uXOq");

var $9UIxp = parcelRequire("9UIxp");

var $rzE3E = parcelRequire("rzE3E");

var $6hrB4 = parcelRequire("6hrB4");
const $e2abc86780787baa$export$a396c03fd23667ef = ()=>{
    const [kbCommonflags, resetDraftArticleData] = (0, $9UIxp.useKnowledgeCommonFlagHook)((0, $6hrB4.default));
    const onDismissed = ()=>{
        resetDraftArticleData(true);
    };
    // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(id: string | number) => Promise<undefined> | undefined'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $rzE3E.KbFlags), {
        flags: kbCommonflags,
        onDismissed: onDismissed
    });
};

});
parcelRegister("9UIxp", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeCommonFlagHook", () => $68535e79aa4458dd$export$71a682bd55aae872);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lw2HC = parcelRequire("lw2HC");
const $68535e79aa4458dd$export$71a682bd55aae872 = (messages)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ id: id, type: type, title: title, description: description }, { resetDraftArticleData: resetDraftArticleData }] = (0, $lw2HC.useFlagData)(messages);
    const knowledgeCommonflags = id ? [
        {
            description: typeof description === 'string' ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), description),
            flagType: type,
            id: id,
            title: formatMessage(title)
        }
    ] : [];
    return [
        knowledgeCommonflags,
        resetDraftArticleData
    ];
};

});

parcelRegister("rzE3E", function(module, exports) {

$parcel$export(module.exports, "KbFlags", () => $a0b6ad285d45eb5a$export$3934d8be12f752d2);

var $5uXOq = parcelRequire("5uXOq");

var $bfqUl = parcelRequire("bfqUl");

var $4ymiS = parcelRequire("4ymiS");


var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

const $a0b6ad285d45eb5a$export$3934d8be12f752d2 = ({ flags: flags, onDismissed: onDismissed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
        onDismissed: (id)=>{
            onDismissed(id);
        }
    }, flags.map(({ flagType: flagType, title: title, description: description, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
            id: id,
            icon: flagType && flagType === (0, $3026c2757a468eb7$export$516433e8a6db7503) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bfqUl))), {
                label: "Success",
                color: `var(--ds-icon-success, ${(0, $dbda9f692ace54dd$export$940e1f69e873f202)})`
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymiS))), {
                label: "Error",
                color: `var(--ds-icon-danger, ${(0, $dbda9f692ace54dd$export$2010d0fb4295b346)})`
            }),
            key: id,
            title: title,
            description: description
        })));
var $a0b6ad285d45eb5a$export$2e2bcd8739ae039 = $a0b6ad285d45eb5a$export$3934d8be12f752d2;

});
parcelRegister("bfqUl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08a0321457cb5aed7e2772729ddee0a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8305f7bd1bf7e48c$var$_react = $8305f7bd1bf7e48c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8305f7bd1bf7e48c$var$_checkCircle = $8305f7bd1bf7e48c$var$_interopRequireDefault((parcelRequire("gb2Zd")));

var $8305f7bd1bf7e48c$var$_checkCircle2 = $8305f7bd1bf7e48c$var$_interopRequireDefault((parcelRequire("kRaKz")));
function $8305f7bd1bf7e48c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8305f7bd1bf7e48c$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $8305f7bd1bf7e48c$var$_react.default.createElement($8305f7bd1bf7e48c$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $8305f7bd1bf7e48c$var$_checkCircle2.default
    }, props));
$8305f7bd1bf7e48c$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $8305f7bd1bf7e48c$var$_default = module.exports.default = $8305f7bd1bf7e48c$var$CheckCircleIcon;

});
parcelRegister("gb2Zd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc6ffd734c61fb34$var$_react = $bc6ffd734c61fb34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc6ffd734c61fb34$var$_UNSAFE_baseNew = $bc6ffd734c61fb34$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $bc6ffd734c61fb34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc6ffd734c61fb34$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $bc6ffd734c61fb34$var$_react.default.createElement($bc6ffd734c61fb34$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$bc6ffd734c61fb34$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $bc6ffd734c61fb34$var$_default = module.exports.default = $bc6ffd734c61fb34$var$CheckCircleIcon;

});


parcelRegister("7R4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $435170f9f2349b2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1eg3p = parcelRequire("1eg3p");

var $3KRpp = parcelRequire("3KRpp");
const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $1eg3p = parcelRequire("1eg3p");

var $7B17s = parcelRequire("7B17s");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $7B17s.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $7B17s.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("fhw5b")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $7B17s.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("fhw5b")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("lKKug", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("4yB9l")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("fhw5b", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));

});



parcelRegister("f2BYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3780c7e328dbb70e$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, $3KRpp.FlagGroup);

});


parcelRegister("6hrB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $218f2273ae394fb2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$218f2273ae394fb2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    draftSuccessFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-title",
        "defaultMessage": "Article published"
    },
    draftSuccessFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-description",
        "defaultMessage": "This article has been added to your knowledge base. Your articles list will update soon."
    },
    draftSuccessSavedFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-title",
        "defaultMessage": "Draft saved"
    },
    draftSuccessSavedFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-description",
        "defaultMessage": "Find it in Drafts in your knowledge base."
    },
    articleSuccessSavedFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-title",
        "defaultMessage": "We\u2019ve saved your unpublished changes"
    },
    articleSuccessSavedFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-description",
        "defaultMessage": "You can edit the article and publish these changes later."
    },
    confluenceCreatePageFailureTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-title",
        "defaultMessage": "We're having trouble creating the article"
    },
    confluenceCreatePageFailureDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-description",
        "defaultMessage": "Wait for a few minutes and try creating the article again."
    },
    articleDeletedFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-title",
        "defaultMessage": "Article deleted"
    },
    articleDeletedFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-description",
        "defaultMessage": "This article has been deleted from your knowledge base. Your articles list will update soon."
    }
});

});


parcelRegister("8qDpT", function(module, exports) {

$parcel$export(module.exports, "ConfluenceEmbeddedViewWrapper", () => $962e9d2227fc279d$export$4b02582fe8eba18f);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $5gBas = parcelRequire("5gBas");

var $jxXKY = parcelRequire("jxXKY");

var $dpjj4 = parcelRequire("dpjj4");
var $kh3Cl = parcelRequire("kh3Cl");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2Dcc2 = parcelRequire("2Dcc2");

var $dAfqg = parcelRequire("dAfqg");


var $lw2HC = parcelRequire("lw2HC");

var $koeKL = parcelRequire("koeKL");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");

var $7fyET = parcelRequire("7fyET");

var $hirE8 = parcelRequire("hirE8");

var $4ccEG = parcelRequire("4ccEG");

var $irQht = parcelRequire("irQht");
const $962e9d2227fc279d$var$WINDOW_RESIZE_THROTTLE = 350;
const $962e9d2227fc279d$var$SHIM_URL = '/plugins/servlet/servicedesk/customer/confluence/shim/';
const $962e9d2227fc279d$export$4b02582fe8eba18f = ({ spaceKey: spaceKey, pageId: pageId, breadcrumbsRef: breadcrumbsRef, projectKey: projectKey, spaceId: spaceId, onIFrameLoaded: onIFrameLoaded })=>{
    const [experienceTracker] = (0, $5uXOq.useState)(new (0, $dpjj4.ExperienceTracker)());
    const cloudId = (0, $koeKL.useCloudId)();
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const projectId = projectContext?.projectId;
    const [breadcrumbsHeight, setBreadcrumbsHeight] = (0, $5uXOq.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const [, routerActions] = (0, $dIdda.useRouter)();
    const [, { articleDeleteSuccess: articleDeleteSuccess }] = (0, $lw2HC.useArticleId)();
    const themeState = (0, $5gBas.default)();
    const { locale: locale } = (0, $koVbs.default)();
    const navigateToEmbeddedEditor = ()=>{
        if (spaceKey != null && projectKey != null) {
            const EDIT_ARTICLE_URL = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${spaceKey}/articles/${pageId}/edit`;
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'onEditClikedInEPView success', {
                articleId: pageId,
                spaceId: spaceId,
                userId: atlassianAccountId,
                tenantId: cloudId
            });
            routerActions.push(EDIT_ARTICLE_URL);
        }
    };
    const isCreatedInEmbeddedEditor = (url)=>url.includes('edit-embed');
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedHandleResize = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
        if (breadcrumbsRef?.current) setBreadcrumbsHeight(breadcrumbsRef.current.clientHeight);
    }, $962e9d2227fc279d$var$WINDOW_RESIZE_THROTTLE), []);
    const handleViewPageLoadFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $7fyET.GlobalPageLoadExperience).markFMP();
        (0, $7fyET.GlobalPageLoadExperience).failure({
            force: true
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        (0, $irQht.epViewLoad).start();
        const viewSuccessCallback = ()=>{
            (0, $irQht.epViewLoad).stop();
            onIFrameLoaded();
        };
        const unsubscribe = experienceTracker.subscribe((payload)=>(0, $4ccEG.experienceTrackerCallback)({
                payload: payload,
                projectKey: projectKey,
                pageId: pageId,
                routerActions: routerActions,
                analyticsEvent: createAnalyticsEvent({}),
                deleteSuccessCallback: articleDeleteSuccess,
                viewSuccessCallback: viewSuccessCallback,
                onViewPageLoadFailure: handleViewPageLoadFailure
            }));
        return unsubscribe;
    }, [
        experienceTracker,
        pageId,
        routerActions,
        projectKey,
        createAnalyticsEvent,
        articleDeleteSuccess,
        onIFrameLoaded,
        handleViewPageLoadFailure
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (breadcrumbsRef?.current) setBreadcrumbsHeight(breadcrumbsRef.current.clientHeight);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', debouncedHandleResize);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', debouncedHandleResize);
        };
    }, [
        debouncedHandleResize,
        breadcrumbsRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hirE8.StyledEmbeddedConfluenceContainer), {
        topOffset: breadcrumbsHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kh3Cl.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxXKY.ViewPage), {
        locale: locale,
        spaceKey: spaceKey,
        contentId: pageId,
        allowedFeatures: [
            'byline-contributors',
            'sticky-header',
            'edit',
            'delete',
            'disable-share'
        ],
        parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
        navigationPolicy: {
            shimUrl: $962e9d2227fc279d$var$SHIM_URL,
            navigate: (url, modifiers, defaultNavigate)=>{
                if (isCreatedInEmbeddedEditor(url)) return navigateToEmbeddedEditor();
                return defaultNavigate(url, modifiers);
            }
        },
        parentProductContentContainerId: `${projectId}`,
        userInfo: {
            userId: atlassianAccountId || '',
            userIdType: (0, $d7e8e0de2b5415e5$export$a40257481ddef37e)
        },
        themeState: themeState
    })));
};

});
parcelRegister("jxXKY", function(module, exports) {

$parcel$export(module.exports, "ViewPage", () => $cff9b17e32ef2915$export$767e3006bdbb424a);

var $5uXOq = parcelRequire("5uXOq");

var $7B17s = parcelRequire("7B17s");
var $8Dmlu = parcelRequire("8Dmlu");

var $kvAIz = parcelRequire("kvAIz");

var $7nref = parcelRequire("7nref");

var $lymE0 = parcelRequire("lymE0");

const $cff9b17e32ef2915$var$LazyViewPage = (0, $7B17s.lazyForPaint)(()=>(parcelRequire("cScIe")), {
    moduleId: "../platform/packages/confluence/embedded-confluence/src/view-page/ViewPage.tsx"
});
const $cff9b17e32ef2915$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nref.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lymE0.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Dmlu.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvAIz.LazyLoadFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cff9b17e32ef2915$var$LazyViewPage, props)));

});
parcelRegister("kvAIz", function(module, exports) {

$parcel$export(module.exports, "LazyLoadFallback", () => $2d4ecd9c80ddb15e$export$da581bf12e325888);

var $bWGt6 = parcelRequire("bWGt6");
function $2d4ecd9c80ddb15e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2d4ecd9c80ddb15e$export$da581bf12e325888 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "egw45yn0"
})({
    name: "w1atjl",
    styles: "width:100%;height:100%"
});

});

parcelRegister("7nref", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => $1d8816e952604065$export$a54013f0d02a8f82);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $frreW = parcelRequire("frreW");
const $1d8816e952604065$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $frreW.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    const locale = (0, $5uXOq.useMemo)(()=>(0, $frreW.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $frreW.DEFAULT_LOCALE)
    }, children);
};

});
parcelRegister("frreW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $5f0a695d878300e0$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $5f0a695d878300e0$export$dca0327c9b9c6498);
const $5f0a695d878300e0$var$DEFAULT_LANGUAGE = 'en';
const $5f0a695d878300e0$var$DEFAULT_REGION = 'US';
const $5f0a695d878300e0$export$1af4c7e47ad72f44 = `${$5f0a695d878300e0$var$DEFAULT_LANGUAGE}-${$5f0a695d878300e0$var$DEFAULT_REGION}`;
const $5f0a695d878300e0$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $5f0a695d878300e0$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $5f0a695d878300e0$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $5f0a695d878300e0$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $5f0a695d878300e0$export$1af4c7e47ad72f44;
};

});


parcelRegister("lymE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $520c397fab424f7e$export$2e2bcd8739ae039);
























const $520c397fab424f7e$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("f5sId"));
        case 'da-DK':
            return (parcelRequire("lCsei"));
        case 'de-DE':
            return (parcelRequire("c0BV1"));
        case 'en-US':
            return (parcelRequire("imwQm"));
        case 'en-GB':
            return (parcelRequire("cnrmW"));
        case 'es-ES':
            return (parcelRequire("l0Bly"));
        case 'fi-FI':
            return (parcelRequire("34ha8"));
        case 'fr-FR':
            return (parcelRequire("7Hm5O"));
        case 'hu-HU':
            return (parcelRequire("5iqfC"));
        case 'it-IT':
            return (parcelRequire("dXeJY"));
        case 'ja-JP':
            return (parcelRequire("cRAiu"));
        case 'ko-KR':
            return (parcelRequire("lpB94"));
        case 'no-NO':
            return (parcelRequire("1qODf"));
        case 'nl-NL':
            return (parcelRequire("k0Vhk"));
        case 'pl-PL':
            return (parcelRequire("8F7T3"));
        case 'pt-BR':
            return (parcelRequire("gQyuG"));
        case 'ru-RU':
            return (parcelRequire("dcgil"));
        case 'sv-SE':
            return (parcelRequire("6AuHG"));
        case 'tr-TR':
            return (parcelRequire("7meun"));
        case 'th-TH':
            return (parcelRequire("cf11c"));
        case 'uk-UA':
            return (parcelRequire("juxAL"));
        case 'vi-VN':
            return (parcelRequire("5JhtR"));
        case 'zh-TW':
            return (parcelRequire("beMYC"));
        case 'zh-CN':
            return (parcelRequire("dtVWN"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $520c397fab424f7e$var$fetchTranslations = async (locale)=>{
    const module = await $520c397fab424f7e$var$importTranslations(locale);
    return module.default;
};
var $520c397fab424f7e$export$2e2bcd8739ae039 = $520c397fab424f7e$var$fetchTranslations;

});
parcelRegister("f5sId", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("kQozT").then(()=>parcelRequire('04EnY'));

});

parcelRegister("lCsei", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("bs0Vp").then(()=>parcelRequire('9cUUB'));

});

parcelRegister("c0BV1", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7CSC4").then(()=>parcelRequire('k0L5l'));

});

parcelRegister("imwQm", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lUuf7").then(()=>parcelRequire('6FH0H'));

});

parcelRegister("cnrmW", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6XBAq").then(()=>parcelRequire('7Dhvo'));

});

parcelRegister("l0Bly", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("fAK6w").then(()=>parcelRequire('7ebYl'));

});

parcelRegister("34ha8", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("aMCK5").then(()=>parcelRequire('2ceUJ'));

});

parcelRegister("7Hm5O", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("bqKCJ").then(()=>parcelRequire('9JI6m'));

});

parcelRegister("5iqfC", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("b7I0z").then(()=>parcelRequire('31lvt'));

});

parcelRegister("dXeJY", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3GgvH").then(()=>parcelRequire('i5sxz'));

});

parcelRegister("cRAiu", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("77IRc").then(()=>parcelRequire('bNVW8'));

});

parcelRegister("lpB94", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5rioT").then(()=>parcelRequire('2ARoo'));

});

parcelRegister("1qODf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("b900X").then(()=>parcelRequire('hnkXV'));

});

parcelRegister("k0Vhk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("04NqQ").then(()=>parcelRequire('4DFZU'));

});

parcelRegister("8F7T3", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7dK6w").then(()=>parcelRequire('cvAdE'));

});

parcelRegister("gQyuG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("aByS7").then(()=>parcelRequire('7J1HX'));

});

parcelRegister("dcgil", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6pncH").then(()=>parcelRequire('1aZ45'));

});

parcelRegister("6AuHG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("ha3Q5").then(()=>parcelRequire('czYcz'));

});

parcelRegister("7meun", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9MUwC").then(()=>parcelRequire('hpetb'));

});

parcelRegister("cf11c", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("3CgRH").then(()=>parcelRequire('jG0bu'));

});

parcelRegister("juxAL", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5FqZH").then(()=>parcelRequire('hBITf'));

});

parcelRegister("5JhtR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1aiqd").then(()=>parcelRequire('93sth'));

});

parcelRegister("beMYC", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("VJI3J").then(()=>parcelRequire('7gcTD'));

});

parcelRegister("dtVWN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("eABkv").then(()=>parcelRequire('Hu13b'));

});


parcelRegister("cScIe", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("1IA1r")
]).then(()=>parcelRequire('jd8vE'));

});


parcelRegister("hirE8", function(module, exports) {

$parcel$export(module.exports, "StyledEmbeddedConfluenceContainer", () => $c2ec46a621396b62$export$ae185cb8762590a8);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $44v1T = parcelRequire("44v1T");
const $c2ec46a621396b62$export$ae185cb8762590a8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { topOffset: topOffset, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $lD23V.default)((0, $44v1T.PAGE_LAYOUT_OFFSET_TOP)),
            "--_imrwx": (0, $lD23V.default)(__cmplp.topOffset, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3irbb1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4ccEG", function(module, exports) {

$parcel$export(module.exports, "experienceTrackerCallback", () => $3762a589d4720dda$export$ede22ae60b43f8c);

var $8zOmE = parcelRequire("8zOmE");
const $3762a589d4720dda$export$9a4ff2d809fc4156 = 'delete-page';
const $3762a589d4720dda$export$9257b5b55c8e2555 = 'view-page';
const $3762a589d4720dda$export$ede22ae60b43f8c = (params)=>{
    const { payload: payload, projectKey: projectKey, pageId: pageId, routerActions: routerActions, analyticsEvent: analyticsEvent, deleteSuccessCallback: deleteSuccessCallback, viewSuccessCallback: viewSuccessCallback, onViewPageLoadFailure: onViewPageLoadFailure } = params;
    const { action: action, name: name, attributes: attributes } = payload;
    switch(action){
        case 'taskStart':
            // @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
            if (name === $3762a589d4720dda$export$9a4ff2d809fc4156 && attributes?.contentId === pageId) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'deleteButton clicked', {
                articleId: pageId
            });
            break;
        case 'taskSuccess':
            if (name === $3762a589d4720dda$export$9a4ff2d809fc4156 && // @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
            attributes?.contentId === pageId && projectKey !== undefined) {
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onArticleDelete success', {
                    articleId: pageId
                });
                deleteSuccessCallback(pageId);
                routerActions.push(`/jira/servicedesk/projects/${projectKey}/knowledge/articles`);
            }
            // @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
            if (name === $3762a589d4720dda$export$9257b5b55c8e2555 && attributes?.contentId === pageId) {
                viewSuccessCallback();
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'epViewPage success', {
                    articleId: pageId
                });
            }
            break;
        case 'taskFail':
            // @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
            if (name === $3762a589d4720dda$export$9a4ff2d809fc4156 && attributes?.contentId === pageId) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'onArticleDelete failure', {
                articleId: pageId
            });
            // @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
            if (name === $3762a589d4720dda$export$9257b5b55c8e2555 && attributes?.contentId === pageId) {
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'epViewPage failure', {
                    articleId: pageId
                });
                onViewPageLoadFailure();
            }
            break;
        default:
            break;
    }
};

});

parcelRegister("irQht", function(module, exports) {

$parcel$export(module.exports, "epViewLoad", () => $24aa99e291c015aa$export$1ba81ebb50ee85e9);

var $hC3PM = parcelRequire("hC3PM");
const $24aa99e291c015aa$export$1ba81ebb50ee85e9 = (0, $hC3PM.metrics).interaction({
    key: 'service-management.ep-view.load'
});

});


parcelRegister("6y0Ij", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c25676f4d8a9574$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c25676f4d8a9574$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareArticle: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.share-article",
        "defaultMessage": "Share this article"
    },
    shareableUrlLabel: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.shareable-url-label",
        "defaultMessage": "Shareable URL"
    },
    copyArticleUrlLabel: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.copy-article-url-label",
        "defaultMessage": "Copy article link"
    },
    belongsToThisSpace: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.belongs-to-this-space",
        "defaultMessage": "Space"
    },
    labels: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.labels",
        "defaultMessage": "Labels"
    },
    tooltipText: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.tooltip-text",
        "defaultMessage": "Opens in new tab"
    }
});

});


parcelRegister("lcClb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("9bA5E")
]).then(()=>parcelRequire('iD6ft'));

});

parcelRegister("3TeJf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("jnvZA")
]).then(()=>parcelRequire('6vnDB'));

});




parcelRegister("kGNe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a3f7642e2f7278$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $gLt7z = parcelRequire("gLt7z");

var $5fBrW = parcelRequire("5fBrW");

var $9AWQZ = parcelRequire("9AWQZ");
var $22a3f7642e2f7278$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state, props)=>({
        name: (0, $5fBrW.getCategoryName)(state, props.id),
        projectKey: (0, $gLt7z.getProjectKey)(state),
        baseUrl: (0, $gLt7z.getBaseUrl)(state)
    }), {})((0, $9AWQZ.default));

});
parcelRegister("9AWQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ae94aada8bab44$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $2Lj35 = parcelRequire("2Lj35");
function $f1ae94aada8bab44$export$2e2bcd8739ae039({ id: id, name: name, children: children, baseUrl: baseUrl, projectKey: projectKey }) {
    if (name === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, $2Lj35.categoryGuidToString)(id)}`,
            text: name,
            type: 'jsd-category-link'
        }
    }, children);
}

});


parcelRegister("2riGj", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubAppBase", () => $cda69d9cd68a5197$export$f848f52481042e56);

var $5uXOq = parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");

var $e0Brz = parcelRequire("e0Brz");

var $gEFwt = parcelRequire("gEFwt");

var $kb4zh = parcelRequire("kb4zh");

var $9sGI6 = parcelRequire("9sGI6");

var $97Kan = parcelRequire("97Kan");

var $3HwlS = parcelRequire("3HwlS");

var $2Dcc2 = parcelRequire("2Dcc2");

var $5MiFc = parcelRequire("5MiFc");

var $cf7yQ = parcelRequire("cf7yQ");

var $lw2HC = parcelRequire("lw2HC");

var $cbMay = parcelRequire("cbMay");

var $h4S6Q = parcelRequire("h4S6Q");

var $hYd1f = parcelRequire("hYd1f");

var $1eweq = parcelRequire("1eweq");

var $1xzCS = parcelRequire("1xzCS");

var $7FkcY = parcelRequire("7FkcY");

var $6GLlD = parcelRequire("6GLlD");

var $e33py = parcelRequire("e33py");

var $6FTcZ = parcelRequire("6FTcZ");

var $gq0sA = parcelRequire("gq0sA");

var $4S0uJ = parcelRequire("4S0uJ");

var $dIdda = parcelRequire("dIdda");
const $cda69d9cd68a5197$var$KnowledgeHubAppBaseView = (props)=>{
    const { initialActions: initialActions, KnowledgeHubContainer: KnowledgeHubContainer, appName: appName, shouldRemoveMargin: shouldRemoveMargin = false } = props;
    const [{ match: match, query: query }] = (0, $dIdda.useRouter)();
    const [{ data: pageContextData, error: pageContextError }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId } = projectContext || {};
    const [{ data: confluenceLink, error: confluenceLinkError }] = (0, $6FTcZ.useKbConfluenceContext)(projectKey);
    const [{ categories: categories, isCategoriesSupported: isCategoriesSupported }, { fetchCategories: fetchCategories }] = (0, $lw2HC.useCategoriesData)();
    const { activationId: activationId } = tenantContext || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) return;
        projectId && activationId && fetchCategories(projectId, createAnalyticsEvent({}), activationId);
    }, [
        projectId,
        fetchCategories,
        createAnalyticsEvent,
        activationId
    ]);
    if (!confluenceLink && !confluenceLinkError || !pageContextData && !pageContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stateAppProps = {
        app: {
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }
    };
    const CustomizedPageStyle = (0, $3HwlS.getWillShowNav4)() && shouldRemoveMargin ? (0, $e65Lk.default) : (0, $4S0uJ.PageStyle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GLlD.default), {
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeHubContainer, {
        scope: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eweq.KnowledgeHubActionsSubscriber), null, (_, scopedKnowledgeActions)=>{
        const initialState = {
            ...scopedKnowledgeActions.getStoreState(),
            ...stateAppProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MiFc.ReduxConnector), {
            storeName: "servicedesk-knowledge-hub",
            initialState: initialState,
            rootReducer: (0, $1xzCS.default)(scopedKnowledgeActions.updateStore),
            rootEpic: (0, $hYd1f.default),
            initialActions: initialActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FkcY.default), {
            ...confluenceLink,
            categories: categories,
            isCategoriesSupported: isCategoriesSupported
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2769 - No overload matches this call.
            projectName: projectName,
            section: "knowledge"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbMay.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            baseUrl: "",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectKey: projectKey,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectName: projectName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomizedPageStyle, null, props.children({
            match: match,
            query: query,
            pageContext: {
                ...stateAppProps.app
            }
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $h4S6Q.default)
        })));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};
const $cda69d9cd68a5197$export$f848f52481042e56 = (0, $9sGI6.default)($cda69d9cd68a5197$var$KnowledgeHubAppBaseView, {
    initialActions: [],
    KnowledgeHubContainer: (0, $1eweq.KnowledgeHubContainer)
});
var $cda69d9cd68a5197$export$2e2bcd8739ae039 = $cda69d9cd68a5197$export$f848f52481042e56;

});
parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("5MiFc", function(module, exports) {

$parcel$export(module.exports, "ReduxConnector", () => $d6d887f51629efb1$export$c0c26a673bd1981c);

var $5uXOq = parcelRequire("5uXOq");

var $F2Mxm = parcelRequire("F2Mxm");

var $bC2fB = parcelRequire("bC2fB");
const $d6d887f51629efb1$export$c0c26a673bd1981c = ({ storeName: storeName, initialState: initialState, initialActions: initialActions, rootReducer: rootReducer, rootEpic: rootEpic, children: children })=>{
    // Guarantees store is created only once for component's lifespan
    const createStoreRef = (0, $5uXOq.useRef)(()=>(0, $F2Mxm.default)({
            appName: storeName,
            initialState: initialState,
            rootReducer: rootReducer,
            rootEpic: rootEpic
        }));
    // Guarantees same store is used throughout component's lifespan
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const store = (0, $5uXOq.useMemo)(createStoreRef.current, []);
    // Guarantees initial actions only get run once even if prop changes
    const initialActionsRef = (0, $5uXOq.useRef)(initialActions);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        initialActionsRef.current?.forEach((action)=>{
            store.dispatch(action());
        });
    }, [
        store
    ]);
    return(// ReduxProvider provides store only to first child. Using fragment so if multiple
    // children are given, all will get store context. Common case for this is when
    // FlagsDispatcher and app need to share the same store
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC2fB.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)));
};

});

parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $7B17s = parcelRequire("7B17s");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("6MoH3")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("ejgPJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("2VzMc")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7B17s.lazyAfterPaint)(()=>(parcelRequire("ahFso")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("6MoH3", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("chQyv").then(()=>parcelRequire('hZyYK'));

});

parcelRegister("ejgPJ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("2VzMc", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("ahFso", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("cbMay", function(module, exports) {

$parcel$export(module.exports, "default", () => $342ca5599182c99e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $825UM = parcelRequire("825UM");

var $ks7Ah = parcelRequire("ks7Ah");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$342ca5599182c99e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ks7Ah.default), null, ({ isOpen: isOpen, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $825UM.default), {
            isOpen: isOpen,
            onClose: onClose
        }));

});
parcelRegister("825UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d18ceb0644bdde$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kbNdD = parcelRequire("kbNdD");

var $1bqnV = parcelRequire("1bqnV");


var $6z7Gx = parcelRequire("6z7Gx");

var $gq0sA = parcelRequire("gq0sA");

var $dIdda = parcelRequire("dIdda");

var $261Bl = parcelRequire("261Bl");

var $lw2HC = parcelRequire("lw2HC");

var $7U3kA = parcelRequire("7U3kA");
const $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { push: push } = (0, $dIdda.useRouterActions)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const { projectId: projectId, projectKey: projectKey } = projectContext || {};
    const [{ isSubmitting: isSubmitting, formValues: formValues, error: error, createdCategory: createdCategory }, { createCategory: createCategory, handleFormInputChange: handleFormInputChange, resetCreatedCategory: resetCreatedCategory }] = (0, $lw2HC.useCreateCategoryData)();
    const activationId = tenantContext?.activationId || '';
    const isValid = !!formValues.name && formValues.name.length !== 0;
    const onChange = (field, value)=>{
        handleFormInputChange(field, value);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!createdCategory) return;
        onClose();
        resetCreatedCategory();
        push(`/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, $261Bl.categoryGuidToString)(createdCategory.id)}`);
    }, [
        createdCategory,
        projectKey,
        push,
        onClose,
        resetCreatedCategory
    ]);
    const onSubmit = (e, analyticsEvent)=>{
        e.preventDefault();
        if (isSubmitting || !isValid) return;
        projectId && createCategory(projectId, analyticsEvent, activationId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbNdD.default), {
        data: {
            source: `knowledgeCreateCategory${(0, $4d5e0871c06cee03$export$1171103ea9083ffa)}`,
            actionSubject: 'category',
            attributes: {
                context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bqnV.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7U3kA.default), {
        onChange: onChange,
        onClose: onClose,
        onSubmit: onSubmit,
        formValues: formValues,
        formError: error.formError,
        fieldErrors: error.fieldErrors,
        isSubmitting: isSubmitting,
        isDisabled: !isValid
    })));
};
var $a6d18ceb0644bdde$export$2e2bcd8739ae039 = $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory;

});
parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("7U3kA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ae948e58435135$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $goLm2 = parcelRequire("goLm2");
var $7T12o = parcelRequire("7T12o");

var $gdAct = parcelRequire("gdAct");
var $an8tl = parcelRequire("an8tl");
var $b98NP = parcelRequire("b98NP");
var $cdzWP = parcelRequire("cdzWP");
var $gTRsD = parcelRequire("gTRsD");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $9oIFN = parcelRequire("9oIFN");

var $5TOVG = parcelRequire("5TOVG");
const $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSubmitting: isSubmitting = false, isDisabled: isDisabled = false, onChange: onChange, onClose: onClose, onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdAct.default), {
        onClose: onClose,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cdzWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gTRsD.default), null, formatMessage((0, $5TOVG.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $an8tl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9oIFN.default), {
        onChange: onChange,
        onSubmit: onSubmit,
        formError: formError,
        fieldErrors: fieldErrors,
        isDisabled: isSubmitting
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b98NP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7T12o.default), {
        appearance: "primary",
        onClick: onSubmit,
        isLoading: isSubmitting,
        isDisabled: isDisabled
    }, formatMessage((0, $5TOVG.default).createAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goLm2.default), {
        onClick: onClose
    }, formatMessage((0, $5TOVG.default).cancelAction)))));
};
var $c2ae948e58435135$export$2e2bcd8739ae039 = $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless;

});
parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});
parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("9oIFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $49788ff41cd45114$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $3pn3a = parcelRequire("3pn3a");
var $49788ff41cd45114$export$2e2bcd8739ae039 = (0, $8oe80.default)('form', {
    onSubmit: 'submitted'
})((0, $3pn3a.default));

});
parcelRegister("3pn3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6b524a14a97bee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eKl4A = parcelRequire("eKl4A");

var $i3NQF = parcelRequire("i3NQF");

var $laM7j = parcelRequire("laM7j");

var $dvaUE = parcelRequire("dvaUE");

var $koVbs = parcelRequire("koVbs");

var $7cbM0 = parcelRequire("7cbM0");

var $7VpFm = parcelRequire("7VpFm");
const $da6b524a14a97bee$var$CreateCategoryForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors, isDisabled: isDisabled = false, testId: testId } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createOnChangeHandlerForField = (field)=>(e)=>{
            props.onChange(field, e.currentTarget.value);
        };
    const errorMessage = (field)=>fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;
    return(// @ts-expect-error - TS2322 - Type '{ children: (Element | undefined)[]; onSubmit: (e: SyntheticEvent<any, Event>) => void; disabled: boolean; }' is not assignable to type 'DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        onSubmit: onSubmit,
        disabled: isDisabled
    }, formError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i3NQF.default), {
        appearance: "error",
        testId: testId && `${testId}--section-message`
    }, formatMessage(formError.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $7VpFm.default).helpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKl4A.default), {
        // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
        error: errorMessage('name'),
        label: formatMessage((0, $7VpFm.default).nameFieldLabel),
        isRequired: true,
        name: "name"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cbM0.default), {
            error: errorMessage('name')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvaUE.default), {
            ...fieldProps,
            isRequired: true,
            autoComplete: "off",
            placeholder: formatMessage((0, $7VpFm.default).nameFieldPlaceholder),
            isInvalid: fieldErrors && !!fieldErrors.name,
            maxLength: 100,
            onChange: createOnChangeHandlerForField('name'),
            isDisabled: isDisabled,
            autoFocus: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKl4A.default), {
        // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
        error: errorMessage('description'),
        label: formatMessage((0, $7VpFm.default).descriptionFieldLabel),
        name: "description"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cbM0.default), {
            error: errorMessage('description')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $laM7j.default), {
            ...fieldProps,
            maxLength: 150,
            minimumRows: 3,
            autoComplete: "off",
            placeholder: formatMessage((0, $7VpFm.default).descriptionFieldPlaceholder),
            isInvalid: fieldErrors && !!fieldErrors.description,
            isDisabled: isDisabled,
            onChange: createOnChangeHandlerForField('description')
        })))));
};
var $da6b524a14a97bee$export$2e2bcd8739ae039 = $da6b524a14a97bee$var$CreateCategoryForm;

});
parcelRegister("eKl4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fca9f8d615fd71d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("3joPi");

var $agEJC = parcelRequire("agEJC");

var $6lFBs = parcelRequire("6lFBs");

var $c9bWK = parcelRequire("c9bWK");

var $6Oaeg = parcelRequire("6Oaeg");

var $4uwmb = parcelRequire("4uwmb");

var $6cAn5 = parcelRequire("6cAn5");
function $5fca9f8d615fd71d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5fca9f8d615fd71d$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $5fca9f8d615fd71d$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $5fca9f8d615fd71d$var$isFunction(x) {
    return typeof x === 'function';
}
function $5fca9f8d615fd71d$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $5fca9f8d615fd71d$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $5fca9f8d615fd71d$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $c9bWK.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $c9bWK.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $5fca9f8d615fd71d$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $5fca9f8d615fd71d$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$5fca9f8d615fd71d$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $5fca9f8d615fd71d$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $5fca9f8d615fd71d$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($5fca9f8d615fd71d$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $agEJC.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $5fca9f8d615fd71d$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6Oaeg.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4uwmb.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6lFBs.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("6lFBs", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $3f574ed0f3fc4c60$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $3f574ed0f3fc4c60$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("c9bWK", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $68107146a3762a5b$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $68107146a3762a5b$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $68107146a3762a5b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $68107146a3762a5b$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $68107146a3762a5b$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $68107146a3762a5b$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68107146a3762a5b$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68107146a3762a5b$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("6Oaeg", function(module, exports) {

$parcel$export(module.exports, "Label", () => $afa1bdfc5ce6cca0$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $afa1bdfc5ce6cca0$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $afa1bdfc5ce6cca0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $afa1bdfc5ce6cca0$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $afa1bdfc5ce6cca0$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        css: $afa1bdfc5ce6cca0$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $afa1bdfc5ce6cca0$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("legend", {
        css: $afa1bdfc5ce6cca0$var$fieldsetLabelStyles
    }, children);
};
var $afa1bdfc5ce6cca0$export$2e2bcd8739ae039 = $afa1bdfc5ce6cca0$export$b04be29aa201d4f5;

});

parcelRegister("4uwmb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f2e2883f46104c3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $2f2e2883f46104c3$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $dbda9f692ace54dd$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $2f2e2883f46104c3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $2f2e2883f46104c3$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("laM7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $deefe53941ee70d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7UFJi = parcelRequire("7UFJi");

var $aKNbD = parcelRequire("aKNbD");
const $deefe53941ee70d0$var$packageName = "platform-pkg";
const $deefe53941ee70d0$var$packageVersion = "0.0.0-use.local";
const $deefe53941ee70d0$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $deefe53941ee70d0$var$packageName,
    packageVersion: $deefe53941ee70d0$var$packageVersion
};
const $deefe53941ee70d0$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $aKNbD.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $deefe53941ee70d0$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $deefe53941ee70d0$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7UFJi.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$deefe53941ee70d0$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7UFJi.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$deefe53941ee70d0$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $deefe53941ee70d0$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $5uXOq.useMemo)(()=>(0, $aKNbD.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)([
        baseStyles,
        (0, $aKNbD.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $deefe53941ee70d0$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($deefe53941ee70d0$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$deefe53941ee70d0$var$TextArea.displayName = 'TextArea';
var $deefe53941ee70d0$export$2e2bcd8739ae039 = $deefe53941ee70d0$var$TextArea;

});
parcelRegister("aKNbD", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $7c68f17accf9b0ad$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $7c68f17accf9b0ad$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $7c68f17accf9b0ad$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aj9Sw = parcelRequire("aj9Sw");
function $7c68f17accf9b0ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7c68f17accf9b0ad$var$disabledRules = {
    backgroundColor: $aj9Sw.disabledBackground,
    backgroundColorFocus: $aj9Sw.disabledBackground,
    backgroundColorHover: $aj9Sw.disabledBackground,
    borderColor: $aj9Sw.disabledBorder,
    borderColorFocus: $aj9Sw.defaultBorderColorFocus,
    textColor: $aj9Sw.disabledTextColor
};
const $7c68f17accf9b0ad$var$invalidRules = {
    borderColor: $aj9Sw.invalidBorderColor,
    borderColorFocus: $aj9Sw.defaultBorderColorFocus,
    backgroundColor: $aj9Sw.defaultBackgroundColor,
    backgroundColorFocus: $aj9Sw.defaultBackgroundColorFocus,
    backgroundColorHover: $aj9Sw.defaultBackgroundColorHover
};
const $7c68f17accf9b0ad$var$backgroundColor = {
    standard: $aj9Sw.defaultBackgroundColor,
    subtle: $aj9Sw.transparent,
    none: $aj9Sw.transparent
};
const $7c68f17accf9b0ad$var$backgroundColorFocus = {
    standard: $aj9Sw.defaultBackgroundColorFocus,
    subtle: $aj9Sw.defaultBackgroundColorFocus,
    none: $aj9Sw.transparent
};
const $7c68f17accf9b0ad$var$backgroundColorHover = {
    standard: $aj9Sw.defaultBackgroundColorHover,
    subtle: $aj9Sw.defaultBackgroundColorHover,
    none: $aj9Sw.transparent
};
const $7c68f17accf9b0ad$var$borderColor = {
    standard: $aj9Sw.defaultBorderColor,
    subtle: $aj9Sw.transparent,
    none: $aj9Sw.transparent
};
const $7c68f17accf9b0ad$var$borderColorFocus = {
    standard: $aj9Sw.defaultBorderColorFocus,
    subtle: $aj9Sw.defaultBorderColorFocus,
    none: $aj9Sw.transparent
};
const $7c68f17accf9b0ad$var$borderColorHover = {
    standard: $aj9Sw.defaultBorderColor,
    subtle: $aj9Sw.subtleBorderColorHover,
    none: $aj9Sw.transparent
};
const $7c68f17accf9b0ad$var$lineHeightBase = 20;
const $7c68f17accf9b0ad$var$lineHeightCompact = 16;
const $7c68f17accf9b0ad$var$compactVerticalPadding = 2;
const $7c68f17accf9b0ad$var$verticalPadding = 6;
const $7c68f17accf9b0ad$var$horizontalPadding = 8;
const $7c68f17accf9b0ad$var$transitionDuration = '0.2s';
const $7c68f17accf9b0ad$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $7c68f17accf9b0ad$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $7c68f17accf9b0ad$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $7c68f17accf9b0ad$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $7c68f17accf9b0ad$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $7c68f17accf9b0ad$var$lineHeightBase * minimumRows;
    return contentHeight + $7c68f17accf9b0ad$var$verticalPadding * 2 + borderHeight * 2;
};
const $7c68f17accf9b0ad$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $7c68f17accf9b0ad$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $7c68f17accf9b0ad$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $7c68f17accf9b0ad$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $7c68f17accf9b0ad$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $7c68f17accf9b0ad$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$7c68f17accf9b0ad$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $7c68f17accf9b0ad$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $7c68f17accf9b0ad$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $7c68f17accf9b0ad$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $7c68f17accf9b0ad$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$7c68f17accf9b0ad$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $7c68f17accf9b0ad$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $7c68f17accf9b0ad$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$7c68f17accf9b0ad$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $7c68f17accf9b0ad$var$disabledRules.backgroundColorFocus,
                borderColor: $7c68f17accf9b0ad$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $7c68f17accf9b0ad$var$disabledRules.backgroundColor,
                borderColor: $7c68f17accf9b0ad$var$disabledRules.borderColor
            }
        } : {}
    });
const $7c68f17accf9b0ad$var$placeholderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $aj9Sw.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $7c68f17accf9b0ad$var$disabledRules.textColor
    }
});
const $7c68f17accf9b0ad$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $7c68f17accf9b0ad$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $7c68f17accf9b0ad$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $7c68f17accf9b0ad$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $7c68f17accf9b0ad$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $7c68f17accf9b0ad$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$7c68f17accf9b0ad$var$invalidRules.borderColor}`
            }
        }
    });
var $7c68f17accf9b0ad$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $7c68f17accf9b0ad$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $7c68f17accf9b0ad$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        resize: resize
    });
    if (resize === 'auto') return $7c68f17accf9b0ad$var$_ref2;
    return $7c68f17accf9b0ad$var$_ref;
};
const $7c68f17accf9b0ad$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $7c68f17accf9b0ad$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $7c68f17accf9b0ad$var$codeFontFamily : $7c68f17accf9b0ad$var$fontFamily
    });
const $7c68f17accf9b0ad$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $7c68f17accf9b0ad$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $7c68f17accf9b0ad$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$7c68f17accf9b0ad$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $7c68f17accf9b0ad$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $7c68f17accf9b0ad$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$7c68f17accf9b0ad$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $7c68f17accf9b0ad$var$lineHeightBase / 14
        }
    });
};
const $7c68f17accf9b0ad$var$staticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$7c68f17accf9b0ad$var$transitionDuration} ease-in-out,
               border-color ${$7c68f17accf9b0ad$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$7c68f17accf9b0ad$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $7c68f17accf9b0ad$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $7c68f17accf9b0ad$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c68f17accf9b0ad$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $aj9Sw.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $7c68f17accf9b0ad$var$disabledRules.textColor
        }
    });

});
parcelRegister("aj9Sw", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $b9e19e0bd5c12fae$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $b9e19e0bd5c12fae$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $b9e19e0bd5c12fae$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $b9e19e0bd5c12fae$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $b9e19e0bd5c12fae$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $b9e19e0bd5c12fae$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $b9e19e0bd5c12fae$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $b9e19e0bd5c12fae$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $b9e19e0bd5c12fae$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $b9e19e0bd5c12fae$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $b9e19e0bd5c12fae$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $b9e19e0bd5c12fae$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $b9e19e0bd5c12fae$export$f4d082c200a4b4b8);

const $b9e19e0bd5c12fae$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`;
const $b9e19e0bd5c12fae$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $dbda9f692ace54dd$export$1ce2d1575d444ceb)})`;
const $b9e19e0bd5c12fae$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $dbda9f692ace54dd$export$2010d0fb4295b346)})`;
const $b9e19e0bd5c12fae$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`;
const $b9e19e0bd5c12fae$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`;
const $b9e19e0bd5c12fae$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $dbda9f692ace54dd$export$e655ef011c4aa1a2)})`;
const $b9e19e0bd5c12fae$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`;
const $b9e19e0bd5c12fae$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`;
const $b9e19e0bd5c12fae$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $b9e19e0bd5c12fae$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$f563ee71e9ee74cd)})`;
const $b9e19e0bd5c12fae$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$fbda843f0a27fe96)})`;
const $b9e19e0bd5c12fae$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de)})`;
const $b9e19e0bd5c12fae$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("7cbM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c9409ad575aa5f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
function $78c9409ad575aa5f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c9409ad575aa5f$var$ErrorMessage, null, props.error));
}
$78c9409ad575aa5f$export$2e2bcd8739ae039.defaultProps = {
    error: undefined
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $78c9409ad575aa5f$var$ErrorMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1l5o _1yt4swc3",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7VpFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $185a0480b7dde273$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $185a0480b7dde273$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    helpText: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text",
        "defaultMessage": "Group related articles in categories to help customers find what they need."
    },
    nameFieldLabel: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label",
        "defaultMessage": "Name"
    },
    nameFieldPlaceholder: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder",
        "defaultMessage": "Category name, e.g \"Printers\" or \"Wifi\""
    },
    descriptionFieldLabel: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label",
        "defaultMessage": "Description"
    },
    descriptionFieldPlaceholder: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder",
        "defaultMessage": "Tell customers more about this category"
    }
});

});



parcelRegister("5TOVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f748cc858c62ad0d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f748cc858c62ad0d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.title",
        "defaultMessage": "Create new category"
    },
    createAction: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-action",
        "defaultMessage": "Create"
    },
    cancelAction: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("ks7Ah", function(module, exports) {

$parcel$export(module.exports, "default", () => $30d72adc6eb603b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kvQS7 = parcelRequire("kvQS7");
const $30d72adc6eb603b4$var$NavDriver = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvQS7.KbCreateCategorySubscriber), null, ({ isOpen: isOpen }, { setCreateCategoryDisplay: setCreateCategoryDisplay })=>{
        const onClose = ()=>setCreateCategoryDisplay(false);
        return children({
            isOpen: isOpen,
            onClose: onClose
        });
    });
};
var $30d72adc6eb603b4$export$2e2bcd8739ae039 = $30d72adc6eb603b4$var$NavDriver;

});
parcelRegister("kvQS7", function(module, exports) {

$parcel$export(module.exports, "useKbCreateCategoryActions", () => $fefcd82701364dc4$export$719df9e736f08a9);
$parcel$export(module.exports, "KbCreateCategorySubscriber", () => $fefcd82701364dc4$export$2b9cf8c256011b51);

var $7JoAD = parcelRequire("7JoAD");
const $fefcd82701364dc4$export$d4c72bab9d6cc13a = {
    isOpen: false
};
const $fefcd82701364dc4$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
        setState({
            isOpen: isOpen
        });
    };
const $fefcd82701364dc4$export$e324594224ef24da = {
    setCreateCategoryDisplay: $fefcd82701364dc4$var$setCreateCategoryDisplay
};
const $fefcd82701364dc4$var$Store = (0, $7JoAD.createStore)({
    name: 'kb-create-category',
    initialState: $fefcd82701364dc4$export$d4c72bab9d6cc13a,
    actions: $fefcd82701364dc4$export$e324594224ef24da
});
const $fefcd82701364dc4$export$719df9e736f08a9 = (0, $7JoAD.createHook)($fefcd82701364dc4$var$Store, {
    selector: null
});
const $fefcd82701364dc4$export$2b9cf8c256011b51 = (0, $7JoAD.createSubscriber)($fefcd82701364dc4$var$Store);

});



parcelRegister("h4S6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e91b5defeecf9279$export$2e2bcd8739ae039);

var $5sKH1 = parcelRequire("5sKH1");

var $iHUHp = parcelRequire("iHUHp");

var $6zk4x = parcelRequire("6zk4x");

var $1hzgw = parcelRequire("1hzgw");

var $6VTSZ = parcelRequire("6VTSZ");
const $e91b5defeecf9279$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $6zk4x.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
        case 0, $5sKH1.ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
            return (0, $6VTSZ.default)();
        case 0, $iHUHp.REMOVE_LABEL_FROM_ARTICLE_FAILURE:
            return (0, $1hzgw.default)();
        default:
            return undefined;
    }
};
var $e91b5defeecf9279$export$2e2bcd8739ae039 = $e91b5defeecf9279$var$flagsMapper;

});
parcelRegister("5sKH1", function(module, exports) {

$parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_FAILURE", () => $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d);
$parcel$export(module.exports, "addCategoriesForArticleFailure", () => $a77e1c0ebfe8e6c5$export$98c16426b39dc19d);
const $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d = 'state.actions.add-categories-for-article-failure.ADD_CATEGORIES_FOR_ARTICLE_FAILURE';
const $a77e1c0ebfe8e6c5$export$98c16426b39dc19d = (payload)=>({
        payload: payload,
        type: $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d
    });

});

parcelRegister("iHUHp", function(module, exports) {

$parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_FAILURE", () => $36bd602e9276dc31$export$78c874904ae250ac);
$parcel$export(module.exports, "removeLabelFromArticleFailure", () => $36bd602e9276dc31$export$b7ca01a9c0fd6afb);
const $36bd602e9276dc31$export$78c874904ae250ac = 'state.actions.remove-label-from-article-failure.REMOVE_LABEL_FROM_ARTICLE_FAILURE';
const $36bd602e9276dc31$export$b7ca01a9c0fd6afb = (payload)=>({
        payload: payload,
        type: $36bd602e9276dc31$export$78c874904ae250ac
    });

});

parcelRegister("6zk4x", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE", () => $ad606a0cff7a573c$export$f5f174c6323905d3);
$parcel$export(module.exports, "updateCategoriesForArticleFailure", () => $ad606a0cff7a573c$export$4578d03141d71619);
const $ad606a0cff7a573c$export$f5f174c6323905d3 = 'state.actions.update-categories-for-article-failure.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE';
const $ad606a0cff7a573c$export$4578d03141d71619 = (payload)=>({
        payload: payload,
        type: $ad606a0cff7a573c$export$f5f174c6323905d3
    });

});

parcelRegister("1hzgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb51d5c83a378fb$export$2e2bcd8739ae039);

var $fmcGe = parcelRequire("fmcGe");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ecb51d5c83a378fb$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        type: 'error',
        title: (0, $fmcGe.default).title,
        description: (0, $fmcGe.default).description
    });

});
parcelRegister("fmcGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $372161f8a7552a21$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $372161f8a7552a21$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.title",
        "defaultMessage": "We couldn\u2019t save the changes you made"
    },
    description: {
        "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("6VTSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $53def11827375f52$export$2e2bcd8739ae039);

var $kINlF = parcelRequire("kINlF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53def11827375f52$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        type: 'error',
        title: (0, $kINlF.default).title,
        description: (0, $kINlF.default).description
    });

});
parcelRegister("kINlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59c7a9bfc032690$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f59c7a9bfc032690$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.title",
        "defaultMessage": "Article's categories not updated"
    },
    description: {
        "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.description",
        "defaultMessage": "We weren't able to update the article's categories. Try again in a minute."
    }
});

});



parcelRegister("hYd1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c850f2f9e57103ab$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $bdof7 = parcelRequire("bdof7");

var $eGP51 = parcelRequire("eGP51");

var $4DyVT = parcelRequire("4DyVT");

var $feRMu = parcelRequire("feRMu");

var $kTAvA = parcelRequire("kTAvA");

var $cpM8i = parcelRequire("cpM8i");

var $bDRTj = parcelRequire("bDRTj");

var $a20m8 = parcelRequire("a20m8");

var $gTvcp = parcelRequire("gTvcp");

var $4JAV5 = parcelRequire("4JAV5");

var $iYJ1l = parcelRequire("iYJ1l");

var $92ShW = parcelRequire("92ShW");

var $6OXm8 = parcelRequire("6OXm8");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$c850f2f9e57103ab$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $92ShW.epic), (0, $gTvcp.epic), (0, $cpM8i.epic), (0, $bDRTj.epic), (0, $a20m8.epic), (0, $4DyVT.epic), (0, $bdof7.epic), (0, $6OXm8.epic), (0, $4JAV5.epic), (0, $feRMu.epic), (0, $kTAvA.epic), (0, $eGP51.epic), (0, $iYJ1l.epic));

});
parcelRegister("bdof7", function(module, exports) {

$parcel$export(module.exports, "epic", () => $8156adb89212081f$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $6ovlC = parcelRequire("6ovlC");

var $5sKH1 = parcelRequire("5sKH1");

var $5XgTr = parcelRequire("5XgTr");

var $gXg4u = parcelRequire("gXg4u");

var $gLt7z = parcelRequire("gLt7z");

const $8156adb89212081f$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $6ovlC.ADD_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
        const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        const currentCategoryIds = (0, $gXg4u.getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
        return (0, $fmmX1.addCategoriesForArticle)({
            projectId: projectId,
            categoryIds: categoryIds,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map(()=>{
            (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
                action: 'update',
                actionSubjectId: articleId
            });
            return (0, $5XgTr.addCategoriesForArticleSuccess)({
                articleId: articleId,
                categoryIds: categoryIds,
                previousCategoryIds: currentCategoryIds
            });
        }).catch((error)=>{
            const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
            (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: analyticsEvent,
                id: 'articleUpdate Failure',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $5sKH1.addCategoriesForArticleFailure)({
                statusCode: statusCode,
                errorKey: errorKey,
                errorMessage: errorMessage,
                failedCategoryIds: categories,
                articleId: articleId
            }));
        });
    });

});
parcelRegister("fmmX1", function(module, exports) {

$parcel$export(module.exports, "list", () => $0f36cff0fb97de2b$export$8837f4fc672e936d);
$parcel$export(module.exports, "listCategoryArticles", () => $0f36cff0fb97de2b$export$897d9115a17b4c24);
$parcel$export(module.exports, "getArticleWithExpandParams", () => $0f36cff0fb97de2b$export$fb27d96404fd219d);
$parcel$export(module.exports, "addCategoriesForArticle", () => $0f36cff0fb97de2b$export$d93a983139fde0cc);
$parcel$export(module.exports, "updateCategoriesForArticle", () => $0f36cff0fb97de2b$export$2613b83c3141003a);
$parcel$export(module.exports, "getAllLinkedSpaces", () => $0f36cff0fb97de2b$export$6f4beca8ff3702f3);
$parcel$export(module.exports, "addLabelsToArticles", () => $0f36cff0fb97de2b$export$f40640db2a9b7e80);
$parcel$export(module.exports, "removeLabelsFromArticles", () => $0f36cff0fb97de2b$export$cba6b78bbfb96381);
$parcel$export(module.exports, "fetchLabelSuggestions", () => $0f36cff0fb97de2b$export$8502c8a97aecfbad);
$parcel$export(module.exports, "fetchArticleEditPermission", () => $0f36cff0fb97de2b$export$65396ff44dade790);
parcelRequire("3q49N");
parcelRequire("c66Ur");
parcelRequire("d0pqD");

var $ebyGx = parcelRequire("ebyGx");

var $kVLXA = parcelRequire("kVLXA");

var $7f4tk = parcelRequire("7f4tk");

var $5OrSA = parcelRequire("5OrSA");

var $2Lj35 = parcelRequire("2Lj35");

/**
 * This will replace `null` with `undefined`. We want to merge
 * data later in the application - but we don't want null to
 * override data that already exists.
 */ const $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined = (article)=>{
    const parsedArticle = {
        ...article
    };
    if (parsedArticle.viewCount === null) parsedArticle.viewCount = undefined;
    if (parsedArticle.categories === null) parsedArticle.categories = undefined;
    if (parsedArticle.featuredInCategories === null) parsedArticle.featuredInCategories = undefined;
    return parsedArticle;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0f36cff0fb97de2b$var$transformArticleResponse = (articleResponse)=>{
    // Currently API return ADF as string instead of a JSON blob, so we have to
    // an additional transformation step here.
    let bodyAdf;
    if (articleResponse.body) bodyAdf = JSON.parse(articleResponse.body);
    const transformedData = {
        ...articleResponse,
        body: bodyAdf
    };
    return $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined(transformedData);
};
const $0f36cff0fb97de2b$var$getQueryString = (opts)=>{
    const { expand: expand, ...otherOpts } = opts;
    if (expand) return (0, $ebyGx.stringify)({
        ...otherOpts,
        expand: expand.join(',')
    });
    return (0, $ebyGx.stringify)(otherOpts);
};
const $0f36cff0fb97de2b$export$8837f4fc672e936d = (projectId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
    const apiPath = `/api/project/${projectId}/article?${queryString}`;
    const url = `${apolloPath}/${activationId}${apiPath}`;
    return (0, $5OrSA.fetchJson$)(url).map((response)=>({
            ...response,
            results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
        }));
};
const $0f36cff0fb97de2b$export$897d9115a17b4c24 = (projectId, categoryId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
    const apiPath = `/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article?${queryString}`;
    const url = `${apolloPath}/${activationId}${apiPath}`;
    return (0, $5OrSA.fetchJson$)(url).map((response)=>({
            ...response,
            results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
        }));
};
const $0f36cff0fb97de2b$export$f8c0d0a39b0d7d4e = (projectId, articleId, withCategory, apolloPath = (0, $45c806b56a43da0e$export$8ce6d23ffa1a190a))=>{
    const url = `${apolloPath}/api/project/${projectId}/article/${articleId}`;
    const queryString = withCategory ? `?${(0, $ebyGx.stringify)({
        expand: 'category'
    })}` : '';
    return (0, $5OrSA.fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
};
const $0f36cff0fb97de2b$export$fb27d96404fd219d = (projectId, articleId, activationId, expandParams, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}`;
    const queryString = expandParams.length ? `?${$0f36cff0fb97de2b$var$getQueryString({
        expand: expandParams
    })}` : '';
    return (0, $5OrSA.fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
};
const $0f36cff0fb97de2b$export$d93a983139fde0cc = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/category`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'PATCH',
        body: JSON.stringify({
            categories: categoryIds
        })
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$2613b83c3141003a = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}/category`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'PUT',
        body: JSON.stringify({
            spaceKey: spaceKey,
            categories: categoryIds
        })
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$6f4beca8ff3702f3 = (projectKey)=>{
    const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb`;
    const transformedResponse = (0, $5OrSA.fetchJson$)(url).map((response)=>({
            spaces: response.map((space)=>({
                    name: space.spaceName,
                    key: space.spaceKey,
                    appLinkId: space.appLinkId
                }))
        }));
    return transformedResponse;
};
const $0f36cff0fb97de2b$export$f40640db2a9b7e80 = ({ projectId: projectId, labels: labels, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'POST',
        body: JSON.stringify(labels)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$cba6b78bbfb96381 = ({ projectId: projectId, label: label, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label/${encodeURIComponent(label)}`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'DELETE'
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$8502c8a97aecfbad = (projectKey, queryString, articleId)=>{
    const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb/labels?query=${queryString}&contentId=${articleId}`;
    return (0, $7f4tk.default)(url).then(({ contentNameMatches: contentNameMatches })=>{
        if (!contentNameMatches?.length) return [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const suggestions = contentNameMatches.reduce((labelList, contentNameMatch)=>{
            if (contentNameMatch.length) // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...labelList,
                ...contentNameMatch
            ];
            return labelList;
        }, []);
        return suggestions.length ? suggestions.map(({ name: name })=>({
                label: name,
                value: name
            })) : [];
    }).catch(()=>[]);
};
const $0f36cff0fb97de2b$export$65396ff44dade790 = (cloudId, articleId, projectId, accountId, sendCustomHeaders, spaceKey)=>{
    const body = {
        subject: {
            type: 'user',
            identifier: accountId
        },
        operation: 'update'
    };
    const headers = sendCustomHeaders ? {
        'Content-Type': 'application/json',
        'X-ATL-EmbeddablePage-EntityIds': JSON.stringify({
            spaceKey: spaceKey || '',
            parentProduct: 'JSM',
            parentProductContentContainerId: projectId,
            contentId: articleId
        })
    } : {
        'Content-Type': 'application/json'
    };
    return (0, $5OrSA.fetchJson$)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/${articleId}/permission/check`, {
        method: 'POST',
        headers: // @ts-expect-error - TS-2322 Please check what's correct: either add `headers` to fetchJson$ `options` type, or remove this argument, if function does not support it and it does nothing
        headers,
        body: JSON.stringify(body)
    }).catch((error)=>(0, $kVLXA.Observable).throw(error));
};

});

parcelRegister("6ovlC", function(module, exports) {

$parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE", () => $5b88d8b66d98e99f$export$c22494f1249599aa);
$parcel$export(module.exports, "addCategoriesForArticle", () => $5b88d8b66d98e99f$export$d93a983139fde0cc);
const $5b88d8b66d98e99f$export$c22494f1249599aa = 'state.actions.add-categories-for-article.ADD_CATEGORIES_FOR_ARTICLE';
const $5b88d8b66d98e99f$export$d93a983139fde0cc = (payload)=>({
        payload: payload,
        type: $5b88d8b66d98e99f$export$c22494f1249599aa
    });

});

parcelRegister("5XgTr", function(module, exports) {

$parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_SUCCESS", () => $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2);
$parcel$export(module.exports, "addCategoriesForArticleSuccess", () => $b60bbe4f4c92ec4f$export$deab1340d30ad632);
const $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2 = 'state.actions.add-categories-for-article-success.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS';
const $b60bbe4f4c92ec4f$export$deab1340d30ad632 = (payload)=>({
        payload: payload,
        type: $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2
    });

});

const $aaa081f4160162a5$export$b8b9d90f9e5bd72b = 'jiraServiceDeskKnowledgeHub';


parcelRegister("eGP51", function(module, exports) {

$parcel$export(module.exports, "epic", () => $b7199b09d6315b91$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $80A0Z = parcelRequire("80A0Z");

var $e8y9X = parcelRequire("e8y9X");

var $8j0bg = parcelRequire("8j0bg");

var $gLt7z = parcelRequire("gLt7z");

const $b7199b09d6315b91$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $80A0Z.ADD_LABELS_TO_ARTICLE)).mergeMap((action)=>{
        const { labels: labels, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        return (0, $fmmX1.addLabelsToArticles)({
            projectId: projectId,
            labels: labels,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map((response)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onAddLabels success', {
                articleId: articleId
            });
            return (0, $8j0bg.addLabelsToArticleSuccess)(response);
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onAddLabelsFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $e8y9X.addLabelsToArticleFailure)({
                articleId: articleId
            }));
        });
    });

});
parcelRegister("80A0Z", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE", () => $f87c53beb7b3ea22$export$2b91058f81222c91);
$parcel$export(module.exports, "addLabelsToArticle", () => $f87c53beb7b3ea22$export$335c057b91702017);
const $f87c53beb7b3ea22$export$2b91058f81222c91 = 'state.actions.add-labels-to-article.ADD_LABELS_TO_ARTICLE';
const $f87c53beb7b3ea22$export$335c057b91702017 = (payload)=>({
        payload: payload,
        type: $f87c53beb7b3ea22$export$2b91058f81222c91
    });

});

parcelRegister("e8y9X", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_FAILURE", () => $68db2bd167d08867$export$836fc3274a0c8c08);
$parcel$export(module.exports, "addLabelsToArticleFailure", () => $68db2bd167d08867$export$46974ef034e5e1ff);
const $68db2bd167d08867$export$836fc3274a0c8c08 = 'state.actions.add-labels-to-article-failure.ADD_LABELS_TO_ARTICLE_FAILURE';
const $68db2bd167d08867$export$46974ef034e5e1ff = (payload)=>({
        payload: payload,
        type: $68db2bd167d08867$export$836fc3274a0c8c08
    });

});

parcelRegister("8j0bg", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_SUCCESS", () => $7cdb79ea2b68767f$export$fb41ea70dd3d20e7);
$parcel$export(module.exports, "addLabelsToArticleSuccess", () => $7cdb79ea2b68767f$export$1d48c14841a2dd90);
const $7cdb79ea2b68767f$export$fb41ea70dd3d20e7 = 'state.actions.add-labels-to-article-success.ADD_LABELS_TO_ARTICLE_SUCCESS';
const $7cdb79ea2b68767f$export$1d48c14841a2dd90 = (payload)=>({
        payload: payload,
        type: $7cdb79ea2b68767f$export$fb41ea70dd3d20e7
    });

});


parcelRegister("4DyVT", function(module, exports) {

$parcel$export(module.exports, "epic", () => $01135ff527d8b512$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $i4zGm = parcelRequire("i4zGm");

var $kHzxc = parcelRequire("kHzxc");

var $33YKl = parcelRequire("33YKl");

var $4VDwv = parcelRequire("4VDwv");

var $gLt7z = parcelRequire("gLt7z");

var $fhG9v = parcelRequire("fhG9v");

const $01135ff527d8b512$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $kHzxc.BROWSE_KNOWLEDGE)).mergeMap((action)=>{
        const page = action.payload.page || 1;
        const state = store.getState();
        const limit = action.payload.limit || (0, $fhG9v.getBrowseLimit)(state);
        const projectId = (0, $gLt7z.getProjectId)(state);
        const spaceKey = action.payload.spaceKey ?? '';
        const cursor = action.payload.cursor ?? '';
        const activationId = (0, $gLt7z.getActivationId)(state);
        let requestParams = {
            categoryId: action.payload.id,
            expand: action.payload.expand,
            orderby: action.payload.orderBy,
            limit: limit
        };
        const query = action.payload.query != null ? action.payload.query : '';
        if (query) // @ts-expect-error - TS2322 - Type '{ query: string; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
        requestParams = {
            ...requestParams,
            query: query
        };
        if (spaceKey) // @ts-expect-error - TS2322 - Type '{ spaceKey: string[]; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
        requestParams = {
            ...requestParams,
            spaceKey: spaceKey
        };
        if (cursor) // @ts-expect-error - TS2322 - Type '{ cursor: string; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
        requestParams = {
            ...requestParams,
            cursor: cursor
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
        const EVENT_NAME = requestParams.categoryId !== 'all-articles' ? 'browseArticleInCategory' : 'browseArticles';
        return (0, $i4zGm.list)(projectId, activationId, requestParams).map((response)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({});
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${EVENT_NAME} success`, {
                    projectId: projectId
                });
            }
            return (0, $4VDwv.browseKnowledgeSuccess)({
                id: action.payload.id,
                ...response,
                page: page
            });
        }).catch((error)=>{
            const { statusCode: statusCode } = error;
            if (createAnalyticsEvent) (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: createAnalyticsEvent({}),
                id: `${EVENT_NAME} failure`,
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $33YKl.browseKnowledgeFailure)({
                id: action.payload.id,
                page: page,
                statusCode: statusCode
            }));
        });
    });

});
parcelRegister("i4zGm", function(module, exports) {

$parcel$export(module.exports, "list", () => $45a2c0bfdac04a79$export$8837f4fc672e936d);
$parcel$export(module.exports, "linkedSpaces", () => $45a2c0bfdac04a79$export$d3636d9abefdd232);

var $fmmX1 = parcelRequire("fmmX1");
const $45a2c0bfdac04a79$export$8837f4fc672e936d = (projectId, activationId, { categoryId: categoryId, ...opts })=>{
    if (categoryId === 'all-articles') return (0, $fmmX1.list)(projectId, opts, activationId);
    return (0, $fmmX1.listCategoryArticles)(projectId, categoryId, opts, activationId);
};
const $45a2c0bfdac04a79$export$d3636d9abefdd232 = (projectKey)=>(0, $fmmX1.getAllLinkedSpaces)(projectKey);

});

parcelRegister("kHzxc", function(module, exports) {

$parcel$export(module.exports, "BROWSE_KNOWLEDGE", () => $e17bf0108bb950f1$export$8b6d2338550bad51);
$parcel$export(module.exports, "browseKnowledge", () => $e17bf0108bb950f1$export$66132e21cee3da17);
const $e17bf0108bb950f1$export$8b6d2338550bad51 = 'state.actions.browse-knowledge.BROWSE_KNOWLEDGE';
const $e17bf0108bb950f1$export$66132e21cee3da17 = (payload)=>({
        type: $e17bf0108bb950f1$export$8b6d2338550bad51,
        payload: payload
    });

});

parcelRegister("33YKl", function(module, exports) {

$parcel$export(module.exports, "BROWSE_KNOWLEDGE_FAILURE", () => $da91aed3c1c538b9$export$be396dbd2f8b61b5);
$parcel$export(module.exports, "browseKnowledgeFailure", () => $da91aed3c1c538b9$export$a84d455b463b93e5);

var $dMhXw = parcelRequire("dMhXw");
const $da91aed3c1c538b9$export$be396dbd2f8b61b5 = 'state.actions.browse-knowledge-failure.BROWSE_KNOWLEDGE_FAILURE';
const $da91aed3c1c538b9$export$a84d455b463b93e5 = (opts)=>({
        type: $da91aed3c1c538b9$export$be396dbd2f8b61b5,
        payload: {
            id: opts.id,
            page: opts.page,
            error: {
                message: (0, $dMhXw.default).genericMessage,
                header: (0, $dMhXw.default).genericHeader
            }
        }
    });

});
parcelRegister("dMhXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $060d0dd30f30d38c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $060d0dd30f30d38c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-header",
        "defaultMessage": "Something went wrong"
    },
    genericMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-message",
        "defaultMessage": "We couldn't load the articles. Please refresh and try again."
    }
});

});


parcelRegister("4VDwv", function(module, exports) {

$parcel$export(module.exports, "BROWSE_KNOWLEDGE_SUCCESS", () => $fdd461c5c2f5f7b7$export$b9ec4df681504dbb);
$parcel$export(module.exports, "browseKnowledgeSuccess", () => $fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d);
const $fdd461c5c2f5f7b7$export$b9ec4df681504dbb = 'state.actions.browse-knowledge-success.BROWSE_KNOWLEDGE_SUCCESS';
const $fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d = (payload)=>({
        type: $fdd461c5c2f5f7b7$export$b9ec4df681504dbb,
        payload: payload
    });

});

parcelRegister("fhG9v", function(module, exports) {

$parcel$export(module.exports, "getArticleIdsForCategory", () => $da36dd250036e782$export$bb874ade4016b878);
$parcel$export(module.exports, "getCategoryTotalSize", () => $da36dd250036e782$export$165fede49970bd0c);
$parcel$export(module.exports, "getBrowseLimit", () => $da36dd250036e782$export$adc0ce73adb3dc4a);
$parcel$export(module.exports, "getBrowseNextCursor", () => $da36dd250036e782$export$4b2e4efe9c0df2cd);
$parcel$export(module.exports, "getBrowsePrevCursor", () => $da36dd250036e782$export$f7e999777526d95e);
$parcel$export(module.exports, "isCategoriesSupported", () => $da36dd250036e782$export$cfb809beeaa82062);
$parcel$export(module.exports, "isBrowseLoading", () => $da36dd250036e782$export$aecf0fb6e785d5e0);
$parcel$export(module.exports, "getArticlesLoading", () => $da36dd250036e782$export$327a4e3439ce6c6a);
const $da36dd250036e782$export$bb874ade4016b878 = (state, categoryId, page = 1)=>state.entities.browse[categoryId] ? state.entities.browse[categoryId].pages[`${page}`] : undefined;
const $da36dd250036e782$export$165fede49970bd0c = (state, categoryId)=>state.entities.browse[categoryId].totalSize;
const $da36dd250036e782$export$adc0ce73adb3dc4a = (state)=>state.entities.browse.limit;
const $da36dd250036e782$export$4b2e4efe9c0df2cd = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].nextCursor ?? '' : '';
const $da36dd250036e782$export$f7e999777526d95e = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].prevCursor ?? '' : '';
const $da36dd250036e782$export$cfb809beeaa82062 = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].categoriesSupported ?? true : true;
const $da36dd250036e782$export$aecf0fb6e785d5e0 = (state, categoryId)=>state.entities.browse[categoryId] === undefined;
const $da36dd250036e782$export$327a4e3439ce6c6a = (state)=>!!state.entities.browse.loading;

});


parcelRegister("feRMu", function(module, exports) {

$parcel$export(module.exports, "epic", () => $40f3d7cc48e99b60$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jrkeZ = parcelRequire("jrkeZ");

var $gMZw6 = parcelRequire("gMZw6");

var $6FRaa = parcelRequire("6FRaa");

var $aZdbu = parcelRequire("aZdbu");

var $gLt7z = parcelRequire("gLt7z");
const $40f3d7cc48e99b60$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $gMZw6.FETCH_APPLINK)).mergeMap(()=>{
        const projectKey = (0, $gLt7z.getProjectKey)(store.getState());
        return (0, $jrkeZ.fetchCurrentAppLink)(projectKey).mergeMap((appLink)=>(0, $kVLXA.Observable).of((0, $aZdbu.fetchAppLinkSuccess)(appLink))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, $6FRaa.fetchAppLinkFailure)({
                statusCode: statusCode
            })));
    });

});
parcelRegister("jrkeZ", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceAppLinks", () => $75401d703e62a5e6$export$411bec8e101d37ea);
$parcel$export(module.exports, "fetchCurrentAppLink", () => $75401d703e62a5e6$export$f1e8c76efca169f3);
$parcel$export(module.exports, "fetchCurrentAppLinkV2", () => $75401d703e62a5e6$export$a5d48ab772ff4e41);
$parcel$export(module.exports, "fetchConfluenceLink", () => $75401d703e62a5e6$export$1eeb53c23f99ec16);
$parcel$export(module.exports, "fetchConfluenceLinkRestful", () => $75401d703e62a5e6$export$c71d13c885efd437);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $7f4tk = parcelRequire("7f4tk");

var $kTM7r = parcelRequire("kTM7r");

var $5QK3R = parcelRequire("5QK3R");
const $75401d703e62a5e6$export$411bec8e101d37ea = (projectKey)=>(0, $5QK3R.fetchAppLinkNoEyeball)(projectKey);
const $75401d703e62a5e6$export$916391fe3383489b = (projectKey)=>(0, $5QK3R.fetchAppLinkNoEyeball)(projectKey).map((data)=>data.appLinks.find((link)=>link.isSystem));
const $75401d703e62a5e6$export$f1e8c76efca169f3 = (projectKey)=>(0, $5QK3R.fetchCurrentAppLinkNoEyeball)(projectKey);
const $75401d703e62a5e6$export$a5d48ab772ff4e41 = (projectKey)=>(0, $5QK3R.fetchCurrentAppLinkNoEyeballV2)(projectKey);
const $75401d703e62a5e6$export$1eeb53c23f99ec16 = (projectKey)=>{
    const kbLink = (0, $kTM7r.wrmClaimSafe)('sd-kb-link');
    if (kbLink) {
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
        if (kbLink && !kbLink.error) return (0, $kVLXA.Observable).of({
            projectKey: projectKey,
            // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
            id: kbLink.id,
            // @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
            spaceKey: kbLink.spaceKey,
            // This is the base URL of the KB instance, not Jira
            /* eslint-disable-next-line jira/deprecations/no-base-url */ // @ts-expect-error - TS2339 - Property 'baseUrl' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
            baseUrl: kbLink.baseUrl
        });
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
        if (kbLink && kbLink.error) return (0, $kVLXA.Observable).throw(kbLink);
    }
    return (0, $kVLXA.Observable).throw({
        error: {
            key: 'sd.applinks.error.corrupt'
        }
    });
};
const $75401d703e62a5e6$var$ERROR_KEY_MAP = {
    '404': 'sd.kb.link.error.link.not.found',
    other: 'sd.applinks.error.corrupt'
};
const $75401d703e62a5e6$export$c71d13c885efd437 = (projectKey)=>{
    const url = `/rest/servicedesk/1/pages/agent/knowledge/${projectKey}`;
    return (0, $7f4tk.default)(url).catch((err)=>// eslint-disable-next-line prefer-promise-reject-errors
        Promise.reject({
            error: {
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly '404': "sd.kb.link.error.link.not.found"; readonly other: "sd.applinks.error.corrupt"; }'.
                key: $75401d703e62a5e6$var$ERROR_KEY_MAP[err.statusCode] || $75401d703e62a5e6$var$ERROR_KEY_MAP.other
            }
        }));
};

});
parcelRegister("kTM7r", function(module, exports) {

$parcel$export(module.exports, "wrmClaimSafe", () => $7a3f570973700129$export$6d04651d170462ec);
/**
 * Claim the WRM data provided by the JIRA instance, utilises the wrm data cache where available.
 * <p>
 *
 * @param {string} key - WRM data key defined by JIRA or the JIRA plugin
 * @returns {*} data obtained from the WRM data set
 */ const $7a3f570973700129$export$6d04651d170462ec = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.wrmDataCache = window.wrmDataCache || {};
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.wrmDataCache[key]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.wrmDataCache[key];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const data = window.WRM.data.claim(key);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.wrmDataCache[key] = data;
    return data;
};
const $7a3f570973700129$export$460d685a9ee326a8 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const claimedData = window.WRM.data.claim(key);
    if (claimedData === undefined) throw new Error(`Could not find WRM data for key: ${key}`);
    return claimedData;
};

});

parcelRegister("5QK3R", function(module, exports) {

$parcel$export(module.exports, "fetchAppLinkNoEyeball", () => $00051febdde61fec$export$d888e54a19706e84);
$parcel$export(module.exports, "fetchCurrentAppLinkNoEyeball", () => $00051febdde61fec$export$91f2ef831add2534);
$parcel$export(module.exports, "fetchCurrentAppLinkNoEyeballV2", () => $00051febdde61fec$export$2727b4e442c6787f);

var $7f4tk = parcelRequire("7f4tk");

var $5OrSA = parcelRequire("5OrSA");
const $00051febdde61fec$export$d888e54a19706e84 = (projectKey)=>(0, $5OrSA.fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence`);
const $00051febdde61fec$export$91f2ef831add2534 = (projectKey)=>(0, $5OrSA.fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);
const $00051febdde61fec$export$2727b4e442c6787f = (projectKey)=>(0, $7f4tk.default)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);

});


parcelRegister("6FRaa", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINK_FAILURE", () => $5c0435e88e4a5ddc$export$1763acbd33c374e5);
$parcel$export(module.exports, "fetchAppLinkFailure", () => $5c0435e88e4a5ddc$export$635f69357a47e715);
const $5c0435e88e4a5ddc$export$1763acbd33c374e5 = 'state.actions.fetch-applink-failure.FETCH_APPLINK_FAILURE';
const $5c0435e88e4a5ddc$export$635f69357a47e715 = (error)=>({
        type: $5c0435e88e4a5ddc$export$1763acbd33c374e5,
        payload: error
    });

});

parcelRegister("aZdbu", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINK_SUCCESS", () => $cada50d61c624db3$export$5a66f7b0b7a57504);
$parcel$export(module.exports, "fetchAppLinkSuccess", () => $cada50d61c624db3$export$d64417727a56e7f1);
const $cada50d61c624db3$export$5a66f7b0b7a57504 = 'state.actions.fetch-applink-success.FETCH_APPLINK_SUCCESS';
const $cada50d61c624db3$export$d64417727a56e7f1 = (payload)=>({
        type: $cada50d61c624db3$export$5a66f7b0b7a57504,
        payload: payload
    });

});


parcelRegister("kTAvA", function(module, exports) {

$parcel$export(module.exports, "epic", () => $034fe31e006c1c0e$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jrkeZ = parcelRequire("jrkeZ");

var $4dXi2 = parcelRequire("4dXi2");

var $3XkGj = parcelRequire("3XkGj");

var $7GY3F = parcelRequire("7GY3F");

var $gLt7z = parcelRequire("gLt7z");
const $034fe31e006c1c0e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $4dXi2.FETCH_APPLINKS)).mergeMap(()=>{
        const projectKey = (0, $gLt7z.getProjectKey)(store.getState());
        return (0, $jrkeZ.fetchConfluenceAppLinks)(projectKey).mergeMap((appLinks)=>(0, $kVLXA.Observable).of((0, $7GY3F.fetchAppLinksSuccess)(appLinks.appLinks))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, $3XkGj.fetchAppLinksFailure)({
                statusCode: statusCode
            })));
    });

});
parcelRegister("4dXi2", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINKS", () => $01bf9f555ca0b395$export$e7bce13a560ead5e);
$parcel$export(module.exports, "fetchAppLinks", () => $01bf9f555ca0b395$export$ee72e8e00b4fb176);
const $01bf9f555ca0b395$export$e7bce13a560ead5e = 'state.actions.fetch-applinks.FETCH_APPLINKS';
const $01bf9f555ca0b395$export$ee72e8e00b4fb176 = ()=>({
        type: $01bf9f555ca0b395$export$e7bce13a560ead5e
    });

});

parcelRegister("3XkGj", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINKS_FAILURE", () => $daac65f7a8dc65e2$export$51c9d05978c1783b);
$parcel$export(module.exports, "fetchAppLinksFailure", () => $daac65f7a8dc65e2$export$c460ed087c66a41d);
const $daac65f7a8dc65e2$export$51c9d05978c1783b = 'state.actions.fetch-applinks-failure.FETCH_APPLINKS_FAILURE';
const $daac65f7a8dc65e2$export$c460ed087c66a41d = (error)=>({
        type: $daac65f7a8dc65e2$export$51c9d05978c1783b,
        payload: error
    });

});

parcelRegister("7GY3F", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINKS_SUCCESS", () => $81371e274ff768f8$export$de0056b0bbdd21c8);
$parcel$export(module.exports, "fetchAppLinksSuccess", () => $81371e274ff768f8$export$56072929934471cd);
const $81371e274ff768f8$export$de0056b0bbdd21c8 = 'state.actions.fetch-applinks-success.FETCH_APPLINKS_SUCCESS';
const $81371e274ff768f8$export$56072929934471cd = (payload)=>({
        type: $81371e274ff768f8$export$de0056b0bbdd21c8,
        payload: payload
    });

});


parcelRegister("cpM8i", function(module, exports) {

$parcel$export(module.exports, "epic", () => $f95e339a734ecb5c$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $la4EY = parcelRequire("la4EY");

var $39oW5 = parcelRequire("39oW5");

var $4C8gV = parcelRequire("4C8gV");

var $agxSw = parcelRequire("agxSw");

var $gLt7z = parcelRequire("gLt7z");

const $f95e339a734ecb5c$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $la4EY.FETCH_ARTICLE)).mergeMap((action)=>{
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = action.payload;
        const getArticleObservable = (0, $fmmX1.getArticleWithExpandParams)(projectId, id, activationId, [
            'category',
            'labels'
        ]);
        return getArticleObservable.mergeMap((article)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $agxSw.fetchArticleSuccess)(article)), (0, $kVLXA.Observable).of((0, $39oW5.fetchArticleEditPermission)(id, accountId, createAnalyticsEvent, article.spaceKey || '')))).catch((error)=>{
            (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: createAnalyticsEvent({}),
                id: 'fetchArticle failure',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $4C8gV.fetchArticleFailure)({
                id: id,
                statusCode: error.statusCode
            }));
        });
    });

});
parcelRegister("39oW5", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE_EDIT_PERMISSION", () => $21d9f874c3cb8395$export$2f278bb19228e406);
$parcel$export(module.exports, "fetchArticleEditPermission", () => $21d9f874c3cb8395$export$65396ff44dade790);
const $21d9f874c3cb8395$export$2f278bb19228e406 = 'state.actions.fetch-article-edit-permission.FETCH_ARTICLE_EDIT_PERMISSION';
const $21d9f874c3cb8395$export$65396ff44dade790 = (id, accountId, createAnalyticsEvent, spaceKey)=>({
        type: $21d9f874c3cb8395$export$2f278bb19228e406,
        payload: {
            id: id,
            spaceKey: spaceKey,
            accountId: accountId,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});

parcelRegister("4C8gV", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => $e3473a94e4383912$export$862d1fc538bf047c);
$parcel$export(module.exports, "fetchArticleFailure", () => $e3473a94e4383912$export$b135c19fc249d3ab);

var $4zIHa = parcelRequire("4zIHa");
const $e3473a94e4383912$export$862d1fc538bf047c = 'state.actions.fetch-article-failure.FETCH_ARTICLE_FAILURE';
const $e3473a94e4383912$export$b135c19fc249d3ab = (opts)=>({
        type: $e3473a94e4383912$export$862d1fc538bf047c,
        payload: {
            id: opts.id,
            error: opts.statusCode === 404 ? {
                message: (0, $4zIHa.default).notFoundMessage,
                header: (0, $4zIHa.default).notFoundHeader,
                ctaText: (0, $4zIHa.default).genericSearchCta,
                ctaLink: '/knowledge'
            } : {
                message: (0, $4zIHa.default).genericMessage,
                header: (0, $4zIHa.default).genericHeader,
                ctaText: (0, $4zIHa.default).genericSearchCta,
                ctaLink: '/knowledge'
            }
        }
    });

});
parcelRegister("4zIHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1714dd9e0ac9ecf4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1714dd9e0ac9ecf4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-header",
        "defaultMessage": "Can't find this article"
    },
    notFoundMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-message",
        "defaultMessage": "You may not have permission to view this article, you may not have permission to access Confluence, or this article may not exist."
    },
    genericHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-header",
        "defaultMessage": "Something went wrong"
    },
    genericMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-message",
        "defaultMessage": "We couldn't load this article. Please refresh after a few minutes."
    },
    genericSearchCta: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-search-cta",
        "defaultMessage": "Browse all articles"
    }
});

});


parcelRegister("agxSw", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => $345896be0e3d6472$export$2d213dcac7fc3339);
$parcel$export(module.exports, "fetchArticleSuccess", () => $345896be0e3d6472$export$6910c63a4b3017af);
const $345896be0e3d6472$export$2d213dcac7fc3339 = 'state.actions.fetch-article-success.FETCH_ARTICLE_SUCCESS';
const $345896be0e3d6472$export$6910c63a4b3017af = (payload)=>({
        type: $345896be0e3d6472$export$2d213dcac7fc3339,
        payload: payload
    });

});


parcelRegister("bDRTj", function(module, exports) {

$parcel$export(module.exports, "epic", () => $90f2b96f2a0068c3$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $39oW5 = parcelRequire("39oW5");

var $fTBH5 = parcelRequire("fTBH5");

var $gLt7z = parcelRequire("gLt7z");

const $90f2b96f2a0068c3$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $39oW5.FETCH_ARTICLE_EDIT_PERMISSION)).mergeMap((action)=>{
        const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent, spaceKey: spaceKey } = action.payload;
        const cloudId = (0, $gLt7z.getCloudId)(store.getState());
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        return (0, $fmmX1.fetchArticleEditPermission)(cloudId, id, projectId, accountId, true, spaceKey).mergeMap(({ hasPermission: hasPermission })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchArticleEditPermission success', {
                articleId: id
            });
            return (0, $kVLXA.Observable).of((0, $fTBH5.setArticleEditPermission)(hasPermission, id));
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onFetchArticleEditPermission failure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $fTBH5.setArticleEditPermission)(false, id));
        });
    });

});
parcelRegister("fTBH5", function(module, exports) {

$parcel$export(module.exports, "SET_ARTICLE_EDIT_PERMISSION", () => $9fa31b3f751a812f$export$b3431c0d5e84092c);
$parcel$export(module.exports, "setArticleEditPermission", () => $9fa31b3f751a812f$export$bb3e34eb2358e906);
const $9fa31b3f751a812f$export$b3431c0d5e84092c = 'state.actions.set-article-edit-permission.SET_ARTICLE_EDIT_PERMISSION';
const $9fa31b3f751a812f$export$bb3e34eb2358e906 = (isEditable, articleId)=>({
        type: $9fa31b3f751a812f$export$b3431c0d5e84092c,
        payload: {
            isEditable: isEditable,
            articleId: articleId
        }
    });

});


parcelRegister("a20m8", function(module, exports) {

$parcel$export(module.exports, "epic", () => $e17a2d6c79b83d30$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $guSo6 = parcelRequire("guSo6");

var $jpaaK = parcelRequire("jpaaK");

var $4COnH = parcelRequire("4COnH");

var $7gdJb = parcelRequire("7gdJb");

var $gLt7z = parcelRequire("gLt7z");

const $e17a2d6c79b83d30$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $jpaaK.FETCH_CATEGORIES)).mergeMap((action)=>{
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const { analyticsEvent: analyticsEvent } = action.payload;
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        return (0, $guSo6.listCategories)(projectId, activationId).mergeMap((categories)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                projectId: projectId
            });
            return (0, $kVLXA.Observable).of((0, $7gdJb.fetchCategoriesSuccess)(categories));
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onFetchCategoriesFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $4COnH.fetchCategoriesFailure)(error));
        });
    });

});
parcelRegister("jpaaK", function(module, exports) {

$parcel$export(module.exports, "FETCH_CATEGORIES", () => $b9a08106a74df812$export$cce9a7031b65f96c);
const $b9a08106a74df812$export$cce9a7031b65f96c = 'state.actions.fetch-categories.FETCH_CATEGORIES';
const $b9a08106a74df812$export$416ec9f5729de215 = (payload)=>({
        type: $b9a08106a74df812$export$cce9a7031b65f96c,
        payload: payload
    });

});

parcelRegister("4COnH", function(module, exports) {

$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => $ab63acaf2733bdc5$export$4425a101b60fad1);
$parcel$export(module.exports, "fetchCategoriesFailure", () => $ab63acaf2733bdc5$export$10b1ac5b71f5513e);
const $ab63acaf2733bdc5$export$4425a101b60fad1 = 'state.actions.fetch-categories-failure.FETCH_CATEGORIES_FAILURE';
const $ab63acaf2733bdc5$export$10b1ac5b71f5513e = (error)=>({
        type: $ab63acaf2733bdc5$export$4425a101b60fad1,
        payload: error
    });

});

parcelRegister("7gdJb", function(module, exports) {

$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => $abc28ada0f8a3d9a$export$8fe15054f89178e3);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => $abc28ada0f8a3d9a$export$1372a078b0bbb728);
const $abc28ada0f8a3d9a$export$8fe15054f89178e3 = 'state.actions.fetch-categories-success.FETCH_CATEGORIES_SUCCESS';
const $abc28ada0f8a3d9a$export$1372a078b0bbb728 = (payload)=>({
        type: $abc28ada0f8a3d9a$export$8fe15054f89178e3,
        payload: payload
    });

});


parcelRegister("gTvcp", function(module, exports) {

$parcel$export(module.exports, "epic", () => $ab48fc04d604b95e$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $jrkeZ = parcelRequire("jrkeZ");

var $791HF = parcelRequire("791HF");

var $eIzL1 = parcelRequire("eIzL1");

var $dtw6v = parcelRequire("dtw6v");

var $gLt7z = parcelRequire("gLt7z");

var $knU3A = parcelRequire("knU3A");
const $ab48fc04d604b95e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $791HF.FETCH_KB_HUB)).mergeMap((action)=>{
        const state = store.getState();
        const projectKey = (0, $gLt7z.getProjectKey)(state);
        const linkedState = (0, $knU3A.getHubLinkedState)(state);
        if (linkedState === 'linked') return (0, $kVLXA.Observable).empty();
        // Try wrmClaim
        return (0, $jrkeZ.fetchConfluenceLink)(action.payload.projectKey).mergeMap((link)=>(0, $kVLXA.Observable).of((0, $dtw6v.fetchKbHubSuccess)(link))).catch(()=>// wrmClaim REST fallback
            (0, $kVLXA.Observable).fromPromise((0, $jrkeZ.fetchConfluenceLinkRestful)(projectKey)).map((link)=>(0, $dtw6v.fetchKbHubSuccess)(link)).catch((err)=>(0, $kVLXA.Observable).of((0, $eIzL1.fetchKbHubFailure)(err))));
    });

});
parcelRegister("791HF", function(module, exports) {

$parcel$export(module.exports, "FETCH_KB_HUB", () => $2cbea12bc7a00f0f$export$6838769d7df96fbb);
// FETCH KB HUB
const $2cbea12bc7a00f0f$export$6838769d7df96fbb = 'state.actions.fetch-knowledge-hub.FETCH_KB_HUB';
const $2cbea12bc7a00f0f$export$647aec6b80785904 = (projectKey)=>({
        type: $2cbea12bc7a00f0f$export$6838769d7df96fbb,
        payload: {
            projectKey: projectKey
        }
    });

});

parcelRegister("eIzL1", function(module, exports) {

$parcel$export(module.exports, "FETCH_KB_HUB_FAILURE", () => $be2f3f4be23b75f6$export$100d6710da08cb59);
$parcel$export(module.exports, "fetchKbHubFailure", () => $be2f3f4be23b75f6$export$7b9ad8413eaffe44);
// FETCH KB HUB FAILURE
const $be2f3f4be23b75f6$export$100d6710da08cb59 = 'state.actions.fetch-knowledge-hub-failure.FETCH_KB_HUB_FAILURE';
const $be2f3f4be23b75f6$export$7b9ad8413eaffe44 = (payload)=>({
        type: $be2f3f4be23b75f6$export$100d6710da08cb59,
        payload: payload
    });

});

parcelRegister("dtw6v", function(module, exports) {

$parcel$export(module.exports, "FETCH_KB_HUB_SUCCESS", () => $db188543ec32993c$export$52043214fd798dd);
$parcel$export(module.exports, "fetchKbHubSuccess", () => $db188543ec32993c$export$3b2b22c5e24bfc30);
const $db188543ec32993c$export$52043214fd798dd = 'state.actions.fetch-knowledge-hub-success.FETCH_KB_HUB_SUCCESS';
const $db188543ec32993c$export$3b2b22c5e24bfc30 = (payload)=>({
        type: $db188543ec32993c$export$52043214fd798dd,
        payload: payload
    });

});

parcelRegister("knU3A", function(module, exports) {

$parcel$export(module.exports, "getHubLinkedState", () => $13b0808aee851dca$export$9b336974117966dd);
$parcel$export(module.exports, "getLinkedConfluenceUrl", () => $13b0808aee851dca$export$fea8defd3093e8e3);
$parcel$export(module.exports, "getLinkedConfluenceSpace", () => $13b0808aee851dca$export$6c88aaaf8fc8b7f1);
const $13b0808aee851dca$export$9b336974117966dd = (state)=>state.entities.hub.linkedState;
const $13b0808aee851dca$export$fea8defd3093e8e3 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.confluenceUrl : undefined;
const $13b0808aee851dca$export$6c88aaaf8fc8b7f1 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.spaceKey : undefined;

});


parcelRegister("4JAV5", function(module, exports) {

$parcel$export(module.exports, "epic", () => $f044973d8abb6a80$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $i4zGm = parcelRequire("i4zGm");

var $goH2j = parcelRequire("goH2j");

var $azjdP = parcelRequire("azjdP");

var $jzG6G = parcelRequire("jzG6G");
const $f044973d8abb6a80$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, $goH2j.FETCH_LINKED_SPACES)).mergeMap((action)=>{
        const { projectKey: projectKey } = action.payload;
        return (0, $i4zGm.linkedSpaces)(projectKey).map((response)=>(0, $jzG6G.fetchLinkedSpacesSuccess)(response)).catch(()=>(0, $kVLXA.Observable).of((0, $azjdP.fetchLinkedSpacesFailure)()));
    });

});
parcelRegister("goH2j", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => $c793be7dffec599b$export$3d78263a729bb91);
$parcel$export(module.exports, "fetchLinkedSpaces", () => $c793be7dffec599b$export$1999596e4ea30c16);
const $c793be7dffec599b$export$3d78263a729bb91 = 'state.actions.fetch-linked-spaces.FETCH_LINKED_SPACES';
const $c793be7dffec599b$export$1999596e4ea30c16 = (payload)=>({
        type: $c793be7dffec599b$export$3d78263a729bb91,
        payload: payload
    });

});

parcelRegister("azjdP", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => $cf0b03dea91f2721$export$9c186423b974805a);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => $cf0b03dea91f2721$export$e63a5f7249c4e5d6);

var $NEu0c = parcelRequire("NEu0c");
const $cf0b03dea91f2721$export$9c186423b974805a = 'state.actions.fetch-linked-spaces-failure.FETCH_LINKED_SPACES_FAILURE';
const $cf0b03dea91f2721$export$e63a5f7249c4e5d6 = ()=>({
        type: $cf0b03dea91f2721$export$9c186423b974805a,
        payload: {
            error: {
                message: (0, $NEu0c.default).genericMessage,
                header: (0, $NEu0c.default).genericHeader
            }
        }
    });

});
parcelRegister("NEu0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc9fdd816f4c370f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc9fdd816f4c370f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-header",
        "defaultMessage": "Something went wrong"
    },
    genericMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-message",
        "defaultMessage": "We couldn't load the linked spaces. Please refresh and try again."
    }
});

});


parcelRegister("jzG6G", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_SPACE_SUCCESS", () => $366933797ff4c171$export$5142badf262ccc86);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => $366933797ff4c171$export$ad2cc5272eef487);
const $366933797ff4c171$export$5142badf262ccc86 = 'state.actions.fetch-linked-spaces-success.FETCH_LINKED_SPACE_SUCCESS';
const $366933797ff4c171$export$ad2cc5272eef487 = (payload)=>({
        type: $366933797ff4c171$export$5142badf262ccc86,
        payload: payload
    });

});


parcelRegister("iYJ1l", function(module, exports) {

$parcel$export(module.exports, "epic", () => $c4c23b3440ef4ce4$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $l1APE = parcelRequire("l1APE");

var $iHUHp = parcelRequire("iHUHp");

var $9aNfZ = parcelRequire("9aNfZ");

var $gLt7z = parcelRequire("gLt7z");

const $c4c23b3440ef4ce4$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $l1APE.REMOVE_LABEL_FROM_ARTICLE)).mergeMap((action)=>{
        const { label: label, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        return (0, $fmmX1.removeLabelsFromArticles)({
            projectId: projectId,
            label: label,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onRemoveLabel success', {
                articleId: articleId
            });
            return (0, $9aNfZ.removeLabelFromArticleSuccess)({
                articleId: articleId,
                label: label
            });
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onRemoveLabelFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $iHUHp.removeLabelFromArticleFailure)({
                articleId: articleId
            }));
        });
    });

});
parcelRegister("l1APE", function(module, exports) {

$parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE", () => $6c5650e2e1eb67b6$export$ad78add1bc20cf2e);
$parcel$export(module.exports, "removeLabelFromArticle", () => $6c5650e2e1eb67b6$export$c7cf56492591fe0f);
const $6c5650e2e1eb67b6$export$ad78add1bc20cf2e = 'state.actions.remove-label-from-article.REMOVE_LABEL_FROM_ARTICLE';
const $6c5650e2e1eb67b6$export$c7cf56492591fe0f = (payload)=>({
        payload: payload,
        type: $6c5650e2e1eb67b6$export$ad78add1bc20cf2e
    });

});

parcelRegister("9aNfZ", function(module, exports) {

$parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_SUCCESS", () => $16ef0dd8936a9692$export$a9305d58f2d32098);
$parcel$export(module.exports, "removeLabelFromArticleSuccess", () => $16ef0dd8936a9692$export$2aaf552c4301b8b9);
const $16ef0dd8936a9692$export$a9305d58f2d32098 = 'state.actions.remove-label-from-article-success.REMOVE_LABEL_FROM_ARTICLE_SUCCESS';
const $16ef0dd8936a9692$export$2aaf552c4301b8b9 = (payload)=>({
        payload: payload,
        type: $16ef0dd8936a9692$export$a9305d58f2d32098
    });

});


parcelRegister("92ShW", function(module, exports) {

$parcel$export(module.exports, "epic", () => $699ec73c490fb4c9$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("8n054");
parcelRequire("6cbqE");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("2agIZ");

var $i4zGm = parcelRequire("i4zGm");

var $hkbfC = parcelRequire("hkbfC");

var $gLt7z = parcelRequire("gLt7z");
const $699ec73c490fb4c9$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $hkbfC.SEARCH_ARTICLES)).mergeMap(()=>(0, $gLt7z.getBaseUrl)(store.getState()));
const $699ec73c490fb4c9$export$83f762cb3c8bb65a = (activationId)=>{
    const stream$ = new (0, $cab1K.Subject)();
    // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<{ term: any; projectId: any; limit: any; searchOnEmptyTerm: any; categoryId: any; expansions: any; orderBy: any; }>'.
    const results$ = stream$// @ts-expect-error - TS2345 - Argument of type '({ term }: { term: any; }) => Observable<number>' is not assignable to parameter of type '(value: unknown) => SubscribableOrPromise<number>'.
    .debounce(({ term: term })=>(0, $kVLXA.Observable).timer(term ? 300 : 0)).switchMap(({ term: term, projectId: projectId, limit: limit, searchOnEmptyTerm: searchOnEmptyTerm, categoryId: categoryId, expansions: expansions, orderBy: orderBy })=>{
        if (!searchOnEmptyTerm && !term) {
            const empty = {
                results: [],
                totalSize: 0,
                start: 0,
                limit: 0,
                size: 0,
                categoriesSupported: true
            };
            return (0, $kVLXA.Observable).of(empty);
        }
        return (0, $i4zGm.list)(projectId, activationId, {
            limit: limit,
            categoryId: categoryId,
            query: term,
            expand: expansions,
            orderby: orderBy
        });
    });
    return {
        search: (args)=>stream$.next(args),
        results$: results$
    };
};

});
parcelRegister("hkbfC", function(module, exports) {

$parcel$export(module.exports, "SEARCH_ARTICLES", () => $b106701f9da61eca$export$9d662e85b068d1ae);
// SEARCH ARTICLES
const $b106701f9da61eca$export$9d662e85b068d1ae = 'state.actions.search-articles.SEARCH_ARTICLES';
const $b106701f9da61eca$export$ce4856e0aa50b880 = (payload)=>({
        type: $b106701f9da61eca$export$9d662e85b068d1ae,
        payload: payload
    });

});


parcelRegister("6OXm8", function(module, exports) {

$parcel$export(module.exports, "epic", () => $611d4a2326bd0c8a$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $19Gv3 = parcelRequire("19Gv3");

var $6zk4x = parcelRequire("6zk4x");

var $ffNrT = parcelRequire("ffNrT");

var $gXg4u = parcelRequire("gXg4u");

var $gLt7z = parcelRequire("gLt7z");

const $611d4a2326bd0c8a$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $19Gv3.UPDATE_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
        const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        const currentCategoryIds = (0, $gXg4u.getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
        return (0, $fmmX1.updateCategoriesForArticle)({
            projectId: projectId,
            categoryIds: categoryIds,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map(()=>{
            (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
                action: 'update',
                actionSubjectId: articleId
            });
            return (0, $ffNrT.updateCategoriesForArticleSuccess)({
                articleId: articleId,
                categoryIds: categoryIds,
                previousCategoryIds: currentCategoryIds
            });
        }).catch((error)=>{
            const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
            (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: analyticsEvent,
                id: 'articleUpdate Failure',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $6zk4x.updateCategoriesForArticleFailure)({
                statusCode: statusCode,
                errorKey: errorKey,
                errorMessage: errorMessage,
                failedCategoryIds: categories,
                articleId: articleId
            }));
        });
    });

});
parcelRegister("19Gv3", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE", () => $44779a20dce37d77$export$a58f1691e9b5c9e3);
$parcel$export(module.exports, "updateCategoriesForArticle", () => $44779a20dce37d77$export$2613b83c3141003a);
const $44779a20dce37d77$export$a58f1691e9b5c9e3 = 'state.actions.update-categories-for-article.UPDATE_CATEGORIES_FOR_ARTICLE';
const $44779a20dce37d77$export$2613b83c3141003a = (payload)=>({
        payload: payload,
        type: $44779a20dce37d77$export$a58f1691e9b5c9e3
    });

});

parcelRegister("ffNrT", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS", () => $80acc745b1c17a99$export$1c5489fde8a5332f);
$parcel$export(module.exports, "updateCategoriesForArticleSuccess", () => $80acc745b1c17a99$export$c725200756c4c1a2);
const $80acc745b1c17a99$export$1c5489fde8a5332f = 'state.actions.update-categories-for-article-success.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS';
const $80acc745b1c17a99$export$c725200756c4c1a2 = (payload)=>({
        payload: payload,
        type: $80acc745b1c17a99$export$1c5489fde8a5332f
    });

});



parcelRegister("1eweq", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubContainer", () => $248571581b729595$export$bb94633c27dcd0a4);
$parcel$export(module.exports, "KnowledgeHubActionsSubscriber", () => $248571581b729595$export$3982d9a4b6ad6814);

var $7JoAD = parcelRequire("7JoAD");

var $1xzCS = parcelRequire("1xzCS");
const $248571581b729595$export$168a0875d66dd4b7 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $248571581b729595$export$e155678cbf296809 = ()=>({ getState: getState })=>getState();
const $248571581b729595$export$e324594224ef24da = {
    updateStore: $248571581b729595$export$168a0875d66dd4b7,
    getStoreState: $248571581b729595$export$e155678cbf296809
};
const $248571581b729595$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    name: 'knowledge-hub',
    initialState: $1xzCS.defaultState,
    actions: $248571581b729595$export$e324594224ef24da
});
const $248571581b729595$export$bb94633c27dcd0a4 = (0, $7JoAD.createContainer)($248571581b729595$export$390f32400eaf98c9);
const $248571581b729595$export$44bc38849b4bbf73 = (0, $7JoAD.createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
    displayName: 'KnowledgeHubState'
});
const $248571581b729595$export$3982d9a4b6ad6814 = (0, $7JoAD.createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
    displayName: 'KnowledgeHubActions',
    selector: null
});
const $248571581b729595$export$81f6ad95dee7b9c = (0, $7JoAD.createHook)($248571581b729595$export$390f32400eaf98c9, {
    selector: null
});

});
parcelRegister("1xzCS", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $349a74123be4d8a0$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $349a74123be4d8a0$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $kChFH = parcelRequire("kChFH");

var $3nEyX = parcelRequire("3nEyX");

var $lJvk4 = parcelRequire("lJvk4");
const $349a74123be4d8a0$var$reducer = (0, $3f2cs.combineReducers)({
    app: $kChFH.default,
    ui: $lJvk4.default,
    entities: $3nEyX.default
});
const $349a74123be4d8a0$export$49d5fc8cba920a0 = {
    app: (0, $kChFH.defaultState),
    ui: (0, $lJvk4.defaultState),
    entities: (0, $3nEyX.defaultState)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$349a74123be4d8a0$export$2e2bcd8739ae039 = (sweetStateUpdater)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state = $349a74123be4d8a0$export$49d5fc8cba920a0, action)=>{
        const outputState = $349a74123be4d8a0$var$reducer(state, action);
        sweetStateUpdater(outputState);
        return outputState;
    };

});
parcelRegister("kChFH", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $1551bcf88a1371a5$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $1551bcf88a1371a5$export$2e2bcd8739ae039);

var $lzeFL = parcelRequire("lzeFL");

var $g5X3G = parcelRequire("g5X3G");

var $kstMB = parcelRequire("kstMB");
const $1551bcf88a1371a5$export$49d5fc8cba920a0 = {
    baseUrl: (0, $g5X3G.toBaseUrl)(''),
    atlassianAccountId: '',
    cloudId: '',
    fabricPfDirUrl: '',
    locale: (0, $lzeFL.defaultLocale),
    userFullname: '',
    portalId: -1,
    projectKey: (0, $g5X3G.toProjectKey)(''),
    projectId: -1,
    projectName: '',
    projectType: '',
    isAdmin: false,
    isJiraAdmin: false,
    isProjectSimplified: false,
    sidebarCategoryLabel: '',
    activationId: 'ee20ebad-e5a1-42f6-899b-18706f0559e7'
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1551bcf88a1371a5$export$2e2bcd8739ae039 = (state = $1551bcf88a1371a5$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $kstMB.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload
            };
        case 0, $kstMB.UPDATE_CATEGORY_SIDEBAR_LABEL:
            return {
                ...state,
                sidebarCategoryLabel: action.payload
            };
        default:
            return state;
    }
};

});
parcelRegister("kstMB", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $802af204f69179eb$export$84856e4ae7cd7538);
$parcel$export(module.exports, "UPDATE_CATEGORY_SIDEBAR_LABEL", () => $802af204f69179eb$export$52e22c956d5c6839);
const $802af204f69179eb$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $802af204f69179eb$export$52e22c956d5c6839 = 'state.actions.app.UPDATE_CATEGORY_SIDEBAR_LABEL';
const $802af204f69179eb$export$5f0e35553cecddfe = (payload)=>({
        type: $802af204f69179eb$export$84856e4ae7cd7538,
        payload: payload
    });
const $802af204f69179eb$export$c2eea28c04c00544 = (payload)=>({
        type: $802af204f69179eb$export$52e22c956d5c6839,
        payload: payload
    });

});


parcelRegister("3nEyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $599b129cc2fb02a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultState", () => $599b129cc2fb02a8$export$49d5fc8cba920a0);

var $3f2cs = parcelRequire("3f2cs");

var $fmcS9 = parcelRequire("fmcS9");

var $gS1i9 = parcelRequire("gS1i9");

var $kahXZ = parcelRequire("kahXZ");

var $5ev1t = parcelRequire("5ev1t");

var $aCUFo = parcelRequire("aCUFo");

var $jsmdo = parcelRequire("jsmdo");

var $3h2aI = parcelRequire("3h2aI");
var $599b129cc2fb02a8$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    hub: $jsmdo.default,
    articles: $kahXZ.default,
    browse: $5ev1t.default,
    categories: $aCUFo.default,
    spaces: $3h2aI.default,
    appLink: $fmcS9.default,
    appLinks: $gS1i9.default
});
const $599b129cc2fb02a8$export$49d5fc8cba920a0 = {
    hub: (0, $jsmdo.defaultState),
    articles: (0, $kahXZ.defaultState),
    browse: (0, $5ev1t.defaultState),
    categories: (0, $aCUFo.defaultState),
    spaces: (0, $3h2aI.defaultState),
    appLink: (0, $fmcS9.defaultState),
    appLinks: (0, $gS1i9.defaultState)
};

});
parcelRegister("fmcS9", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $f5121befb21ec1b4$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $f5121befb21ec1b4$export$2e2bcd8739ae039);

var $gMZw6 = parcelRequire("gMZw6");

var $6FRaa = parcelRequire("6FRaa");

var $aZdbu = parcelRequire("aZdbu");
const $f5121befb21ec1b4$export$49d5fc8cba920a0 = {
    isLoaded: false,
    appLink: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5121befb21ec1b4$export$2e2bcd8739ae039 = (state = $f5121befb21ec1b4$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $gMZw6.FETCH_APPLINK:
            {
                const { error: error, ...stateWithoutError } = state;
                const newState = {
                    ...stateWithoutError,
                    isLoaded: false
                };
                return newState;
            }
        case 0, $aZdbu.FETCH_APPLINK_SUCCESS:
            return {
                ...state,
                isLoaded: true,
                appLink: action.payload
            };
        case 0, $6FRaa.FETCH_APPLINK_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoaded: true
            };
        default:
            return state;
    }
};

});

parcelRegister("gS1i9", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $39212e89b0790fee$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $39212e89b0790fee$export$2e2bcd8739ae039);

var $4dXi2 = parcelRequire("4dXi2");

var $3XkGj = parcelRequire("3XkGj");

var $7GY3F = parcelRequire("7GY3F");
const $39212e89b0790fee$export$49d5fc8cba920a0 = {
    isLoaded: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39212e89b0790fee$export$2e2bcd8739ae039 = (state = $39212e89b0790fee$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $4dXi2.FETCH_APPLINKS:
            return {
                ...state,
                error: undefined,
                isLoaded: false
            };
        case 0, $7GY3F.FETCH_APPLINKS_SUCCESS:
            return {
                appLinks: action.payload,
                error: undefined,
                hasConfluenceServer: action.payload.some((appLink)=>appLink.isServer),
                isLoaded: true
            };
        case 0, $3XkGj.FETCH_APPLINKS_FAILURE:
            return {
                appLinks: [],
                error: action.payload,
                hasConfluenceServer: false,
                isLoaded: true
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("kahXZ", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $16983ab139c0b8e5$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $16983ab139c0b8e5$export$2e2bcd8739ae039);

var $4wVpT = parcelRequire("4wVpT");

var $1UikQ = parcelRequire("1UikQ");

var $hqULQ = parcelRequire("hqULQ");

var $6ovlC = parcelRequire("6ovlC");

var $5sKH1 = parcelRequire("5sKH1");

var $5XgTr = parcelRequire("5XgTr");

var $80A0Z = parcelRequire("80A0Z");

var $e8y9X = parcelRequire("e8y9X");

var $8j0bg = parcelRequire("8j0bg");

var $4VDwv = parcelRequire("4VDwv");

var $la4EY = parcelRequire("la4EY");

var $4C8gV = parcelRequire("4C8gV");

var $agxSw = parcelRequire("agxSw");

var $3pXRi = parcelRequire("3pXRi");

var $iMgsY = parcelRequire("iMgsY");

var $e4spq = parcelRequire("e4spq");

var $l1APE = parcelRequire("l1APE");

var $iHUHp = parcelRequire("iHUHp");

var $9aNfZ = parcelRequire("9aNfZ");

var $hsOR7 = parcelRequire("hsOR7");

var $fTBH5 = parcelRequire("fTBH5");

var $19Gv3 = parcelRequire("19Gv3");

var $6zk4x = parcelRequire("6zk4x");

var $ffNrT = parcelRequire("ffNrT");
const $16983ab139c0b8e5$export$49d5fc8cba920a0 = {};
const $16983ab139c0b8e5$var$articleListToObject = (articles)=>articles.reduce((acc, article)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [article.id]: {
                ...article,
                // This is required to handle the response provided
                // by the legacy JSD endpoint.
                // We can remove this when browseAllArticlesMilestone1
                // is unfeatured.
                title: (0, $hqULQ.removeHighlightText)(article.title),
                categories: article.categories && article.categories.map((category)=>category.id)
            }
        }), {});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16983ab139c0b8e5$export$2e2bcd8739ae039 = (state = $16983ab139c0b8e5$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $3pXRi.REMOVE_ARTICLE_FROM_CATEGORY:
        case 0, $6ovlC.ADD_CATEGORIES_FOR_ARTICLE:
        case 0, $19Gv3.UPDATE_CATEGORIES_FOR_ARTICLE:
            if (state[action.payload.articleId]) return {
                ...state,
                [action.payload.articleId]: {
                    ...state[action.payload.articleId],
                    isBusy: true
                }
            };
            return state;
        case 0, $iMgsY.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE:
        case 0, $5sKH1.ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
        case 0, $6zk4x.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
            if (state[action.payload.articleId]) return {
                ...state,
                [action.payload.articleId]: {
                    ...state[action.payload.articleId],
                    isBusy: false
                }
            };
            return state;
        case 0, $e4spq.REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS:
            if (state[action.payload.articleId]) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[action.payload.articleId];
                const { categoryId: categoryId } = action.payload;
                const newCategoriesList = (existingArticle.categories || []).filter((id)=>id !== categoryId);
                const featuredInCategoryList = (existingArticle.featuredInCategories || []).filter((id)=>id !== categoryId);
                return {
                    ...state,
                    [action.payload.articleId]: {
                        ...existingArticle,
                        categories: newCategoriesList,
                        featuredInCategories: featuredInCategoryList,
                        isBusy: false
                    }
                };
            }
            return state;
        case 0, $5XgTr.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { articleId: articleId, categoryIds: newlyAddedCategoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                const allCategoryIds = [
                    ...previousCategoryIds,
                    ...newlyAddedCategoryIds
                ];
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle) {
                    const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                    // only keep featured in categories list with update categories
                    const featuredInCategories = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allCategoryIds, existingFeaturedInCategoryIds);
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            featuredInCategories: featuredInCategories,
                            categories: allCategoryIds,
                            isBusy: false
                        }
                    };
                }
                return state;
            }
        case 0, $ffNrT.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle) {
                    const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                    // only keep featured in categories list with update categories
                    const featuredInCategories = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(categoryIds, existingFeaturedInCategoryIds);
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            featuredInCategories: featuredInCategories,
                            categories: categoryIds,
                            isBusy: false
                        }
                    };
                }
                return state;
            }
        case 0, $4VDwv.BROWSE_KNOWLEDGE_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload.results));
        case 0, $hsOR7.SEARCH_ARTICLES_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload));
        case 0, $la4EY.FETCH_ARTICLE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (state[action.payload.id] && state[action.payload.id].error) {
                const newState = {
                    ...state
                };
                // Remove the article from state if it had an error when fetching again
                delete newState[action.payload.id];
                return newState;
            }
            return state;
        case 0, $agxSw.FETCH_ARTICLE_SUCCESS:
            {
                const { payload: payload } = action;
                const categories = payload.categories ? {
                    categories: payload.categories.map((category)=>category.id)
                } : {};
                const featuredInCategories = payload.featuredInCategories ? {
                    featuredInCategories: payload.featuredInCategories
                } : {};
                const labels = payload.labels?.length ? payload.labels.map(({ id: id, label: label, name: name })=>({
                        id: id,
                        label: label,
                        name: name
                    })) : [];
                const labelState = {
                    labels: labels,
                    isLoading: false,
                    addLabelError: false
                };
                const { labels: existingLabels, isEditable: isEditable, ...payloadWithoutLabels } = payload;
                const articleState = {
                    ...payloadWithoutLabels,
                    ...categories,
                    ...featuredInCategories,
                    labelState: labelState,
                    isEditable: false
                };
                return {
                    ...state,
                    [action.payload.id]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state[action.payload.id], articleState)
                };
            }
        case 0, $4C8gV.FETCH_ARTICLE_FAILURE:
            return {
                ...state,
                [action.payload.id]: {
                    error: action.payload.error
                }
            };
        case 0, $8j0bg.ADD_LABELS_TO_ARTICLE_SUCCESS:
            {
                const { articleId: articleId, labels: labels } = action.payload;
                const existingArticle = state[articleId];
                if (existingArticle) {
                    const updatedLabels = labels.length ? labels.map(({ id: id, label: label, name: name })=>({
                            id: id,
                            label: label,
                            name: name
                        })) : [];
                    const labelState = {
                        labels: updatedLabels,
                        isLoading: false,
                        addLabelError: false
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $9aNfZ.REMOVE_LABEL_FROM_ARTICLE_SUCCESS:
            {
                const { label: label, articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const labelState = existingArticle.labelState || {};
                    const existingLabels = labelState.labels || [];
                    const updatedLabels = existingLabels?.length ? existingLabels.filter(({ label: existingLabel })=>label !== existingLabel) : [];
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: {
                                labels: updatedLabels,
                                isLoading: false,
                                addLabelError: false
                            }
                        }
                    };
                }
                return state;
            }
        case 0, $e8y9X.ADD_LABELS_TO_ARTICLE_FAILURE:
            {
                const { articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle && existingArticle.labelState) {
                    const existingLabels = existingArticle.labelState.labels || [];
                    const labelState = {
                        labels: existingLabels,
                        isLoading: false,
                        addLabelError: true
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $l1APE.REMOVE_LABEL_FROM_ARTICLE:
        case 0, $80A0Z.ADD_LABELS_TO_ARTICLE:
            {
                const { articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle && existingArticle.labelState) {
                    const existingLabels = existingArticle.labelState.labels || [];
                    const labelState = {
                        labels: existingLabels,
                        isLoading: true,
                        addLabelError: false
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $iHUHp.REMOVE_LABEL_FROM_ARTICLE_FAILURE:
            {
                const { articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle && existingArticle.labelState) {
                    const existingLabels = existingArticle.labelState.labels || [];
                    const labelState = {
                        labels: existingLabels,
                        isLoading: false,
                        addLabelError: false
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $fTBH5.SET_ARTICLE_EDIT_PERMISSION:
            {
                const { articleId: articleId, isEditable: isEditable } = action.payload;
                const existingArticle = state[articleId];
                if (existingArticle) return {
                    ...state,
                    [articleId]: {
                        ...existingArticle,
                        isEditable: isEditable
                    }
                };
                return state;
            }
        default:
            return state;
    }
};

});
parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});


parcelRegister("hqULQ", function(module, exports) {

$parcel$export(module.exports, "removeHighlightText", () => $483996128e1ce34e$export$4fe678a311e29d1a);
const $483996128e1ce34e$export$4fe678a311e29d1a = (text)=>text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');

});

parcelRegister("3pXRi", function(module, exports) {

$parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY", () => $df3a27bd08a194ec$export$ffc4687de776860c);
$parcel$export(module.exports, "removeArticleFromCategory", () => $df3a27bd08a194ec$export$b6002acecf935894);
const $df3a27bd08a194ec$export$ffc4687de776860c = 'state.actions.remove-article-from-category.REMOVE_ARTICLE_FROM_CATEGORY';
const $df3a27bd08a194ec$export$b6002acecf935894 = (payload)=>({
        payload: payload,
        type: $df3a27bd08a194ec$export$ffc4687de776860c
    });

});

parcelRegister("iMgsY", function(module, exports) {

$parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_FAILURE", () => $e6e2e62b66b39b7e$export$30c079f32002614a);
const $e6e2e62b66b39b7e$export$30c079f32002614a = 'state.actions.remove-article-from-category-failure.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE';
const $e6e2e62b66b39b7e$export$9c7b80de1b92cc2 = (payload)=>({
        payload: payload,
        type: $e6e2e62b66b39b7e$export$30c079f32002614a
    });

});

parcelRegister("e4spq", function(module, exports) {

$parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS", () => $1b3b33db699d8db2$export$8bab89f0adf16580);
const $1b3b33db699d8db2$export$8bab89f0adf16580 = 'state.actions.remove-article-from-category-success.REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS';
const $1b3b33db699d8db2$export$37035f42efedefca = (payload)=>({
        type: $1b3b33db699d8db2$export$8bab89f0adf16580,
        payload: payload
    });

});

parcelRegister("hsOR7", function(module, exports) {

$parcel$export(module.exports, "SEARCH_ARTICLES_SUCCESS", () => $4257b84175002daa$export$b377bab65795997b);
const $4257b84175002daa$export$b377bab65795997b = 'state.actions.search-articles-success.SEARCH_ARTICLES_SUCCESS';
const $4257b84175002daa$export$327940e72204ca9b = (payload)=>({
        type: $4257b84175002daa$export$b377bab65795997b,
        payload: payload
    });

});


parcelRegister("5ev1t", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $22d8828255293e73$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $22d8828255293e73$export$2e2bcd8739ae039);

var $16dzj = parcelRequire("16dzj");

var $kHzxc = parcelRequire("kHzxc");

var $33YKl = parcelRequire("33YKl");

var $4VDwv = parcelRequire("4VDwv");

var $0523Q = parcelRequire("0523Q");

var $ffNrT = parcelRequire("ffNrT");
const $22d8828255293e73$export$49d5fc8cba920a0 = {
    limit: 20
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$22d8828255293e73$export$2e2bcd8739ae039 = (state = $22d8828255293e73$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $ffNrT.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { categoryIds: categoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                if (categoryIds) {
                    const newState = {
                        ...state
                    };
                    const categoryIdsNeededCacheClear = (0, (/*@__PURE__*/$parcel$interopDefault($16dzj)))(categoryIds, previousCategoryIds);
                    categoryIdsNeededCacheClear.forEach((categoryId)=>{
                        if (newState[categoryId]) newState[categoryId].shouldClearCacheOnNextFetch = true;
                    });
                    return newState;
                }
                return state;
            }
        case 0, $0523Q.CLEAR_BROWSE:
            {
                const newState = {
                    ...state
                };
                delete newState[action.payload];
                return newState;
            }
        case 0, $kHzxc.BROWSE_KNOWLEDGE:
            if (state[action.payload.id] && state[action.payload.id].pages[`${action.payload.page}`] && // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'string[] | GenericError'.
            state[action.payload.id].pages[`${action.payload.page}`].error) {
                const newState = {
                    ...state,
                    loading: true
                };
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ loading: boolean; limit: number; }'.
                delete newState[action.payload.id].pages[`${action.payload.page}`];
                // @ts-expect-error - TS2322 - Type '{ loading: boolean; limit: number; }' is not assignable to type 'BrowseState'.
                return newState;
            }
            if (state[action.payload.id] && state[action.payload.id].shouldClearCacheOnNextFetch) {
                const newState = {
                    ...state,
                    loading: true,
                    [action.payload.id]: {
                        ...state[action.payload.id],
                        shouldClearCacheOnNextFetch: false,
                        pages: {}
                    }
                };
                // @ts-expect-error - TS2322 - Type '{ [x: string]: boolean | BrowseCategoryState | { shouldClearCacheOnNextFetch: boolean; pages: {}; totalSize: number; nextCursor?: string | undefined; prevCursor?: string | undefined; previousPagePath?: string | undefined; categoriesSupported: boolean; }; loading: boolean; limit: number; }' is not assignable to type 'BrowseState'.
                return newState;
            }
            // @ts-expect-error - TS2322 - Type '{ loading: true; limit: number; }' is not assignable to type 'BrowseState'.
            return {
                ...state,
                loading: true
            };
        case 0, $33YKl.BROWSE_KNOWLEDGE_FAILURE:
            // eslint-disable-next-line no-case-declarations
            const newFailureState = {
                ...state,
                loading: false,
                [action.payload.id]: {
                    pages: {
                        [`${action.payload.page}`]: {
                            error: action.payload.error
                        }
                    }
                }
            };
            // @ts-expect-error - TS2322 - Type '{ readonly [x: string]: false | BrowseCategoryState | { readonly pages: { readonly [x: string]: { readonly error: GenericErrorObject; }; }; }; readonly loading: false; readonly limit: number; }' is not assignable to type 'BrowseState'.
            return newFailureState;
        case 0, $4VDwv.BROWSE_KNOWLEDGE_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const newSuccessState = {
                ...state,
                loading: false,
                [action.payload.id]: {
                    totalSize: action.payload.totalSize,
                    categoriesSupported: action.payload.categoriesSupported,
                    pages: {
                        ...state[action.payload.id] ? state[action.payload.id].pages : {},
                        [`${action.payload.page}`]: action.payload.results.map((article)=>article.id)
                    },
                    nextCursor: action.payload.nextCursor || '',
                    prevCursor: action.payload.prevCursor || ''
                }
            };
            // @ts-expect-error - TS2322 - Type '{ readonly [x: string]: false | BrowseCategoryState | { readonly nextCursor: string; readonly prevCursor: string; readonly totalSize: number; readonly categoriesSupported: boolean; readonly pages: { ...; }; }; readonly loading: false; readonly limit: number; }' is not assignable to type 'BrowseState'.
            return newSuccessState;
        default:
            return state;
    }
};

});
parcelRegister("16dzj", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
    return $7txx8($2GdQn(arrays, $f3SOL));
});
module.exports = $0cd0e06461d5e057$var$xor;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("0523Q", function(module, exports) {

$parcel$export(module.exports, "CLEAR_BROWSE", () => $bf00c744d75604af$export$6795bd145eb16b7e);
const $bf00c744d75604af$export$6795bd145eb16b7e = 'state.actions.clear-browse.CLEAR_BROWSE';
const $bf00c744d75604af$export$862ad1bcf49b6105 = (categoryId)=>({
        type: $bf00c744d75604af$export$6795bd145eb16b7e,
        payload: categoryId
    });

});


parcelRegister("aCUFo", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $67411d71966dddb0$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $67411d71966dddb0$export$2e2bcd8739ae039);

var $4VDwv = parcelRequire("4VDwv");

var $agxSw = parcelRequire("agxSw");

var $jpaaK = parcelRequire("jpaaK");

var $4COnH = parcelRequire("4COnH");

var $7gdJb = parcelRequire("7gdJb");

var $hsOR7 = parcelRequire("hsOR7");
const $67411d71966dddb0$export$49d5fc8cba920a0 = {
    isLoaded: false,
    categories: [],
    isCategoriesSupported: false
};
const $67411d71966dddb0$var$reduceCategoriesFromArticles = (articles, existingCategories)=>{
    const categories = [
        ...existingCategories
    ];
    articles // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, article)=>acc.concat(article.categories), []).forEach((category)=>{
        if (category && !categories.find((existingCategory)=>category.id === existingCategory.id)) categories.push(category);
    });
    return categories;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67411d71966dddb0$export$2e2bcd8739ae039 = (state = $67411d71966dddb0$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $7gdJb.FETCH_CATEGORIES_SUCCESS:
            return {
                categories: action.payload.categories,
                isCategoriesSupported: action.payload.categoriesSupported,
                isLoaded: true
            };
        case 0, $4COnH.FETCH_CATEGORIES_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoaded: true
            };
        case 0, $jpaaK.FETCH_CATEGORIES:
            {
                // Maintain existing categories and set loading state to true
                const newState = {
                    ...state,
                    isLoaded: false
                };
                delete newState.error;
                return newState;
            }
        case 0, $4VDwv.BROWSE_KNOWLEDGE_SUCCESS:
            {
                const newState = {
                    ...state,
                    categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload.results, state.categories)
                };
                return newState;
            }
        case 0, $hsOR7.SEARCH_ARTICLES_SUCCESS:
            {
                const newState = {
                    ...state,
                    categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload, state.categories)
                };
                return newState;
            }
        case 0, $agxSw.FETCH_ARTICLE_SUCCESS:
            {
                const newState = {
                    ...state,
                    categories: $67411d71966dddb0$var$reduceCategoriesFromArticles([
                        action.payload
                    ], state.categories)
                };
                return newState;
            }
        default:
            return state;
    }
};

});

parcelRegister("jsmdo", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $8ca7f66155305974$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $8ca7f66155305974$export$2e2bcd8739ae039);

var $eIzL1 = parcelRequire("eIzL1");

var $dtw6v = parcelRequire("dtw6v");

var $bHD2d = parcelRequire("bHD2d");

var $k9iYw = parcelRequire("k9iYw");
const $8ca7f66155305974$export$49d5fc8cba920a0 = {
    linkedState: 'loading'
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8ca7f66155305974$export$2e2bcd8739ae039 = (state = $8ca7f66155305974$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $dtw6v.FETCH_KB_HUB_SUCCESS:
            {
                const { projectKey: _, ...data } = action.payload;
                return {
                    id: data.id,
                    confluenceUrl: (0, $k9iYw.removeTrailingSlash)(data.baseUrl),
                    spaceKey: data.spaceKey,
                    linkedState: 'linked'
                };
            }
        case 0, $eIzL1.FETCH_KB_HUB_FAILURE:
            if (action.payload.error.key === 'sd.kb.link.error.link.not.found') // Confluence was either not linked, or no space was linked yet.
            return {
                linkedState: 'unlinked'
            };
            return {
                messageKey: action.payload.error.key,
                linkedState: 'error'
            };
        case 0, $bHD2d.SET_KB_HUB:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("bHD2d", function(module, exports) {

$parcel$export(module.exports, "SET_KB_HUB", () => $35c3183d0ed1f802$export$5d4aeddc17f0cd0f);
$parcel$export(module.exports, "setKbHub", () => $35c3183d0ed1f802$export$3f646e047bd99e08);
const $35c3183d0ed1f802$export$5d4aeddc17f0cd0f = 'state.actions.set-knowledge-hub.SET_KB_HUB';
const $35c3183d0ed1f802$export$3f646e047bd99e08 = (payload)=>({
        type: $35c3183d0ed1f802$export$5d4aeddc17f0cd0f,
        payload: payload
    });

});

parcelRegister("k9iYw", function(module, exports) {

$parcel$export(module.exports, "removeTrailingSlash", () => $f5e36f4cfb7d0348$export$b6d465111d914331);
const $f5e36f4cfb7d0348$export$b6d465111d914331 = (str)=>str.replace(/\/$/, '');

});


parcelRegister("3h2aI", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $c0be59ff1e3dfebc$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $c0be59ff1e3dfebc$export$2e2bcd8739ae039);

var $goH2j = parcelRequire("goH2j");

var $azjdP = parcelRequire("azjdP");

var $jzG6G = parcelRequire("jzG6G");
const $c0be59ff1e3dfebc$export$49d5fc8cba920a0 = {
    linkedSpaces: {
        data: [],
        error: null,
        loading: false
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c0be59ff1e3dfebc$export$2e2bcd8739ae039 = (state = $c0be59ff1e3dfebc$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $goH2j.FETCH_LINKED_SPACES:
            return {
                ...state,
                linkedSpaces: {
                    data: [],
                    error: null,
                    loading: true
                }
            };
        case 0, $jzG6G.FETCH_LINKED_SPACE_SUCCESS:
            return {
                ...state,
                linkedSpaces: {
                    error: null,
                    loading: false,
                    data: action.payload.spaces
                }
            };
        case 0, $azjdP.FETCH_LINKED_SPACES_FAILURE:
            return {
                ...state,
                linkedSpaces: {
                    loading: false,
                    data: [],
                    error: action.payload.error
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("lJvk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fc5aff003b114a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultState", () => $61fc5aff003b114a$export$49d5fc8cba920a0);

var $3f2cs = parcelRequire("3f2cs");

var $daO3a = parcelRequire("daO3a");
var $61fc5aff003b114a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    articles: $daO3a.default
});
const $61fc5aff003b114a$export$49d5fc8cba920a0 = {
    articles: (0, $daO3a.defaultState)
};

});
parcelRegister("daO3a", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $ffb3ac562043eddf$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $ffb3ac562043eddf$export$2e2bcd8739ae039);

var $6ovlC = parcelRequire("6ovlC");

var $5sKH1 = parcelRequire("5sKH1");

var $5XgTr = parcelRequire("5XgTr");

var $9fA8j = parcelRequire("9fA8j");

var $5ZGnB = parcelRequire("5ZGnB");

var $19Gv3 = parcelRequire("19Gv3");

var $6zk4x = parcelRequire("6zk4x");

var $ffNrT = parcelRequire("ffNrT");

var $fQZG5 = parcelRequire("fQZG5");
const $ffb3ac562043eddf$export$49d5fc8cba920a0 = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffb3ac562043eddf$export$2e2bcd8739ae039 = (state = $ffb3ac562043eddf$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $6ovlC.ADD_CATEGORIES_FOR_ARTICLE:
        case 0, $19Gv3.UPDATE_CATEGORIES_FOR_ARTICLE:
            {
                const { categoryIds: categoryIds, articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        isShowingBulkCategoryAdder: !!(state[articleId] && state[articleId].isShowingBulkCategoryAdder),
                        categoriesInBulkCategoryAdder: state[articleId] ? state[articleId].categoriesInBulkCategoryAdder : [],
                        categoryIds: categoryIds
                    }
                };
            }
        case 0, $ffNrT.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
        case 0, $5XgTr.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { articleId: articleId } = action.payload;
                const newState = {
                    ...state
                };
                delete newState[articleId];
                return newState;
            }
        case 0, $6zk4x.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
        case 0, $5sKH1.ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
            {
                const { failedCategoryIds: failedCategoryIds, errorMessage: errorMessage, articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        failedCategoryIds: failedCategoryIds,
                        error: errorMessage
                    }
                };
            }
        case 0, $5ZGnB.SHOW_BULK_CATEGORY_ADDER:
            {
                const { articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        isShowingBulkCategoryAdder: true
                    }
                };
            }
        case 0, $9fA8j.HIDE_BULK_CATEGORY_ADDER:
            {
                const { articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        isShowingBulkCategoryAdder: false,
                        categoriesInBulkCategoryAdder: []
                    }
                };
            }
        case 0, $fQZG5.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER:
            {
                const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        categoriesInBulkCategoryAdder: categoryIds
                    }
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("9fA8j", function(module, exports) {

$parcel$export(module.exports, "HIDE_BULK_CATEGORY_ADDER", () => $ed66b70bc3006a26$export$63cec6f97de61b9a);
$parcel$export(module.exports, "hideBulkCategoryAdder", () => $ed66b70bc3006a26$export$541e941f3628edb2);
const $ed66b70bc3006a26$export$63cec6f97de61b9a = 'state.actions.hide-bulk-category-adder.HIDE_BULK_CATEGORY_ADDER';
const $ed66b70bc3006a26$export$541e941f3628edb2 = (payload)=>({
        payload: payload,
        type: $ed66b70bc3006a26$export$63cec6f97de61b9a
    });

});

parcelRegister("5ZGnB", function(module, exports) {

$parcel$export(module.exports, "SHOW_BULK_CATEGORY_ADDER", () => $27a097cc2a8fd1f3$export$848c1458a48faa31);
$parcel$export(module.exports, "showBulkCategoryAdder", () => $27a097cc2a8fd1f3$export$aea09bcda8ca9577);
const $27a097cc2a8fd1f3$export$848c1458a48faa31 = 'state.actions.show-bulk-category-adder.SHOW_BULK_CATEGORY_ADDER';
const $27a097cc2a8fd1f3$export$aea09bcda8ca9577 = (payload)=>({
        payload: payload,
        type: $27a097cc2a8fd1f3$export$848c1458a48faa31
    });

});

parcelRegister("fQZG5", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER", () => $3b0b6b45936d49fc$export$e08673e3855cdb43);
$parcel$export(module.exports, "updateCategoriesInBulkCategoryAdder", () => $3b0b6b45936d49fc$export$f603b0637b290a5e);
const $3b0b6b45936d49fc$export$e08673e3855cdb43 = 'state.actions.update-categories-in-bulk-category-adder.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER';
const $3b0b6b45936d49fc$export$f603b0637b290a5e = (payload)=>({
        payload: payload,
        type: $3b0b6b45936d49fc$export$e08673e3855cdb43
    });

});





parcelRegister("7FkcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01143916800e31c$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $7gdJb = parcelRequire("7gdJb");

var $bHD2d = parcelRequire("bHD2d");

var $8WLSX = parcelRequire("8WLSX");
var $f01143916800e31c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(()=>({}), {
    onSetKbHub: (0, $bHD2d.setKbHub),
    setCategoriesData: (0, $7gdJb.fetchCategoriesSuccess)
})((0, $8WLSX.default));

});
parcelRegister("8WLSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8de5c2338e3adc79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $8de5c2338e3adc79$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.onSetKbHub();
        this.setCategoriesData();
    }
    componentDidUpdate() {
        this.onSetKbHub();
        this.setCategoriesData();
    }
    onSetKbHub() {
        const { onSetKbHub: onSetKbHub, setCategoriesData: setCategoriesData, children: children, categories: categories, isCategoriesSupported: isCategoriesSupported, ...confluenceLink } = this.props;
        onSetKbHub(confluenceLink);
    }
    setCategoriesData() {
        const { setCategoriesData: setCategoriesData, categories: categories, isCategoriesSupported: isCategoriesSupported } = this.props;
        setCategoriesData({
            categories: // TODO modernisation fix-types
            categories,
            categoriesSupported: isCategoriesSupported
        });
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("6GLlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e4a0c92f65aa33$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $9noxX = parcelRequire("9noxX");

var $e9YVH = parcelRequire("e9YVH");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $cYaqS = parcelRequire("cYaqS");
const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cYaqS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e9YVH.toPackageName)(appName),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, children))));
var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $6BZYo.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $dIdda = parcelRequire("dIdda");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $ktx1d = parcelRequire("ktx1d");

var $ew1Lk = parcelRequire("ew1Lk");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ktx1d.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ktx1d.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: formatMessage((0, $4AdE6.default).genericErrorDescription)
    }));
};

});
parcelRegister("ew1Lk", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $41b549fa18234081$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $6nkVm = parcelRequire("6nkVm");

class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $6nkVm.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $ew1Lk = parcelRequire("ew1Lk");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $ew1Lk.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("6FTcZ", function(module, exports) {

$parcel$export(module.exports, "useKbConfluenceContext", () => $5955acba1bcddf7a$export$a8450b4f39918e6d);

var $5uXOq = parcelRequire("5uXOq");

var $bjZiV = parcelRequire("bjZiV");

var $dIdda = parcelRequire("dIdda");
const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, $bjZiV.kbConfluenceContextResource);
const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $dIdda.useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};
var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;

});

parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eitbt = parcelRequire("eitbt");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
$7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
    Page: (0, $eitbt.default)
};
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eitbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a85de8202c6242d$export$2e2bcd8739ae039);

var $7LZee = parcelRequire("7LZee");

var $4NLf2 = parcelRequire("4NLf2");

var $dUThW = parcelRequire("dUThW");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$3a85de8202c6242d$export$2e2bcd8739ae039 = (0, $7LZee.default);

});
parcelRegister("7LZee", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae8ef6553b34982$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eIqqh = parcelRequire("eIqqh");
function $aae8ef6553b34982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aae8ef6553b34982$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $aae8ef6553b34982$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $aae8ef6553b34982$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $aae8ef6553b34982$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $aae8ef6553b34982$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $aae8ef6553b34982$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $aae8ef6553b34982$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $eIqqh.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $aae8ef6553b34982$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $aae8ef6553b34982$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $aae8ef6553b34982$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $aae8ef6553b34982$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $aae8ef6553b34982$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $aae8ef6553b34982$var$pageContentStyles
    }, children)));
};
var $aae8ef6553b34982$export$2e2bcd8739ae039 = $aae8ef6553b34982$var$Page;

});






//# sourceMappingURL=async-servicedesk-knowledge-hub-view-article.c88d2bf3.js.map
